{
	"assistant": {
		"title": "Βοηθός διαχείρισης",
		"open": "Άνοιγμα βοηθού",
		"close": "Κλείσιμο",
		"restart": "Νέα συνομιλία",
		"send": "Αποστολή",
		"stop": "Διακοπή",
		"empty": "Ρωτήστε για προϊόντα, παραγγελίες ή πελάτες.",
		"placeholder": "Γράψτε ένα μήνυμα…",
		"toolActivity": "Εκτέλεση: {{tool}}…",
		"incomplete": "Η απάντηση διακόπηκε πριν ολοκληρωθεί.",
		"stopped": "Διακόψατε την απάντηση.",
		"errors": {
			"unavailable": "Ο βοηθός δεν είναι διαθέσιμος αυτή τη στιγμή.",
			"unprovisioned": "Ο βοηθός δεν έχει ρυθμιστεί σε αυτό το περιβάλλον — ενημερώστε τον διαχειριστή συστήματος.",
			"rateLimited": "Πολλά αιτήματα — δοκιμάστε ξανά σε λίγο.",
			"forbidden": "Δεν έχετε πρόσβαση στον βοηθό διαχείρισης.",
			"tooLong": "Το μήνυμα ή το ιστορικό είναι πολύ μεγάλο.",
			"network": "Σφάλμα δικτύου — δοκιμάστε ξανά."
		},
		"pendingAction": {
			"title": "Σε αναμονή έγκρισης",
			"body": "Η ενέργεια #{{id}} τέθηκε στην ουρά έγκρισης — ΔΕΝ έχει εκτελεστεί.",
			"approve": "Έγκριση",
			"reject": "Απόρριψη",
			"needsOperator": "Απαιτείται έγκριση από χειριστή με δικαίωμα Συστήματος.",
			"approved": "Εγκρίθηκε και εκτελέστηκε.",
			"rejected": "Απορρίφθηκε — δεν εκτελέστηκε.",
			"conflict": "Διεκπεραιώθηκε ήδη από άλλον χειριστή.",
			"failed": "Η ενέργεια απέτυχε — ελέγξτε την ουρά εκκρεμών ενεργειών."
		}
	},
	"newsletters": {
		"subscriptions": {
			"title": "Newsletter",
			"editTitle": "Επεξεργασία εγγραφής",
			"formSubtitle": "Ενημέρωση της κατάστασης επιβεβαίωσης της εγγραφής.",
			"deleteTitle": "Διαγραφή εγγραφής",
			"deleteBody": "Είστε σίγουροι ότι θέλετε να διαγράψετε την εγγραφή {{email}};",
			"columns": {
				"email": "E-mail",
				"verified": "Επιβεβαίωση",
				"created": "Δημιουργία",
				"updated": "Ενημέρωση"
			}
		}
	},
	"giftcards": {
		"orders": {
			"title": "Δωροκάρτες",
			"columns": {
				"code": "Κωδικός",
				"product": "Προϊόν",
				"buyer": "Αγοραστής",
				"order": "Παραγγελία",
				"amount": "Ποσό",
				"remaining": "Απομένει",
				"payment": "Πληρωμή με",
				"status": "Κατάσταση",
				"purchaseDate": "Ημ/νία αγοράς",
				"expires": "Λήξη"
			},
			"details": {
				"title": "Λεπτομέρειες",
				"senderName": "Όνομα αποστολέα",
				"recipientName": "Όνομα παραλήπτη",
				"recipientEmail": "Email παραλήπτη",
				"message": "Μήνυμα",
				"history": "Ιστορικό",
				"theme": "Θέμα",
				"defaultTheme": "Προεπιλεγμένη εικόνα",
				"sendDate": "Ημ/νία αποστολής",
				"emailStatus": "Email",
				"status": {
					"0": "Δεν έχει προγραμματιστεί",
					"1": "Προγραμματισμένο",
					"2": "Στάλθηκε",
					"3": "Ακυρώθηκε"
				}
			}
		}
	},
	"gf_pending": "Προς πίστωση",
	"gf_credit": "Πιστώθηκαν",
	"gf_refund": "Επιστροφή",
	"gf_consume": "Καταναλώθηκαν",
	"gf_cancel": "Ακυρώθηκε",
	"gf_for_consumption": "Προς κατανάλωση",
	"gf_for_ConsumeCorrection": "Διόρθωση κατανάλωσης",
	"menu": {
		"section": {
			"daily": "Καθημερινά",
			"catalog": "Κατάλογος",
			"marketing": "Marketing & Περιεχόμενο",
			"system": "Σύστημα"
		},
		"dashboard": "Πίνακας Ελέγχου",
		"orders": "Παραγγελίες",
		"ordersList": "Λίστα Παραγγελιών",
		"ordersSkroutz": "Skroutz",
		"ordersCreate": "Νέα Παραγγελία",
		"ordersFiltered": "Φιλτραρισμένες",
		"ordersPaymentMethods": "Τρόποι Πληρωμής",
		"ordersShippingMethods": "Τρόποι Αποστολής",
		"ordersPickupPoints": "Σημεία Παραλαβής",
		"ordersInternalStatuses": "Εσωτερικές Καταστάσεις",
		"customers": "Πελάτες",
		"customersList": "Λίστα Πελατών",
		"customersCategories": "Κατηγορίες Πελατών",
		"customersGroups": "Προφίλ Πελατών",
		"customersTiers": "Βαθμίδες",
		"customersCoupons": "Κουπόνια",
		"customersAccessRules": "Κανόνες Πρόσβασης",
		"customersBranches": "Υποκαταστήματα",
		"reports": "Αναφορές",
		"reportsSales": "Πωλήσεις",
		"reportsBrands": "Κατασκευαστές",
		"reportsCategories": "Κατηγορίες",
		"reportsProducts": "Προϊόντα",
		"reportsCoupons": "Κουπόνια",
		"reportsGeographic": "Γεωγραφική Κατανομή",
		"products": "Προϊόντα",
		"productsList": "Λίστα Προϊόντων",
		"productsCategories": "Κατηγορίες",
		"productsManufacturers": "Κατασκευαστές",
		"productsStatuses": "Καταστάσεις",
		"productsRelations": "Σχετικά Προϊόντα",
		"productsReviews": "Αξιολογήσεις",
		"productsBackInStock": "Ειδοποιήσεις διαθεσιμότητας",
		"productsFilters": "Φίλτρα",
		"productsSeasons": "Σεζόν",
		"productsModels": "Μοντέλα",
		"productsWarehouses": "Αποθήκες",
		"productsWishlistTemplates": "Πρότυπα Wishlist",
		"productsFilterTemplates": "Πρότυπα Φίλτρων",
		"productsThemeTemplates": "Πρότυπα Θεμάτων",
		"attributes": "Χαρακτηριστικά",
		"attributesList": "Λίστα Χαρακτηριστικών",
		"attributesCategories": "Κατηγορίες Χαρακτηριστικών",
		"attributesMap": "Απόδοση σε Κατηγορίες",
		"attributesDimensions": "Διαστάσεις",
		"attributesDimensionGrouping": "Ομαδοποίηση Διαστάσεων",
		"attributesSizeGuides": "Μεγεθολόγιο",
		"prices": "Τιμές",
		"pricesTypes": "Τύποι Τιμών",
		"pricesTaxCategories": "Κατηγορίες ΦΠΑ",
		"pricesTaxRules": "Φορολογικοί Κανόνες",
		"pricesCurrencyRates": "Νομίσματα",
		"contributors": "Συντελεστές",
		"contributorsList": "Λίστα Συντελεστών",
		"contributorsCategories": "Κατηγορίες Συντελεστών",
		"contributorsGroups": "Ομάδες Συντελεστών",
		"promotions": "Εμπορικές Πολιτικές",
		"promotionsList": "Λίστα Πολιτικών",
		"loyalty": "Πόντοι Επιβράβευσης",
		"loyaltyOverview": "Επισκόπηση",
		"loyaltyProducts": "Προϊόντα Πόντων",
		"loyaltyRanges": "Κλίμακες Πόντων",
		"loyaltyCustomers": "Πόντοι Πελατών",
		"loyaltyPerEntity": "Πόντοι ανά Οντότητα",
		"giftcards": "Δωροκάρτες",
		"giftcardsOrders": "Παραγγελίες Δωροκαρτών",
		"newsletters": "Newsletters",
		"newslettersSubscriptions": "Εγγραφές",
		"content": "Περιεχόμενο",
		"contentPages": "Σελίδες",
		"contentBanners": "Banners",
		"contentBannerGroups": "Ομάδες Banner",
		"contentMenus": "Μενού",
		"contentFooter": "Υποσέλιδο",
		"contentFaqs": "Συχνές Ερωτήσεις",
		"contentNews": "Νέα",
		"contentEvents": "Εκδηλώσεις",
		"contentSocialMedia": "Μέσα Κοινωνικής Δικτύωσης",
		"contentLogo": "Logo",
		"contentCustomMessageGroups": "Ομάδες Προσαρμοσμένου Μηνύματος",
		"contentCustomMessages": "Προσαρμοσμένα Μηνύματα",
		"contentCustomContent": "Δυναμικό Περιεχόμενο",
		"contentNewsGroups": "Ομάδα άρθρων",
		"contentVideoGroups": "Ομάδες Video",
		"contentNotificationCategories": "Κατηγορίες Ειδοποιήσεων",
		"contentNotifications": "Ειδοποιήσεις",
		"contentNewsTags": "Tags για Νέα-Ανακοινώσεις",
		"contentEventTags": "Tags εκδηλώσεων",
		"contentContactForms": "Φόρμες Επικοινωνίας",
		"contentPushSubscriptions": "Εγγραφές συσκευών για push messages",
		"contentFileManager": "File Manager",
		"contentNewsCategories": "Κατηγορίες για Νέα-Ανακοινώσεις",
		"contentEventCategories": "Κατηγορίες Εκδηλώσεων",
		"contentEventLocations": "Τοποθεσίες εκδηλώσεων",
		"contentVideoCategories": "Κατηγορίες Video",
		"contentVideos": "Video",
		"specialModules": "Ειδικά Modules",
		"modulesEvents": "Εκδηλώσεις",
		"modulesContests": "Διαγωνισμοί",
		"system": "Σύστημα",
		"systemSettings": "Ρυθμίσεις",
		"systemUsers": "Χρήστες",
		"systemLanguages": "Γλώσσες",
		"systemCountries": "Χώρες",
		"importExport": "Import Export",
		"importExportImport": "Εισαγωγή",
		"importExportExport": "Εξαγωγή",
		"systemSites": "Sites",
		"systemCountryRegions": "Νομοί",
		"systemCities": "Πόλεις",
		"systemPostalCodes": "Ταχ. Κωδικοί",
		"systemTaxOffices": "Εφορίες (ΔΟΥ)",
		"systemEmailTemplates": "E-mail Templates",
		"systemEventSubscriptions": "Event Subscriptions",
		"systemTaskSchedules": "Προγρ/μένες Εργασίες",
		"systemUserRoles": "Ρόλοι Χρηστών",
		"systemApiKeys": "API Keys",
		"systemMcpKeys": "Κλειδιά MCP",
		"systemAiPendingActions": "Ενέργειες AI σε αναμονή",
		"systemActivityLog": "Ιστορικό Ενεργειών",
		"systemRobotsFile": "robots.txt",
		"systemSitemapPages": "Σελίδες Sitemap",
		"systemUrlRedirects": "301 Ανακατευθύνσεις",
		"systemSystemLog": "Αρχείο καταγραφών",
		"systemErpLogs": "Σφάλματα ERP",
		"systemSmsTemplates": "Sms Templates",
		"systemAvailableDates": "Διαθέσιμες Ημερομηνίες",
		"customersRegisterRequests": "Αιτήσεις Εγγραφής",
		"customersSalesPersons": "Πωλητές",
		"customersInspectors": "Επιθεωρητές",
		"bookings": "Κρατήσεις",
		"bookingsList": "Κρατήσεις",
		"bookingsTypes": "Τύποι Κρατήσεων",
		"bookingsRepresentatives": "Εκπρόσωποι",
		"bookingsReports": "Αναφορές",
		"promotionsCoupons": "Κουπόνια",
		"loyaltyTierRules": "Κανόνες επιπέδων",
		"modulesProductTabs": "Product Tabs",
		"productsBuyGuides": "Οδηγοί Αγοράς",
		"productsBundles": "Πακέτα",
		"promotionsDiscountCaps": "Πλαφόν εκπτώσεων",
		"returns": "Επιστροφές",
		"returnsList": "Αιτήματα επιστροφής",
		"returnsSettings": "Ρυθμίσεις επιστροφών"
	},
	"shell": {
		"comingSoon": "Μεταφέρεται σύντομα στο admin-v2",
		"toggleSidebar": "Εναλλαγή πλαϊνής μπάρας",
		"theme": {
			"toLight": "Εναλλαγή σε φωτεινό θέμα",
			"toDark": "Εναλλαγή σε σκούρο θέμα"
		},
		"search": {
			"label": "Αναζήτηση",
			"title": "Αναζήτηση",
			"placeholder": "Αναζήτηση σελίδων μενού...",
			"empty": "Δεν βρέθηκαν σελίδες."
		},
		"site": {
			"open": "Άνοιγμα καταστήματος",
			"copy": "Αντιγραφή URL",
			"copied": "Το URL αντιγράφηκε",
			"copyFailed": "Αποτυχία αντιγραφής"
		},
		"language": {
			"label": "Γλώσσα"
		},
		"notifications": {
			"label": "Ειδοποιήσεις",
			"empty": "Σύντομα διαθέσιμο"
		},
		"user": {
			"profile": "Προφίλ μου",
			"settings": "Ρυθμίσεις λογαριασμού",
			"activity": "Ιστορικό ενεργειών",
			"signOut": "Αποσύνδεση"
		}
	},
	"dashboard": {
		"title": "Πίνακας Ελέγχου",
		"comparison": "σύγκριση με",
		"refresh": "Ανανέωση",
		"export": "Εξαγωγή",
		"live": "Ζωντανά · {{ago}}",
		"range": {
			"today": "Σήμερα",
			"yesterday": "Χθες",
			"7d": "7 ημέρες",
			"30d": "30 ημέρες",
			"90d": "90 ημέρες",
			"ytd": "Φέτος",
			"custom": "Προσαρμοσμένο"
		},
		"chips": {
			"customers": "Πελάτες",
			"productCodes": "Κωδικοί προϊόντων",
			"productsVariants": "Προϊόντα με παραλλαγές"
		},
		"kpi": {
			"orders": "Παραγγελίες",
			"revenue": "Έσοδα",
			"aov": "Μέση Αξία Καλαθιού",
			"newCustomers": "Νέοι Πελάτες",
			"conversion": "Συντελεστής Μετατροπής",
			"vs": "vs",
			"prevPeriod": "προηγ. περίοδο",
			"placeholder": "δείγμα",
			"conversionDisabled": "Μη διαθέσιμο — απαιτείται ρύθμιση του Google Analytics (GA4)",
			"error": "Σφάλμα φόρτωσης"
		},
		"trend": {
			"comparePrev": "σε σύγκριση με την προηγούμενη περίοδο",
			"peak": "Κορύφωση",
			"low": "Ελάχιστο",
			"current": "Τρέχουσα περίοδος",
			"previous": "Προηγούμενη περίοδος",
			"vs": "vs",
			"empty": "Δεν υπάρχουν δεδομένα για αυτό το διάστημα",
			"titles": {
				"revenue": "Έσοδα διαχρονικά",
				"orders": "Παραγγελίες διαχρονικά",
				"aov": "Μέση αξία διαχρονικά",
				"units": "Τεμάχια διαχρονικά"
			},
			"metric": {
				"revenue": "Έσοδα",
				"orders": "Παραγγελίες",
				"aov": "Μέση Αξία",
				"units": "Τεμάχια"
			}
		},
		"donut": {
			"total": "σύνολο"
		},
		"status": {
			"completed": "Ολοκληρωμένες",
			"processing": "Σε επεξεργασία",
			"inDelivery": "Σε αποστολή",
			"pending": "Σε αναμονή",
			"cancelled": "Ακυρωμένες",
			"refunded": "Επιστροφές"
		},
		"statusDonut": {
			"title": "Κατανομή Καταστάσεων",
			"count": "{{count}} παραγγελίες",
			"empty": "Δεν υπάρχουν παραγγελίες"
		},
		"paymentDonut": {
			"title": "Τρόποι Πληρωμής",
			"subtitle": "Ανά πλήθος παραγγελιών",
			"empty": "Δεν υπάρχουν δεδομένα πληρωμών"
		},
		"gauge": {
			"title": "Ποσοστό Ακυρώσεων",
			"subtitle": "Επιλεγμένη περίοδος · στόχος <{{target}}%",
			"healthy": "Υγιές",
			"warning": "Προσοχή",
			"danger": "Υψηλό",
			"belowTarget": "Κάτω από τον στόχο",
			"aboveTarget": "Πάνω από τον στόχο",
			"ratio": "{{cancelled}} ακυρωμένες / {{total}}"
		},
		"category": {
			"title": "Πωλήσεις ανά Κατηγορία",
			"subtitle": "Top 6 ανά έσοδα · {{total}} σύνολο",
			"empty": "Δεν υπάρχουν δεδομένα κατηγοριών"
		},
		"heatmap": {
			"title": "Παραγγελίες ανά ώρα × ημέρα",
			"subtitle": "Πυκνότητα παραγγελιών · Ώρα Ελλάδας",
			"empty": "Δεν υπάρχουν δεδομένα παραγγελιών",
			"peak": "Κορύφωση: {{day}} {{hour}}:00",
			"cell": "{{day}} {{hour}}:00 · {{count}} παραγγελίες",
			"cellNote": "Κάθε κελί = 1 ώρα",
			"less": "Λιγότερες",
			"more": "Περισσότερες",
			"mon": "Δευ",
			"tue": "Τρι",
			"wed": "Τετ",
			"thu": "Πεμ",
			"fri": "Παρ",
			"sat": "Σαβ",
			"sun": "Κυρ"
		},
		"alerts": {
			"pending": "εκκρεμείς παραγγελίες",
			"lowStock": "χαμηλό απόθεμα",
			"erp": "σφάλματα ERP",
			"failedPayments": "αποτυχημένες πληρωμές",
			"refunds": "αιτήματα επιστροφής",
			"oldest": "παλαιότερο {{ago}}",
			"none": "—",
			"belowThreshold": "κάτω από το όριο αποθέματος",
			"lastFailed": "Τελευταίο σφάλμα {{ago}}",
			"last24h": "τελευταίες 24 ώρες",
			"atRisk": "{{amount}} σε κίνδυνο"
		},
		"recentOrders": {
			"title": "Πρόσφατες Παραγγελίες",
			"seeAll": "Δες όλες →",
			"empty": "Καμία πρόσφατη παραγγελία"
		},
		"topProducts": {
			"title": "Top Προϊόντα",
			"period": "τελευταίες 7 ημέρες",
			"sales": "{{count}} πωλήσεις",
			"empty": "Δεν υπάρχουν δεδομένα πωλήσεων"
		},
		"geographic": {
			"title": "Παραγγελίες ανά Περιοχή",
			"seeAll": "Δες πλήρη ανάλυση →",
			"subtitle": "{{total}} παραγγελίες · {{inGreece}} εντός + {{outside}} εκτός Ελλάδας",
			"rankingTitle": "Περιφέρειες ανά παραγγελίες",
			"topRegion": "Κορυφαία περιφέρεια",
			"ofAllOrders": "{{pct}} όλων των παραγγελιών",
			"median": "Διάμεσος",
			"perRegion": "παραγγελίες / περιφέρεια",
			"disclaimer": "Σημείωση: Ο χάρτης είναι στυλιζαρισμένη προσέγγιση των ακτογραμμών.",
			"outsideTitle": "Εκτός Ελλάδας",
			"outsideTotal": "{{count}} παραγγελίες · {{pct}}",
			"cyprus": "Κύπρος",
			"cyprusMeta": "Λευκωσία, Λεμεσός, Λάρνακα +",
			"otherCountries": "Άλλες χώρες",
			"unknown": "Άγνωστη περιοχή",
			"unknownMeta": "Λείπει ή άκυρος ταχ. κώδικας",
			"others": "Άλλες",
			"empty": "Δεν υπάρχουν γεωγραφικά δεδομένα",
			"none": "—",
			"mapAria": "Πυκνότητα παραγγελιών ανά περιφέρεια"
		}
	},
	"reports": {
		"sales": {
			"title": "Αναφορά Παραγγελιών",
			"statusFilter": "Κατάσταση",
			"empty": "Δεν υπάρχουν δεδομένα για αυτό το διάστημα",
			"ordersChart": {
				"title": "Αριθμός Παραγγελιών ανά Ημέρα",
				"byChannel": "Ανά κανάλι",
				"byStatus": "Ανά κατάσταση",
				"total": "{{count}} Παραγγελίες"
			},
			"totals": {
				"title": "Σύνολα ανά Ημέρα",
				"net": "Καθαρό ποσό",
				"tax": "ΦΠΑ",
				"shipping": "Χρέωση αποστολής",
				"payment": "Χρέωση πληρωμής",
				"grandTotal": "{{amount}} Τελικό ποσό"
			},
			"payment": {
				"title": "Τρόποι Πληρωμής",
				"subtitle": "Ανά πλήθος παραγγελιών",
				"empty": "Δεν υπάρχουν δεδομένα πληρωμών"
			},
			"shipping": {
				"title": "Τρόποι Αποστολών",
				"subtitle": "Ανά πλήθος παραγγελιών",
				"empty": "Δεν υπάρχουν δεδομένα αποστολών"
			}
		},
		"brands": {
			"title": "Αναφορά Κατασκευαστών",
			"empty": "Δεν υπάρχουν δεδομένα για αυτό το διάστημα",
			"topQuantity": {
				"title": "Top 10 Κατασκευαστές ανά Ποσότητα",
				"subtitle": "Ανά τεμάχια",
				"empty": "Δεν υπάρχουν δεδομένα"
			},
			"topTurnover": {
				"title": "Top 10 Κατασκευαστές ανά Τζίρο",
				"subtitle": "Ανά τζίρο",
				"empty": "Δεν υπάρχουν δεδομένα"
			}
		},
		"categories": {
			"title": "Αναφορά Κατηγοριών",
			"empty": "Δεν υπάρχουν δεδομένα για αυτό το διάστημα"
		},
		"products": {
			"title": "Αναφορά Προϊόντων",
			"empty": "Δεν υπάρχουν δεδομένα για αυτό το διάστημα"
		},
		"coupons": {
			"title": "Αναφορά Κουπονιών",
			"empty": "Δεν υπάρχουν δεδομένα για αυτό το διάστημα",
			"columns": {
				"redemptions": "Εξαργυρώσεις",
				"redeemedAmount": "Ποσό έκπτωσης",
				"turnover": "Τζίρος"
			}
		},
		"geographic": {
			"title": "Γεωγραφική Κατανομή",
			"empty": "Δεν υπάρχουν γεωγραφικά δεδομένα",
			"breakdownTitle": "Ανάλυση ανά περιοχή",
			"columns": {
				"region": "Περιοχή / Χώρα",
				"orders": "Παραγγελίες",
				"revenue": "Έσοδα"
			}
		},
		"columns": {
			"name": "Όνομα",
			"category": "Κατηγορία",
			"code": "Κωδικός",
			"quantity": "Ποσότητα",
			"turnover": "Τζίρος"
		}
	},
	"common": {
		"save": "Αποθήκευση αλλαγών",
		"saving": "Αποθήκευση…",
		"loading": "Φόρτωση",
		"cancel": "Ακύρωση",
		"close": "Κλείσιμο",
		"delete": "Διαγραφή",
		"duplicate": "Διπλοτυπία",
		"edit": "Επεξεργασία",
		"add": "Προσθήκη",
		"remove": "Αφαίρεση",
		"search": "Αναζήτηση",
		"filters": "Φίλτρα",
		"noResults": "Δεν βρέθηκαν αποτελέσματα",
		"sections": "Ενότητες",
		"previous": "Προηγούμενη",
		"next": "Επόμενη",
		"none": "— Κανένα —",
		"general": "Γενικά",
		"settings": "Ρυθμίσεις",
		"untitled": "Χωρίς τίτλο",
		"retry": "Δοκιμάστε ξανά",
		"yes": "Ναι",
		"no": "Όχι",
		"unknown": "Άγνωστο",
		"refresh": "Ανανέωση",
		"select": "Επιλέξτε…",
		"expand": "Ανάπτυξη",
		"collapse": "Σύμπτυξη",
		"soon": "Σύντομα",
		"upload": "Μεταφόρτωση",
		"replace": "Αντικατάσταση"
	},
	"fileBrowser": {
		"title": "Βιβλιοθήκη αρχείων",
		"selectPrompt": "Περιηγηθείτε και επιλέξτε ένα υπάρχον αρχείο για σύνδεση ή μεταφορτώστε νέο — χωρίς διπλή μεταφόρτωση του ίδιου αρχείου.",
		"root": "Αρχική",
		"insert": "Εισαγωγή",
		"upload": "Μεταφόρτωση",
		"uploading": "Μεταφόρτωση…",
		"empty": "Ο φάκελος είναι κενός.",
		"errorLoad": "Δεν ήταν δυνατή η φόρτωση της βιβλιοθήκης αρχείων.",
		"uploadError": "Δεν ήταν δυνατή η μεταφόρτωση του αρχείου.",
		"uploadRejected": "Μη υποστηριζόμενος τύπος αρχείου. Επιτρέπονται: εικόνες, ZIP, XML, DOC, DOCX, XLS, XLSX, CSV, TXT, PDF."
	},
	"auth": {
		"login": {
			"title": "Σύνδεση",
			"subtitle": "Διαχείριση {{brand}}",
			"username": "Email / Όνομα χρήστη",
			"password": "Κωδικός",
			"submit": "Σύνδεση",
			"error": "Λάθος στοιχεία σύνδεσης"
		}
	},
	"promotion": {
		"surface": {
			"editor": {
				"title": "Επεξεργασία Πολιτικής"
			},
			"grid": {
				"title": "Εμπορικές Πολιτικές",
				"new": "Νέα Πολιτική"
			}
		},
		"crumbs": {
			"offers": "Προσφορές",
			"policies": "Εμπορικές Πολιτικές"
		},
		"status": {
			"active": "Ενεργή",
			"scheduled": "Προγραμματισμένη",
			"expired": "Έληξε",
			"draft": "Πρόχειρη",
			"visible": "Ορατή",
			"hidden": "Κρυφή",
			"inactive": "Ανενεργή"
		},
		"tabs": {
			"all": "Όλες",
			"active": "Ενεργές",
			"scheduled": "Προγραμματισμένες",
			"expired": "Έληξαν",
			"draft": "Πρόχειρες"
		},
		"basicInfo": {
			"tab": "Βασικά Στοιχεία",
			"identity": {
				"title": "Ταυτότητα",
				"subtitle": "Βασικά στοιχεία αναγνώρισης της πολιτικής",
				"name": "Όνομα",
				"nameHelp": "Όνομα της πολιτικής όπως εμφανίζεται στις λίστες της διαχείρισης",
				"code": "Κωδικός",
				"codeHelp": "Μοναδικός κωδικός αναφοράς (συγχρονίζεται με ERP)",
				"priority": "Σειρά",
				"priorityHelp": "Σειρά εφαρμογής όταν πολλές πολιτικές ταιριάζουν. Μικρότεροι αριθμοί εφαρμόζονται πρώτοι."
			},
			"description": {
				"title": "Περιγραφή & Σήμανση",
				"subtitle": "Κείμενα που εμφανίζονται στο κατάστημα και τη διαχείριση",
				"description": "Περιγραφή",
				"badgeText": "Πληροφορίες σήμανσης προϊόντος στη λίστα",
				"badgeTextHelp": "Σύντομο κείμενο που εμφανίζεται πάνω στη σήμανση της λίστας προϊόντων (π.χ. -20%, ΚΑΛΟΚΑΙΡΙ)",
				"frontLabel": "Ετικέτα καταστήματος",
				"frontLabelHelp": "Ετικέτα στα προϊόντα της πολιτικής (αποθηκεύεται για την τρέχουσα γλώσσα).",
				"colorHex": "Χρώμα κειμένου ετικέτας",
				"backgroundColorHex": "Χρώμα φόντου ετικέτας",
				"externalUrl": "Εξωτερικός σύνδεσμος",
				"externalUrlHelp": "Προαιρετικός σύνδεσμος της ετικέτας στο κατάστημα."
			},
			"images": {
				"title": "Εικόνες",
				"subtitle": "Σήμα προϊόντος και φόντο για τη σελίδα προσφοράς",
				"badge": "Εικόνα σήματος",
				"background": "Εικόνα φόντου",
				"backgroundHelp": "Εμφανίζεται ως banner στη σελίδα της προσφοράς. Δεκτές μορφές όπως στις εικόνες προϊόντων."
			},
			"statusVisibility": {
				"title": "Κατάσταση & Ορατότητα",
				"subtitle": "Πότε εφαρμόζεται η πολιτική και αν είναι ορατή στο κατάστημα",
				"active": "Ενεργή",
				"activeHelp": "Η πολιτική είναι ενεργοποιημένη και μπορεί να εφαρμοστεί. Αν είναι ανενεργή, οι Συνθήκες και Ενέργειες αγνοούνται.",
				"visible": "Ορατή στις προσφορές",
				"visibleHelp": "Η πολιτική εμφανίζεται στη σελίδα προσφορών του καταστήματος και στη λίστα ενεργών εκπτώσεων.",
				"hidden": "Απόκρυψη από προσφορές",
				"hiddenHelp": "Η πολιτική εφαρμόζεται κανονικά αλλά δεν εμφανίζεται στη δημόσια λίστα προσφορών (χρήσιμο για κρυφές προσφορές, κωδικούς συνεργατών κ.λπ.)"
			}
		},
		"conditions": {
			"tab": "Συνθήκες",
			"timeWindow": {
				"title": "Χρονικό παράθυρο",
				"subtitle": "Διάστημα μέσα στο οποίο μπορεί να εφαρμοστεί η πολιτική",
				"from": "Ισχύει από",
				"to": "Ισχύει έως",
				"help": "Αφήστε κενά τα πεδία για να ισχύει χωρίς χρονικό όριο.",
				"durationDays": "{{count}} ημέρες",
				"scheduledNote": "Η πολιτική αυτή τη στιγμή είναι προγραμματισμένη — ξεκινά σε {{count}} ημέρες."
			},
			"cartThresholds": {
				"title": "Όρια καλαθιού",
				"subtitle": "Ποσοτικοί κανόνες που πρέπει να ισχύουν για να εφαρμοστεί η πολιτική",
				"minAmount": "Ελάχιστο ποσό",
				"minAmountHelp": "Το καλάθι πρέπει να έχει αξία τουλάχιστον αυτή",
				"maxAmount": "Μέγιστο ποσό",
				"maxAmountHelp": "Άνω όριο. Αφήστε κενό για χωρίς όριο",
				"minQuantity": "Ελάχιστη ποσότητα",
				"minQuantityHelp": "Συνολικός αριθμός τεμαχίων στο καλάθι",
				"selectedOnly": "Εφαρμογή μόνο στα επιλεγμένα προϊόντα",
				"selectedOnlyHelp": "Όταν ενεργό, τα παραπάνω όρια ποσού και ποσότητας υπολογίζονται μόνο για τα προϊόντα που ταιριάζουν στις συνθήκες προϊόντος παρακάτω — όχι για ολόκληρο το καλάθι."
			},
			"productSelection": {
				"title": "Επιλογή προϊόντων",
				"subtitle": "Σε ποια προϊόντα εφαρμόζεται η πολιτική",
				"banner": "Συνδυάστε επιλογές από συγκεκριμένα προϊόντα, κατηγορίες και κατασκευαστές. Αφήστε κενά όλα τα πεδία για να εφαρμοστεί σε όλα τα προϊόντα.",
				"products": "Συγκεκριμένα προϊόντα",
				"productsPlaceholder": "Αναζήτηση προϊόντος ανά όνομα, SKU ή barcode…",
				"productsHelp": "Επιλέξτε συγκεκριμένα προϊόντα — ο διπλανός συνδυαστής ορίζει αν χρειάζεται τουλάχιστον ένα από αυτά στο καλάθι ή όλα.",
				"categories": "Συγκεκριμένες προϊοντικές κατηγορίες",
				"categoriesPlaceholder": "Προσθήκη κατηγορίας…",
				"categoriesHelp": "Προϊόντα οποιασδήποτε από τις επιλεγμένες κατηγορίες (συμπεριλαμβάνονται υποκατηγορίες)",
				"manufacturers": "Συγκεκριμένοι κατασκευαστές",
				"manufacturersPlaceholder": "Προσθήκη κατασκευαστή…",
				"manufacturersHelp": "Προϊόντα οποιουδήποτε από τους επιλεγμένους εκδότες / κατασκευαστές",
				"bulkImport": {
					"trigger": "Μαζική εισαγωγή",
					"title": "Μαζική εισαγωγή προϊόντων",
					"subtitle": "Επικολλήστε ή ανεβάστε μια λίστα κωδικών/barcode προϊόντων για να προστεθούν στην πολιτική. Τα προϊόντα που θα βρεθούν προστίθενται στην παραπάνω επιλογή και αποθηκεύονται με την αποθήκευση της πολιτικής.",
					"pasteLabel": "Επικόλληση κωδικών",
					"pastePlaceholder": "SKU-001\nSKU-002\n5200000000012",
					"pasteHelp": "Ένας κωδικός ή barcode ανά γραμμή (λειτουργούν και τα κόμματα/ερωτηματικά).",
					"fileLabel": "Ή ανεβάστε αρχείο",
					"fileDropHint": "Σύρετε & αφήστε ένα αρχείο εδώ",
					"chooseFile": "Επιλογή αρχείου",
					"allowedExtensions": "Επιτρεπτά: .xlsx, .csv, .txt — οι κωδικοί διαβάζονται από την πρώτη στήλη.",
					"importCta": "Εισαγωγή",
					"summary": "Βρέθηκαν {{matched}} από {{total}} κωδικούς.",
					"invalidFile": "Μη υποστηριζόμενος τύπος αρχείου. Επιτρεπτά: .xlsx, .csv, .txt.",
					"allMatched": "Όλοι οι κωδικοί βρέθηκαν και προστέθηκαν στην επιλογή.",
					"unmatchedTitle": "{{count}} κωδικοί δεν αντιστοιχούν σε προϊόν:"
				}
			},
			"combinators": {
				"inner": {
					"label": "Συγκεκριμένα προϊόντα",
					"any": "Ή (τουλάχιστον ένα στο καλάθι)",
					"all": "ΚΑΙ (όλα στο καλάθι)"
				},
				"outer": {
					"label": "Συνδυασμός Επιλογών",
					"or": "Ή — οποιοδήποτε μπλοκ ταιριάζει",
					"and": "ΚΑΙ — όλα τα μπλοκ ταιριάζουν"
				}
			},
			"customerRestriction": {
				"title": "Περιορισμός σε πελάτες",
				"subtitle": "Σε ποιους πελάτες εφαρμόζεται η πολιτική (αφήστε κενά για να ισχύει για όλους)",
				"categories": "Κατηγορίες πελάτη",
				"categoriesPlaceholder": "Προσθήκη κατηγορίας πελάτη…",
				"categoriesHelp": "Π.χ. VIP, B2B, Εγγεγραμμένοι, Πρώτη αγορά",
				"profiles": "Συγκεκριμένα προφίλ πελατών",
				"profilesPlaceholder": "Αναζήτηση πελάτη ανά όνομα ή email…",
				"profilesHelp": "Συγκεκριμένοι λογαριασμοί πελατών (όχι κατηγορία)"
			},
			"siteScope": {
				"title": "Πεδίο εφαρμογής",
				"subtitle": "Σε ποια sites εφαρμόζεται η πολιτική",
				"sites": "Επιλεγμένα Sites",
				"sitesPlaceholder": "Προσθήκη συγκεκριμένων sites…",
				"sitesLoading": "Φόρτωση sites…",
				"sitesError": "Αποτυχία φόρτωσης sites",
				"sitesHelp": "Αφήστε κενό για να χρησιμοποιηθεί η επιλογή πεδίου παρακάτω",
				"allSites": "Σε όλα τα sites",
				"allSitesHelp": "Η πολιτική εφαρμόζεται σε κάθε site της εγκατάστασης",
				"defaultSite": "Μόνο στο κύριο site",
				"defaultSiteHelp": "Εφαρμογή αποκλειστικά στο default site",
				"ignoredNote": "Έχετε επιλέξει συγκεκριμένα sites — η επιλογή παρακάτω αγνοείται."
			}
		},
		"action": {
			"tab": "Ενέργειες",
			"title": "Ενέργειες πολιτικής",
			"subtitle": "Τι κάνει αυτή η πολιτική όταν εφαρμόζεται. Οι ενέργειες εκτελούνται με τη σειρά που εμφανίζονται.",
			"addAction": "Προσθήκη ενέργειας",
			"count": "{{count}} ενέργειες",
			"combine": "Συνδυασμός",
			"duplicateAction": "Διπλοτυπία ενέργειας",
			"removeAction": "Αφαίρεση ενέργειας",
			"types": {
				"percentageDiscount": "Ποσοστιαία Έκπτωση",
				"valueDiscount": "Αξιακή Έκπτωση",
				"fixedPrice": "Καθορισμένη Τιμή",
				"bogo": "Ποσοστιαία Έκπτωση X+Y",
				"giftProduct": "Δώρο προϊόν",
				"perProductDiscount": "Έκπτωση σε συγκεκριμένα προϊόντα",
				"categoryDiscount": "Έκπτωση σε συγκεκριμένες κατηγορίες",
				"shippingDiscount": "Έκπτωση μεταφορικών"
			},
			"tierMode": {
				"fixed": "Σταθερή",
				"byQuantity": "Κλιμακωτή ανά ποσότητα",
				"byAmount": "Κλιμακωτή ανά ποσό",
				"addTier": "Προσθήκη βαθμίδας",
				"help": {
					"fixed": "Στη σταθερή έκπτωση, μία βαθμίδα ορίζει το όριο καλαθιού και την αξία που αφαιρείται.",
					"byQuantity": "Στην κλιμακωτή ανά ποσότητα, η αξία αλλάζει ανάλογα με τον αριθμό των τεμαχίων στο καλάθι.",
					"byAmount": "Στην κλιμακωτή ανά ποσό, η αξία κλιμακώνεται με βάση την αξία του καλαθιού."
				},
				"sublabel": {
					"fixed": "Σταθερή βαθμίδα",
					"byQuantity": "Βαθμίδες ανά ποσότητα",
					"byAmount": "Βαθμίδες ανά ποσό"
				}
			},
			"applicationMode": {
				"label": "Τρόπος εφαρμογής",
				"once": "Μια φορά",
				"perItem": "Ανά τεμάχιο",
				"help": "Καθορίζει αν η έκπτωση εφαρμόζεται μία φορά στο σύνολο του καλαθιού ή ξεχωριστά για κάθε τεμάχιο."
			},
			"perProduct": {
				"minQty": "Ελάχ.",
				"discount": "Έκπτωση",
				"maxQty": "Μεγ.",
				"maxQtyTooltip": "Πάνω από αυτή την ποσότητα, η πολιτική δεν εφαρμόζεται καθόλου."
			},
			"bogo": {
				"expression": "Για κάθε <0/> τεμάχια στο καλάθι, δώσε <1/> τεμάχιο με <2/>% έκπτωση",
				"sameProductOnly": "Πρέπει να είναι ίδιο προϊόν",
				"sameProductOnlyHelp": "Όταν ενεργό, τα X και Y τεμάχια πρέπει να είναι του ίδιου προϊόντος. Όταν ανενεργό, ταιριάζει οποιοδήποτε προϊόν περνά τις Συνθήκες.",
				"percentageRequired": "Ορίστε ποσοστό έκπτωσης ή δώστε σε κάθε γραμμή δική της έκπτωση.",
				"percentageOptional": "Προαιρετικό: όλες οι γραμμές έχουν δική τους έκπτωση.",
				"reachPricingMode": "Τα προϊόντα που δεν λαμβάνουν έκπτωση χρεώνονται σε",
				"reachPricingModeHelp": "Αφορά τα X τεμάχια κάθε μπλοκ.",
				"reachPricingAfterDiscount": "Τιμή τιμοκαταλόγου",
				"reachPricingBeforeDiscount": "Αρχική τιμή (πριν την έκπτωση τιμοκαταλόγου)",
				"offerTargets": "Προϊόντα που λαμβάνουν την έκπτωση (προαιρετικό)",
				"offerTargetsHelp": "Αν οριστούν προϊόντα ή κατηγορίες, κάθε Χ τεμάχια από τα επιλεγμένα προϊόντα της πολιτικής δίνουν έκπτωση σε έως Υ τεμάχια από αυτά. Αφήστε κενό για την κλασική έκπτωση X+Y. Γραμμή χωρίς δική της έκπτωση παίρνει το παραπάνω ποσοστό. Η μέγ. ποσότητα (μόνο προϊόντα) ορίζει πόσα το πολύ τεμάχια του προϊόντος παίρνουν την έκπτωση (κενό = χωρίς όριο).",
				"offerProducts": "Προϊόντα",
				"offerCategories": "Κατηγορίες",
				"product": "Προϊόν",
				"category": "Κατηγορία",
				"ownDiscount": "Έκπτωση",
				"addOfferProduct": "Προσθήκη προϊόντος",
				"addOfferCategory": "Προσθήκη κατηγορίας"
			},
			"gift": {
				"maxSelections": "Μέγιστες επιλογές",
				"products": "Προϊόντα δώρου",
				"prompt": "Μήνυμα προτροπής για το δώρο",
				"promptHelp": "Εμφανίζεται στο checkout όταν ο πελάτης μπορεί να επιλέξει δώρο."
			},
			"shipping": {
				"method": "Μέθοδος",
				"type": "Τύπος",
				"amount": "Ποσό",
				"addRule": "Προσθήκη κανόνα",
				"stopProcessing": "Σταμάτημα",
				"stopProcessingHelp": "Διακόπτει την επεξεργασία επόμενων κανόνων αυτής της ενέργειας",
				"additive": "Πρόσθεση",
				"additiveHelp": "Προστίθεται στην έκπτωση από προηγούμενους κανόνες",
				"typePercentage": "Ποσοστό",
				"typeFixed": "Σταθερό ποσό",
				"typeFree": "Δωρεάν",
				"rule": "Κανόνας"
			},
			"applyOnDiscounted": {
				"label": "Τρόπος εφαρμογής σε εκπτωτικά προϊόντα",
				"none": "Χωρίς εφαρμογή",
				"max": "Μέγιστη έκπτωση",
				"additive": "Πρόσθετη έκπτωση",
				"onFinal": "Επί της τελικής τιμής",
				"help": "Πώς συμπεριφέρεται όταν το προϊόν έχει έκπτωση από τον τιμοκατάλογο."
			},
			"discountMode": {
				"label": "Τύπος",
				"percentage": "Ποσοστό (%)",
				"amount": "Σταθερό ποσό ανά τεμάχιο (€)"
			},
			"categoryDiscount": {
				"category": "Κατηγορία",
				"maxChoices": "Μέγιστη επιλογή πελάτη",
				"maxChoicesHelp": "Κενό = χωρίς όριο.",
				"add": "Προσθήκη εκπτωτικής κατηγορίας"
			}
		},
		"rail": {
			"status": "Κατάσταση",
			"summary": "Περίληψη Πολιτικής",
			"badgePreview": "Προεπισκόπηση Σήματος",
			"appliesWhen": "Εφαρμόζεται όταν",
			"applies": "Εφαρμόζει",
			"badgePreviewCaption": "Εμφάνιση στη λίστα προϊόντων",
			"validFromTo": "Ισχύει {{from}} – {{to}}",
			"relativeInDays": "σε {{count}} ημέρες",
			"relativeAgoDays": "πριν {{count}} ημέρες",
			"relativeInForce": "σε ισχύ",
			"summaryCartMin": "Καλάθι ≥ €{{amount}}",
			"summaryProducts": "{{count}} συγκεκριμένα προϊόντα",
			"summaryCategories": "{{count}} κατηγορίες προϊόντων",
			"summaryCategoriesNamed": "Κατηγορία: {{names}}",
			"summaryCustomers": "{{count}} κατηγορίες πελατών",
			"summaryCustomersNamed": "Πελάτες: {{names}}",
			"summaryCombines": "Συνδυάζεται με άλλες εκπτώσεις",
			"summaryAllSites": "Όλα τα sites",
			"summaryDefaultSite": "Μόνο στο κύριο site",
			"summarySpecificSites": "{{count}} επιλεγμένα sites",
			"summaryEmpty": "Χωρίς όρους — ισχύει παντού",
			"applyDescPercentTiered": "{{from}}–{{to}}% κλιμακωτή έκπτωση {{mode}}",
			"applyDescPercentFixed": "{{value}}% έκπτωση",
			"applyDescValueTiered": "€{{from}}–{{to}} κλιμακωτή έκπτωση {{mode}}",
			"applyDescValueFixed": "€{{value}} σταθερή έκπτωση",
			"applyDescFixedPriceTiered": "Κλιμακωτή τιμή {{mode}}",
			"applyDescFixedPriceFixed": "Σταθερή τιμή €{{value}}",
			"applyDescBogo": "Αγόρασε {{x}}, πάρε {{y}} με {{z}}% έκπτωση",
			"applyDescByAmount": "ανά ποσό καλαθιού",
			"applyDescByQuantity": "ανά ποσότητα",
			"applyDescGift": "Δώρο προϊόν — {{selections}} επιλογή από {{total}} διαθέσιμα",
			"applyDescPerProduct": "Έκπτωση σε {{count}} προϊόντα",
			"applyDescCategory": "Έκπτωση σε {{count}} κατηγορίες",
			"applyDescShipping": "{{count}} κανόνες έκπτωσης μεταφορικών"
		},
		"grid": {
			"columns": {
				"policy": "Πολιτική",
				"types": "Τύποι",
				"validity": "Ισχύς",
				"status": "Κατάσταση"
			},
			"empty": {
				"title": "Δεν υπάρχουν εμπορικές πολιτικές",
				"subtitle": "Δημιουργήστε την πρώτη σας πολιτική για να ξεκινήσετε."
			},
			"error": {
				"title": "Σφάλμα φόρτωσης πολιτικών",
				"subtitle": "Δεν ήταν δυνατή η φόρτωση των εμπορικών πολιτικών. Ελέγξτε τη σύνδεση και δοκιμάστε ξανά."
			},
			"rowMenu": {
				"edit": "Επεξεργασία",
				"duplicate": "Διπλοτυπία",
				"viewInStore": "Προβολή στο κατάστημα",
				"exportJson": "Εξαγωγή ως JSON",
				"history": "Ιστορικό αλλαγών",
				"delete": "Διαγραφή"
			},
			"pagination": {
				"showing": "Εμφάνιση {{from}}-{{to}} από {{total}}",
				"perPage": "{{count}} / σελίδα"
			},
			"validityInDays": "σε {{count}} ημέρες",
			"validityAgoDays": "πριν {{count}} ημέρες",
			"validityInForce": "Σε ισχύ",
			"validityNoLimit": "Χωρίς χρονικό όριο",
			"typesOverflow": "+{{count}}",
			"filtersComingSoon": "Φίλτρα: σύντομα διαθέσιμα"
		},
		"discountCaps": {
			"title": "Πλαφόν εκπτώσεων",
			"subtitle": "{{count}} πλαφόν — πόσο μπορεί μια έκπτωση να μειώσει την τιμή μονάδας ενός προϊόντος",
			"add": "Νέο πλαφόν",
			"addTitle": "Νέο πλαφόν έκπτωσης",
			"editTitle": "Επεξεργασία πλαφόν έκπτωσης",
			"formSubtitle": "Οι εκπτώσεις σε αυτό το προϊόν (ή διάσταση) δεν κατεβάζουν ποτέ την τιμή μονάδας κάτω από το πλαφόν. Πόντοι, δωροκάρτες, κουπόνια καλαθιού, επιβεβλημένες τιμές και δώρα δεν περιορίζονται.",
			"searchPlaceholder": "Αναζήτηση με κωδικό, όνομα, barcode…",
			"allDimensions": "Όλες οι διαστάσεις",
			"activeFromNow": "Τώρα",
			"deleteTitle": "Διαγραφή πλαφόν έκπτωσης",
			"deleteBody": "Διαγραφή του πλαφόν του {{name}}; Ένα πλαφόν που έχει χρησιμοποιηθεί σε παραγγελίες κλείνει αντί να διαγραφεί.",
			"fields": {
				"product": "Προϊόν",
				"dimension": "Διάσταση",
				"maxDiscountPercentage": "Μέγιστη έκπτωση %",
				"maxDiscountAmount": "Μέγιστο ποσό έκπτωσης",
				"minimumFinalUnitPrice": "Ελάχιστη τελική τιμή μονάδας",
				"basis": "Βάση ποσοστού/ποσού",
				"activeFrom": "Ισχύει από",
				"isActive": "Ενεργό"
			},
			"basis": {
				"0": "Επί της αρχικής τιμής",
				"1": "Επί της τελικής τιμής"
			},
			"validation": {
				"product_required": "Το προϊόν είναι υποχρεωτικό",
				"product_not_found": "Το προϊόν δεν βρέθηκε",
				"dimension_not_found": "Η διάσταση δεν ανήκει στο προϊόν",
				"at_least_one_cap_required": "Ορίστε τουλάχιστον ένα από μέγιστο %, μέγιστο ποσό ή ελάχιστη τελική τιμή",
				"percentage_range": "Το ποσοστό πρέπει να είναι πάνω από 0 και έως 100, με έως 2 δεκαδικά",
				"referenced": "Παραγγελίες άρχισαν να χρησιμοποιούν αυτό το πλαφόν· δοκιμάστε ξανά για να κλείσει",
				"amount_range": "Το ποσό πρέπει να είναι 0 ή μεγαλύτερο, με έως 4 δεκαδικά",
				"minimum_final_unit_price_range": "Η ελάχιστη τελική τιμή πρέπει να είναι 0 ή μεγαλύτερη, με έως 4 δεκαδικά",
				"basis_required": "Η βάση είναι υποχρεωτική",
				"basis_invalid": "Μη έγκυρη βάση",
				"duplicate_open_cap": "Υπάρχει ήδη πλαφόν για αυτό το προϊόν/διάσταση",
				"closed_cap_immutable": "Ένα αντικατεστημένο πλαφόν δεν αλλάζει",
				"load_options_required": "Λείπουν παράμετροι λίστας"
			}
		}
	},
	"productEditor": {
		"railLabel": "Προϊόν",
		"crumbs": {
			"catalog": "Κατάλογος",
			"products": "Προϊόντα",
			"untitled": "(χωρίς όνομα)"
		},
		"head": {
			"code": "Κωδικός",
			"visible": "Ορατό",
			"hidden": "Κρυφό",
			"outOfStock": "Εξαντλημένο",
			"more": "Περισσότερες ενέργειες",
			"menu": {
				"viewInStore": "Προβολή στο κατάστημα",
				"duplicate": "Διπλοτυπία",
				"archive": "Αρχειοθέτηση"
			}
		},
		"tabs": {
			"basic": "Βασικά",
			"categories": "Κατηγορίες",
			"descriptions": "Περιγραφές",
			"images": "Πολυμέσα",
			"files": "Αρχεία",
			"prices": "Τιμές",
			"characteristics": "Χαρακτηριστικά",
			"variants": "Παραλλαγές",
			"relations": "Σχέσεις",
			"states": "Καταστάσεις",
			"awards": "Βραβεία",
			"points": "Πόντοι",
			"garan": "GARAN",
			"faqs": "Συχνές Ερωτήσεις",
			"returnPolicy": "Επιστροφές προϊόντων",
			"bundles": "Πακέτα"
		},
		"files": {
			"slot": "Αρχείο {{n}}",
			"empty": "Κανένα αρχείο",
			"staged": "{{name}} (ανεβαίνει με την αποθήκευση)",
			"upload": "Μεταφόρτωση",
			"replace": "Αντικατάσταση",
			"remove": "Αφαίρεση",
			"undo": "Αναίρεση",
			"supportText": "Έως 5 έγγραφα που εμφανίζονται στη σελίδα του προϊόντος. Τα νέα αρχεία ανεβαίνουν όταν αποθηκεύσετε το προϊόν."
		},
		"tabBody": {
			"saveHint": "Όλες οι αλλαγές αποθηκεύονται με το κουμπί Αποθήκευση",
			"comingSoon": "Αυτή η ενότητα θα ολοκληρωθεί σε επόμενη φάση."
		},
		"rail": {
			"preview": "Προεπισκόπηση",
			"status": "Κατάσταση",
			"storefront": "Κατάστημα",
			"stock": "Απόθεμα",
			"retailPrice": "Τιμή λιανικής",
			"priceValue": "{{value}} €",
			"discount": "Έκπτωση",
			"sync": "Συγχρονισμός",
			"lastErpSync": "Τελευταίος συγχρονισμός ERP",
			"syncStatus": "Κατάσταση"
		},
		"toasts": {
			"saveBeforeSync": "Αποθηκεύστε το προϊόν πριν τον συγχρονισμό ERP.",
			"uploadingImages": "Μεταφόρτωση {{done}} από {{total}} εικόνων…",
			"satelliteSaveFailed": "Η αποθήκευση «{{tab}}» απέτυχε.",
			"savedWithSatelliteFailures": "Αποθηκεύτηκε· απέτυχε: {{tabs}}"
		}
	},
	"products": {
		"erpSync": {
			"synced": "Συγχρονισμένο {{when}}",
			"upToDate": "Ενημερωμένο",
			"pending": "Εκκρεμεί",
			"syncWithErp": "Συγχρονισμός με ERP"
		},
		"prices": {
			"priceLabel": "Ετικέτα τιμής",
			"price": "Τιμή",
			"preDiscount": "Προ έκπτωσης",
			"discountPercent": "Έκπτωση %",
			"default": "Προεπιλογή",
			"vatIncl": "Με ΦΠΑ",
			"vatExcl": "Χωρίς ΦΠΑ"
		},
		"characteristics": {
			"searchPlaceholder": "Αναζήτηση χαρακτηριστικών…",
			"selectPlaceholder": "Επιλέξτε…",
			"searchable": "Με δυνατότητα αναζήτησης",
			"unsupportedHint": "Μη υποστηριζόμενος τύπος — επεξεργασία μέσω ERP",
			"attributeCount": "{{count}} χαρακτηριστικά",
			"emptyTitle": "Δεν έχουν οριστεί χαρακτηριστικά",
			"emptyHelp": "Αυτό το προϊόν δεν έχει σχήμα χαρακτηριστικών στο ERP. Συγχρονίστε με το ERP για να λάβετε την τελευταία διαμόρφωση.",
			"noMatches": "Δεν βρέθηκαν χαρακτηριστικά",
			"flatGroup": "Γενικά χαρακτηριστικά"
		},
		"points": {
			"heroActive": "{{count}} πόντοι ανά αγορά",
			"heroDisabled": "Οι πόντοι είναι απενεργοποιημένοι",
			"heroHelp": "Πρόγραμμα επιβράβευσης {{brand}}: 100 πόντοι = 1,00€ σε πίστωση καταστήματος.",
			"fieldLabel": "Πόντοι ανά αγορά",
			"unit": "πόντοι",
			"disabledHint": "Ορίστε 0 για να απενεργοποιήσετε τους πόντους για αυτό το προϊόν.",
			"tabMeta": "Πόντοι επιβράβευσης ανά αγορά"
		},
		"garan": {
			"tabMeta": "Εμπορική εγγύηση ανθεκτικότητας (Καν. ΕΕ 2025/1960)",
			"banner": "Η ενεργοποίηση του GARAN βεβαιώνει ότι η εγγύηση παρέχεται από τον παραγωγό, χωρίς επιπλέον κόστος, και καλύπτει ολόκληρο το προϊόν. Η πραγματική διάρκεια πρέπει να υπερβαίνει τα 2 έτη για να ισχύει η σήμανση.",
			"overrides": {
				"title": "Υπερισχύσεις προϊόντος",
				"subtitle": "Υπερισχύστε των προεπιλογών του παραγωγού για αυτό το προϊόν. Αφήστε τον διακόπτη στο «Κληρονομικότητα» για να ακολουθεί τον παραγωγό."
			},
			"fields": {
				"enabled": "Διακόπτης GARAN",
				"enabledHelp": "Η κληρονομικότητα χρησιμοποιεί την προεπιλογή του παραγωγού· το Ναι/Όχι την επιβάλλει για αυτό το προϊόν.",
				"years": "Διάρκεια εγγύησης (έτη)",
				"yearsHelp": "Υπερισχύει των ετών του παραγωγού για αυτό το προϊόν· αφήστε το κενό για κληρονομικότητα. Πρέπει να υπερβαίνει τα 2 έτη για να ισχύει.",
				"model": "Αναγνωριστικό μοντέλου",
				"modelHelp": "Το εμπορικό μοντέλο στο οποίο αναφέρεται η εγγύηση. Αν μείνει κενό, χρησιμοποιείται ο κωδικός του προϊόντος."
			},
			"mode": {
				"inherit": "Κληρονομικότητα από παραγωγό",
				"on": "Ναι",
				"off": "Όχι"
			},
			"computed": {
				"title": "Πραγματικές τιμές",
				"subtitle": "Υπολογίζονται από τον διακομιστή μετά την εφαρμογή της κληρονομικότητας — μόνο για ανάγνωση.",
				"eligible": "Επιλέξιμο για σήμανση GARAN",
				"notEligible": "Μη επιλέξιμο",
				"effectiveYears": "Πραγματική διάρκεια",
				"effectiveProducer": "Παραγωγός",
				"effectiveModel": "Πραγματικό μοντέλο",
				"yearsValue": "{{count}} έτη",
				"inheritNote": "Αυτό το προϊόν κληρονομεί την προεπιλογή GARAN του παραγωγού."
			}
		},
		"categories": {
			"filterPlaceholder": "Φιλτράρισμα κατηγοριών…",
			"expandAll": "Ανάπτυξη όλων",
			"collapseAll": "Σύμπτυξη όλων",
			"showOnlySelected": "Μόνο επιλεγμένες",
			"categoryName": "Όνομα κατηγορίας",
			"main": "Κύρια",
			"mainBadge": "Κύρια",
			"subcategories": "{{count}} υποκατηγορίες",
			"setMain": "Ορισμός ως κύρια: {{name}}",
			"expand": "Ανάπτυξη",
			"collapse": "Σύμπτυξη",
			"noMatches": "Δεν βρέθηκαν κατηγορίες"
		},
		"images": {
			"main": "Κύρια",
			"replace": "Αντικατάσταση",
			"preview": "Προεπισκόπηση",
			"remove": "Αφαίρεση",
			"dragToReorder": "Σύρετε για αναδιάταξη",
			"uploading": "Μεταφόρτωση…",
			"addSlot": "Προσθήκη",
			"dropTitle": "Σύρετε εικόνες εδώ για μεταφόρτωση",
			"dropHelp": "ή κάντε κλικ για επιλογή · JPG, PNG, WebP έως {{maxSize}}MB",
			"usage": "{{used}} μεταφορτωμένες · {{available}} διαθέσιμες θέσεις · μέγιστο {{max}}"
		},
		"quickEdit": {
			"title": "Γρήγορη επεξεργασία",
			"openFull": "Άνοιγμα πλήρους προϊόντος",
			"visibilitySection": "Ορατότητα στο κατάστημα",
			"visibleTitle": "Ορατό στο κατάστημα",
			"visibleHelp": "Όταν είναι ανενεργό, το προϊόν κρύβεται από λίστες και αναζήτηση.",
			"availabilitySection": "Κατάσταση διαθεσιμότητας",
			"availabilityPlaceholder": "Επιλέξτε διαθεσιμότητα",
			"availabilityHelp": "Καθορίζει το σήμα αποθέματος που εμφανίζεται στο κατάστημα.",
			"feedsSection": "Social/Shopping feeds",
			"socialFeeds": "Social/Shopping feeds",
			"flagsSection": "Σημαίες προϊόντος",
			"featured": "Προβεβλημένο",
			"used": "Μεταχειρισμένο",
			"newRelease": "Νέα κυκλοφορία",
			"onSale": "Σε προσφορά",
			"limited": "Περιορισμένη έκδοση",
			"bestseller": "Bestseller",
			"unsaved": "{{count}} μη αποθηκευμένες αλλαγές"
		},
		"descriptions": {
			"designView": "Design",
			"htmlView": "HTML",
			"htmlModeNote": "Επεξεργασία ακατέργαστου HTML — διατηρείται ως έχει κατά την αποθήκευση.",
			"undo": "Αναίρεση",
			"redo": "Επανάληψη",
			"bold": "Έντονα",
			"italic": "Πλάγια",
			"strike": "Διαγραμμένα",
			"underline": "Υπογράμμιση",
			"textColor": "Χρώμα κειμένου",
			"clearColor": "Καθαρισμός χρώματος",
			"highlight": "Επισήμανση",
			"clearHighlight": "Καθαρισμός επισήμανσης",
			"alignLeft": "Στοίχιση αριστερά",
			"alignCenter": "Στοίχιση στο κέντρο",
			"alignRight": "Στοίχιση δεξιά",
			"justify": "Πλήρης στοίχιση",
			"bulletList": "Λίστα με κουκκίδες",
			"orderedList": "Αριθμημένη λίστα",
			"blockquote": "Παράθεση",
			"link": "Εισαγωγή συνδέσμου",
			"linkPrompt": "Διεύθυνση URL συνδέσμου",
			"image": "Μεταφόρτωση εικόνας",
			"browseLibrary": "Εισαγωγή από τη βιβλιοθήκη αρχείων",
			"clearFormat": "Καθαρισμός μορφοποίησης",
			"words": "Λέξεις",
			"characters": "Χαρακτήρες",
			"lines": "Γραμμές",
			"htmlPreserved": "Το HTML διατηρείται ως έχει κατά την αποθήκευση"
		},
		"basic": {
			"identification": {
				"title": "Ταυτοποίηση",
				"subtitle": "Απαιτείται: Κωδικός"
			},
			"naming": {
				"title": "Ονομασία & εμφάνιση"
			},
			"inventory": {
				"title": "Απόθεμα & παραγγελία",
				"subtitle": "Απαιτείται: Διαθεσιμότητα, Τύπος προϊόντος"
			},
			"flags": {
				"title": "Ορατότητα & σημαίες",
				"subtitle": "Εμφάνιση στο κατάστημα και ροές δεδομένων (feeds)"
			},
			"dimensions": {
				"title": "Διαστάσεις & κατασκευαστής"
			},
			"seo": {
				"title": "SEO",
				"subtitle": "Χρησιμοποιείται από μηχανές αναζήτησης και meta tags του καταστήματος"
			},
			"fields": {
				"code": "Κωδικός (SKU)",
				"barcode": "Barcode",
				"erpCode": "Κωδικός ERP",
				"groupCode": "Κωδικός ομάδας",
				"seoUrl": "SEO URL",
				"name": "Όνομα",
				"subtitle": "Υπότιτλος",
				"headerTitle": "Τίτλος κεφαλίδας",
				"headerTitleHelp": "Προαιρετικό — αντικαθιστά το Όνομα στην κεφαλίδα του καταστήματος.",
				"availability": "Διαθεσιμότητα",
				"availabilityPlaceholder": "Επιλέξτε διαθεσιμότητα…",
				"productType": "Τύπος προϊόντος",
				"productTypePlaceholder": "Επιλέξτε τύπο…",
				"subType": "Υπο-τύπος",
				"subTypePlaceholder": "Επιλέξτε υπο-τύπο…",
				"quantity": "Ποσότητα",
				"baseMU": "Βασική ΜΜ",
				"weightMU": "ΜΜ βάρους",
				"orderMinQty": "Ελάχιστη ποσότητα παραγγελίας",
				"orderMaxQty": "Μέγιστη ποσότητα παραγγελίας",
				"orderStepQty": "Βηματική ποσότητα παραγγελίας",
				"releaseDate": "Ημερομηνία κυκλοφορίας",
				"displayOrder": "Σειρά εμφάνισης",
				"pieces": "Τεμάχια",
				"size": "Μέγεθος",
				"weight": "Βάρος",
				"width": "Πλάτος",
				"length": "Μήκος",
				"height": "Ύψος",
				"manufacturer": "Κατασκευαστής",
				"manufacturerPlaceholder": "Επιλέξτε…",
				"metaTitle": "Meta title",
				"metaTitleHelp": "Αν είναι κενό, χρησιμοποιείται το Όνομα του προϊόντος.",
				"metaDescription": "Meta description",
				"metaKeywords": "Meta keywords",
				"canonicalUrl": "Canonical URL",
				"indexing": "Ευρετηρίαση"
			},
			"productTypes": {
				"Product": "Προϊόν",
				"GiftCard": "Δωροκάρτα",
				"Grouped": "Ομαδοποιημένο",
				"Bundle": "Πακέτο",
				"Giftbox": "Κουτί δώρου",
				"Custom": "Προσαρμοσμένο"
			},
			"flagLabels": {
				"isVisible": "Ορατό",
				"disableShoppingCart": "Απενεργοποίηση καλαθιού",
				"allowOutOfStockOrdering": "Παραγγελία εκτός αποθέματος",
				"hasDimensionPages": "Σελίδες παραλλαγών",
				"isUsed": "Μεταχειρισμένο",
				"isFeatured": "Προβεβλημένο",
				"showSkroutz": "Skroutz",
				"showBestPrice": "BestPrice",
				"showYou": "You.gr",
				"showJeanious": "Jeanious",
				"showLinkwise": "Linkwise",
				"frontExclusion": "Εξαίρεση από προβολές",
				"showSocial": "Social/Shopping feeds",
				"disableIndexation": "Απενεργοποίηση ευρετηρίασης",
				"disableFollow": "Απενεργοποίηση follow"
			},
			"flagHelp": {
				"isVisible": "Εμφάνιση στο κατάστημα.",
				"disableShoppingCart": "Μόνο περιήγηση· δεν μπορεί να αγοραστεί.",
				"allowOutOfStockOrdering": "Μπορεί να προστεθεί στο καλάθι και να αγοραστεί ακόμη και με μηδενικό απόθεμα.",
				"hasDimensionPages": "Κάθε παραλλαγή αποκτά δική της σελίδα, URL και SEO.",
				"showSkroutz": "Συμπερίληψη στη ροή Skroutz.",
				"frontExclusion": "Απόκρυψη από τις σελίδες προβολής του καταστήματος.",
				"showSocial": "Συμπερίληψη σε Google Shopping και Facebook Catalog."
			}
		},
		"categoriesTab": {
			"pickHint": "Επιλέξτε τουλάχιστον μία κατηγορία για το προϊόν",
			"allTitle": "Όλες οι κατηγορίες",
			"selectedSummary": "{{count}} επιλεγμένες",
			"loadError": "Αποτυχία φόρτωσης του δέντρου κατηγοριών."
		},
		"descriptionsTab": {
			"saveHint": "Και τα δύο πεδία αποθηκεύονται με την Αποθήκευση της σελίδας",
			"erpBanner": "Επεξεργάζεστε περιεχόμενο συγχρονισμένο από ERP; Η προβολή Design διατηρεί τη συνήθη μορφοποίηση αλλά μπορεί να κανονικοποιήσει ειδικές περιπτώσεις inline στυλ. Για επεξεργασία ακατέργαστου HTML, χρησιμοποιήστε την προβολή HTML.",
			"shortTitle": "Μικρή περιγραφή",
			"shortSubtitle": "Εμφανίζεται στις κάρτες προϊόντων και ως εναλλακτική meta description",
			"shortPlaceholder": "Σύντομη περιγραφή…",
			"longTitle": "Μεγάλη περιγραφή",
			"longSubtitle": "Πλήρες περιεχόμενο σελίδας προϊόντος, κάτω από τις εικόνες",
			"longPlaceholder": "Αναλυτική περιγραφή προϊόντος…"
		},
		"pricesTab": {
			"meta": "Σχήμα από συγχρονισμό ERP · {{count}} γραμμές τιμών",
			"banner": "Διαμόρφωση από σχήμα. Οι ετικέτες τιμών και η συμπερίληψη ΦΠΑ προέρχονται από το σχήμα ERP. Το κατάστημα χρησιμοποιεί τη γραμμή που έχει σημανθεί ως Προεπιλογή.",
			"sectionTitle": "Τιμολόγηση",
			"vatCategory": "Κατηγορία ΦΠΑ",
			"vatCategoryPlaceholder": "Επιλέξτε κατηγορία ΦΠΑ",
			"discountEnabled": "Ενεργή έκπτωση",
			"empty": "Δεν έχουν διαμορφωθεί γραμμές τιμών για αυτό το προϊόν."
		},
		"characteristicsTab": {
			"meta": "{{count}} χαρακτηριστικά σε {{groups}} ομάδες · Σχήμα από ERP",
			"banner": "Διαμόρφωση από σχήμα. Τα χαρακτηριστικά ομαδοποιούνται κατά όνομα κατηγορίας. Όταν δεν έχει οριστεί κατηγορία, εμφανίζονται σε μία ενιαία λίστα."
		},
		"imagesTab": {
			"meta": "{{used}} από {{max}} θέσεις σε χρήση",
			"supportText": "Η θέση 1 είναι η κύρια εικόνα (εξώφυλλο κάρτας και πρώτη εικόνα στη σελίδα). Οι θέσεις 2–15 εμφανίζονται με τη σειρά τους — σύρετε για αναδιάταξη. JPG, PNG ή WebP έως 5MB ανά αρχείο. Οι αλλαγές μεταφορτώνονται κατά την αποθήκευση."
		},
		"faqs": {
			"listTitle": "Συχνές ερωτήσεις προϊόντος",
			"listHint": "Σύρετε για αναδιάταξη · Κάντε κλικ σε μια ερώτηση για επεξεργασία",
			"empty": "Δεν έχουν διαμορφωθεί ερωτήσεις. Προσθέστε την πρώτη.",
			"add": "Προσθήκη ερώτησης",
			"question": "Ερώτηση",
			"questionPlaceholder": "π.χ. Είναι κατάλληλο για μαθητές Γ' Λυκείου;",
			"answer": "Απάντηση",
			"answerPlaceholder": "Γράψτε την απάντηση…",
			"editing": "Επεξεργασία ερώτησης #{{index}}",
			"untitled": "(χωρίς ερώτηση)",
			"expand": "Ανάπτυξη",
			"collapse": "Σύμπτυξη",
			"dragToReorder": "Σύρετε για αναδιάταξη",
			"mediaDisabledNote": "Οι εικόνες και τα συνημμένα είναι απενεργοποιημένα στις απαντήσεις FAQ.",
			"tabMeta": "{{count}} ερωτήσεις",
			"tabBanner": "Οι ερωτήσεις εμφανίζονται στη σελίδα του προϊόντος στη βιτρίνα.",
			"loadError": "Αποτυχία φόρτωσης ερωτήσεων."
		},
		"awards": {
			"listTitle": "Όλες οι βραβεύσεις",
			"add": "Προσθήκη βράβευσης",
			"empty": "Δεν υπάρχουν βραβεύσεις ακόμη.",
			"addTitle": "Προσθήκη βράβευσης",
			"editTitle": "Επεξεργασία βράβευσης",
			"dialogSubtitle": "Όνομα, τοποθεσία, ημερομηνία, περιγραφή και έως 2 εικόνες.",
			"name": "Όνομα βράβευσης",
			"namePlaceholder": "π.χ. Βραβείο Σχολικού Βιβλίου",
			"location": "Τοποθεσία",
			"locationPlaceholder": "Φορέας απονομής, πόλη ή χώρα",
			"date": "Ημερομηνία βράβευσης",
			"description": "Περιγραφή",
			"descriptionNote": "Οι εικόνες μπαίνουν στα παρακάτω πεδία, όχι μέσα στο κείμενο.",
			"image1": "Εικόνα 1 (κύρια)",
			"image1Hint": "Κύριο σήμα — εμφανίζεται στη συλλογή βραβεύσεων.",
			"image2": "Εικόνα 2 (προαιρετική)",
			"save": "Αποθήκευση βράβευσης",
			"untitled": "(χωρίς όνομα)",
			"imagesCount": "{{count}} εικόνες",
			"dragToReorder": "Σύρετε για αναδιάταξη",
			"tabMeta": "{{count}} βραβεία",
			"requiresSystemRole": "Η επεξεργασία βραβείων απαιτεί ρόλο System. Προβολή μόνο.",
			"loadError": "Αποτυχία φόρτωσης βραβείων."
		},
		"variants": {
			"listTitle": "Όλες οι παραλλαγές ({{count}})",
			"add": "Προσθήκη παραλλαγής",
			"generate": "Δημιουργία συνδυασμών",
			"empty": "Δεν υπάρχουν παραλλαγές ακόμη.",
			"colImage": "Εικόνα",
			"colVariant": "Παραλλαγή",
			"colSku": "SKU",
			"colBarcode": "Barcode",
			"colPrice": "Τιμή",
			"colStock": "Απόθεμα",
			"colVisible": "Ορατό",
			"visible": "Ορατό",
			"hidden": "Κρυφό",
			"hide": "Απόκρυψη",
			"show": "Εμφάνιση",
			"addTitle": "Προσθήκη παραλλαγής",
			"addSubtitle": "Νέο υπο-SKU κάτω από {{parentSku}}",
			"dimensionFallback": "Διάσταση",
			"dimensionPlaceholder": "π.χ. 2025",
			"dimensionHint": "Διαμορφωμένη διάσταση για αυτό το προϊόν. Απαιτείται.",
			"dimensionValuesHint": "Επιλέξτε τιμή για τουλάχιστον μία διάσταση.",
			"sku": "SKU",
			"skuHint": "Δημιουργείται αυτόματα από το γονικό SKU + τιμή διάστασης. Επεξεργαστείτε για παράκαμψη.",
			"barcode": "Barcode",
			"price": "Τιμή",
			"preDiscount": "Προ έκπτωσης",
			"stock": "Απόθεμα",
			"visibleOnStorefront": "Ορατό στο κατάστημα",
			"generateTitle": "Δημιουργία συνδυασμών παραλλαγών",
			"generateSubtitle": "Μαζική δημιουργία παραλλαγών από επιλεγμένες τιμές διαστάσεων",
			"selectedCount": "({{count}} επιλεγμένες)",
			"generatePreview": "{{count}} νέες παραλλαγές θα δημιουργηθούν. Κάθε μία αποκτά μοναδικό αυτόματο SKU.",
			"defaultsLabel": "Προεπιλογές για νέες παραλλαγές",
			"defaultPrice": "Προεπιλεγμένη τιμή",
			"defaultStock": "Προεπιλεγμένο απόθεμα",
			"defaultsNote": "Όλες οι νέες παραλλαγές κληρονομούν αυτές τις προεπιλογές. Μπορείτε να τις επεξεργαστείτε μετά.",
			"generateAction": "Δημιουργία {{count}} παραλλαγών",
			"tabMeta": "{{count}} παραλλαγές",
			"loadError": "Αποτυχία φόρτωσης παραλλαγών.",
			"editTitle": "Επεξεργασία παραλλαγής",
			"disableCart": "Απενεργοποίηση καλαθιού",
			"frontExclusion": "Απόκρυψη από το κατάστημα",
			"releaseDate": "Ημερομηνία κυκλοφορίας",
			"cartDisabledBadge": "Χωρίς καλάθι",
			"frontExcludedBadge": "Κρυφή στο κατάστημα",
			"pageAction": "Σελίδα",
			"pageTitle": "Σελίδα παραλλαγής",
			"pageSubtitle": "Σελίδα, URL και SEO της {{label}} (στην τρέχουσα γλώσσα)",
			"pageInheritHint": "Τα κενά πεδία κληρονομούν τις τιμές του προϊόντος στο κατάστημα. Κενό slug δημιουργείται από το όνομα.",
			"pageFlagOffNote": "Χρησιμοποιείται μόνο όταν είναι ενεργό το «Σελίδες παραλλαγών» στην καρτέλα Βασικά του προϊόντος.",
			"pageName": "Όνομα",
			"pageSlug": "Slug",
			"pageSlugHelp": "Εξυπηρετείται στο /products/{slug}.",
			"pageSeoTitle": "SEO",
			"pageMetaTitle": "Meta τίτλος",
			"pageMetaDescription": "Meta περιγραφή",
			"pageMetaKeywords": "Meta λέξεις-κλειδιά",
			"pageShortDescription": "Σύντομη περιγραφή",
			"pageLongDescription": "Αναλυτική περιγραφή",
			"pageLoadError": "Αποτυχία φόρτωσης της σελίδας παραλλαγής.",
			"pageSaved": "Η σελίδα παραλλαγής αποθηκεύτηκε.",
			"pageSaveError": "Αποτυχία αποθήκευσης της σελίδας παραλλαγής."
		},
		"surface": {
			"title": "Προϊόντα"
		},
		"actions": {
			"excelExport": "Εξαγωγή Excel",
			"excelExportStubHint": "Σύντομα διαθέσιμο — απαιτείται endpoint εξαγωγής στον server",
			"newProduct": "Νέο προϊόν"
		},
		"filters": {
			"title": "Φίλτρα προϊόντων",
			"subtitle": "Περιορίστε τα αποτελέσματα του πίνακα.",
			"barcodePlaceholder": "Αναζήτηση με barcode…",
			"categoriesPlaceholder": "Επιλέξτε κατηγορίες…",
			"statuses": "Καταστάσεις",
			"statusesPlaceholder": "Επιλέξτε καταστάσεις…",
			"subTypes": "Υπο-τύποι",
			"subTypesPlaceholder": "Επιλέξτε υπο-τύπους…",
			"availability": "Διαθεσιμότητα",
			"availabilityPlaceholder": "Επιλέξτε διαθεσιμότητα…",
			"priceRange": "Εύρος τιμής λιανικής",
			"discountRange": "Εύρος έκπτωσης (%)",
			"quantityRange": "Εύρος αποθέματος",
			"releaseDateRange": "Ημερομηνία κυκλοφορίας",
			"from": "Από",
			"to": "Έως",
			"triAny": "Όλα",
			"apply": "Εφαρμογή",
			"clear": "Καθαρισμός"
		},
		"columns": {
			"title": "Εμφανιζόμενες στήλες",
			"reset": "Επαναφορά στηλών"
		},
		"massEdit": {
			"title": "Μαζική επεξεργασία",
			"subtitle": "Εφαρμογή αλλαγών σε {{count}} επιλεγμένα προϊόντα.",
			"keep": "Καμία αλλαγή",
			"apply": "Εφαρμογή σε {{count}}",
			"success": "Ενημερώθηκαν {{count}} προϊόντα"
		},
		"chips": {
			"label": "Αποθηκευμένα φίλτρα",
			"outOfStock": "Εξαντλημένα",
			"hidden": "Κρυφά προϊόντα",
			"newReleases": "Νέες κυκλοφορίες",
			"featured": "Προβεβλημένα",
			"noImage": "Χωρίς εικόνα",
			"saveCurrent": "Αποθήκευση τρέχοντος",
			"saveCurrentHint": "Σύντομα διαθέσιμο"
		},
		"toolbar": {
			"searchPlaceholder": "Αναζήτηση με όνομα, SKU ή barcode…",
			"columns": "Στήλες",
			"columnsHint": "Σύντομα διαθέσιμο",
			"massEdit": "Μαζική επεξεργασία",
			"massErpSync": "Μαζικός συγχρονισμός ERP"
		},
		"selection": {
			"count": "{{count}} προϊόντα επιλεγμένα",
			"onPage": "στη σελίδα {{page}}",
			"hint": "Χρησιμοποιήστε τη Μαζική επεξεργασία ή τον Μαζικό συγχρονισμό ERP παραπάνω.",
			"clear": "Καθαρισμός επιλογής"
		},
		"gridBar": {
			"showing": "Εμφάνιση",
			"of": "από",
			"comfortable": "Άνετο",
			"compact": "Συμπαγές"
		},
		"grid": {
			"selectAll": "Επιλογή όλων",
			"selectRow": "Επιλογή {{name}}",
			"categoryMore": "+{{count}}",
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"sku": "SKU",
				"barcode": "Barcode",
				"category": "Κατηγορία",
				"stock": "Απόθεμα",
				"preDiscount": "Προ έκπτωσης",
				"discount": "Έκπτωση",
				"retail": "Τιμή λιανικής",
				"visible": "Ορατό",
				"id": "ID",
				"subTitle": "Υπότιτλος",
				"baseName": "Βασικό όνομα",
				"altCode": "Εναλλ. κωδικός",
				"groupCode": "Κωδικός ομάδας",
				"erpCode": "Κωδικός ERP",
				"manufacturer": "Κατασκευαστής",
				"subType": "Υποτύπος",
				"productType": "Τύπος προϊόντος",
				"availability": "Διαθεσιμότητα",
				"featured": "Προβεβλημένο",
				"hasDiscount": "Έχει έκπτωση",
				"releaseDate": "Ημ/νία κυκλοφορίας",
				"sortIndex": "Σειρά"
			},
			"rowMenu": {
				"label": "Ενέργειες",
				"open": "Άνοιγμα προϊόντος",
				"quickEdit": "Γρήγορη επεξεργασία",
				"warehouses": "Προβολή αποθηκών",
				"related": "Σχετικά προϊόντα",
				"sync": "Συγχρονισμός με ERP",
				"duplicate": "Αντιγραφή",
				"delete": "Διαγραφή"
			}
		},
		"pager": {
			"rowsPerPage": "Σειρές ανά σελίδα:",
			"first": "Πρώτη",
			"prev": "Προηγούμενη",
			"next": "Επόμενη",
			"last": "Τελευταία",
			"page": "Σελίδα {{page}}"
		},
		"empty": {
			"title": "Δεν υπάρχουν προϊόντα",
			"subtitle": "Δεν βρέθηκαν προϊόντα.",
			"filteredTitle": "Κανένα αποτέλεσμα",
			"filteredSubtitle": "Κανένα προϊόν δεν ταιριάζει στα φίλτρα.",
			"clearFilters": "Καθαρισμός φίλτρων"
		},
		"error": {
			"title": "Κάτι πήγε στραβά",
			"subtitle": "Δεν ήταν δυνατή η φόρτωση των προϊόντων."
		},
		"type": {
			"book": "Βιβλίο",
			"toy": "Παιχνίδι"
		},
		"availability": {
			"0": "Διαθέσιμο (αποθήκη)",
			"1": "Διαθέσιμο",
			"2": "Περιορισμένο",
			"3": "Εξαντλημένο",
			"4": "Προπαραγγελία",
			"5": "Κατόπιν παραγγελίας"
		},
		"deleteDialog": {
			"title": "Διαγραφή προϊόντος",
			"body": "Σίγουρα θέλετε να διαγράψετε το «{{name}}»;",
			"confirm": "Διαγραφή"
		},
		"toasts": {
			"deleted": "Το προϊόν διαγράφηκε",
			"duplicated": "Το προϊόν αντιγράφηκε",
			"quickEditSaved": "Οι αλλαγές αποθηκεύτηκαν",
			"actionFailed": "Η ενέργεια απέτυχε",
			"erpSyncDone": "Ο συγχρονισμός ERP ολοκληρώθηκε",
			"comingSoon": "Σύντομα διαθέσιμο"
		},
		"states": {
			"meta": "{{active}} από {{total}} ενεργές",
			"banner": "Οι καταστάσεις εμφανίζονται ως ετικέτες στη βιτρίνα (ΝΕΟ, BEST SELLER κ.λπ.). Ενεργοποιήστε όσες ισχύουν για αυτό το προϊόν.",
			"empty": "Δεν υπάρχουν διαθέσιμες καταστάσεις.",
			"loadError": "Αποτυχία φόρτωσης καταστάσεων."
		},
		"relations": {
			"tabMeta": "{{count}} συσχετίσεις",
			"productCount": "{{count}} προϊόντα",
			"banner": "Οι συσχετίσεις συνδέουν αυτό το προϊόν με άλλα για cross-sell και συμπληρωματικές προτάσεις στη βιτρίνα.",
			"searchPlaceholder": "Αναζήτηση προϊόντος με όνομα ή κωδικό…",
			"searchEmpty": "Δεν βρέθηκαν προϊόντα.",
			"noTypes": "Δεν έχουν οριστεί τύποι συσχέτισης.",
			"loadError": "Αποτυχία φόρτωσης συσχετίσεων."
		}
	},
	"orders": {
		"surface": {
			"title": "Λίστα Παραγγελιών"
		},
		"actions": {
			"export": "Εξαγωγή",
			"exportStubHint": "Σύντομα διαθέσιμο — απαιτείται endpoint εξαγωγής στον server",
			"newOrder": "Νέα Παραγγελία"
		},
		"chips": {
			"label": "Αποθηκευμένα",
			"todaysPending": "Σημερινές εκκρεμείς",
			"boxNow": "BOX NOW",
			"failedPayment": "Αποτυχία πληρωμής",
			"couriered": "Σε αποστολή",
			"invoiceOrders": "Με τιμολόγιο",
			"saveCurrent": "Αποθήκευση τρέχοντος",
			"saveCurrentHint": "Σύντομα διαθέσιμο"
		},
		"toolbar": {
			"searchPlaceholder": "Αναζήτηση με email, τηλέφωνο, UID ή κωδικό παραγγελίας…",
			"columns": "Στήλες"
		},
		"gridBar": {
			"showing": "Εμφάνιση",
			"of": "από",
			"density": "Πυκνότητα",
			"comfortable": "Άνετο",
			"compact": "Συμπαγές"
		},
		"grid": {
			"purchasedAt": "Καταχωρήθηκε {{when}}",
			"unknownPayment": "Άγνωστος τρόπος",
			"guestYes": "Επισκέπτης",
			"guestNo": "Εγγεγραμμένος",
			"columns": {
				"order": "Παραγγελία",
				"date": "Ημερομηνία",
				"customer": "Πελάτης",
				"payment": "Πληρωμή",
				"shipping": "Αποστολή",
				"document": "Παραστατικό",
				"quantity": "Τεμ.",
				"id": "ID",
				"erpCode": "Κωδικός ERP",
				"methodOfPurchase": "Μέθοδος",
				"deliveryDate": "Ημ/νία παράδοσης",
				"guest": "Επισκέπτης",
				"transactionId": "ID συναλλαγής",
				"total": "Σύνολο",
				"status": "Κατάσταση"
			},
			"rowMenu": {
				"label": "Ενέργειες",
				"open": "Άνοιγμα παραγγελίας",
				"copyUrl": "Αντιγραφή URL",
				"cancel": "Ακύρωση"
			}
		},
		"mop": {
			"0": "Ηλεκτρονικά",
			"1": "Τηλέφωνο",
			"2": "Εφαρμογή"
		},
		"columns": {
			"title": "Ορατές στήλες",
			"reset": "Επαναφορά στηλών"
		},
		"document": {
			"retail": "Λιανική",
			"invoice": "Τιμολόγιο"
		},
		"onlinePayment": {
			"title": "Ηλεκτρονική πληρωμή",
			"provider": "Πάροχος",
			"status": "Κατάσταση πληρωμής",
			"transactionId": "Αναγνωριστικό συναλλαγής",
			"transactionStatus": "Κατάσταση συναλλαγής",
			"amount": "Ποσό",
			"date": "Ημερομηνία",
			"providerDetails": "Στοιχεία παρόχου",
			"empty": "Δεν υπάρχουν στοιχεία ηλεκτρονικής πληρωμής για αυτή την παραγγελία.",
			"error": "Δεν ήταν δυνατή η φόρτωση των στοιχείων ηλεκτρονικής πληρωμής.",
			"xpay": {
				"orderId": "Κωδικός παραγγελίας XPay",
				"empty": "Δεν έχουν καταγραφεί συναλλαγές XPay.",
				"success": "Επιτυχία",
				"failed": "Αποτυχία",
				"authCode": "Κωδ. έγκρισης",
				"eventId": "Συμβάν",
				"rawRequest": "Αίτημα",
				"rawResponse": "Απάντηση",
				"rawPayload": "Περιεχόμενο ειδοποίησης",
				"kind": {
					"hpp": "Συνεδρία πληρωμής (HPP)",
					"query": "Έλεγχος κατάστασης",
					"notification": "Ειδοποίηση (webhook)"
				}
			}
		},
		"payment": {
			"paid": "Πληρωμένη",
			"pending": "Σε αναμονή",
			"onDelivery": "Με την παράδοση",
			"cancelled": "Ακυρώθηκε",
			"declined": "Απορρίφθηκε",
			"failed": "Απέτυχε",
			"aborted": "Διακόπηκε",
			"timeout": "Λήξη χρόνου"
		},
		"status": {
			"pending": "Εκκρεμής",
			"processing": "Σε επεξεργασία",
			"inDelivery": "Σε αποστολή",
			"completed": "Ολοκληρωμένη",
			"partiallyDelivered": "Μερικώς παραδομένη",
			"notDelivered": "Μη παραδομένη",
			"checkingStock": "Έλεγχος αποθέματος",
			"refund": "Επιστροφή χρημάτων",
			"partiallyReturned": "Μερική επιστροφή",
			"returned": "Επεστράφη",
			"invoiced": "Τιμολογημένη",
			"readyForPickup": "Έτοιμη για παραλαβή",
			"cancelled": "Ακυρωμένη",
			"na": "Μη διαθέσιμη",
			"unknown": "—"
		},
		"filters": {
			"title": "Φίλτρα παραγγελιών",
			"subtitle": "Περιορίστε τα αποτελέσματα του πίνακα.",
			"sections": {
				"identifier": "Αναζήτηση με αναγνωριστικό",
				"dates": "Ημερομηνίες"
			},
			"uid": "Κωδικός ή UID",
			"uidPlaceholder": "π.χ. CVITG-3289221",
			"internalId": "Εσωτερικό ID",
			"internalIdPlaceholder": "100, 101…",
			"barcode": "Barcode",
			"barcodePlaceholder": "Σάρωση…",
			"tracking": "Κωδικός αποστολής",
			"trackingPlaceholder": "ACS / Box Now / Courier",
			"purchaseDate": "Ημερομηνία αγοράς",
			"deliveryDate": "Ημερομηνία παράδοσης",
			"statuses": "Κατάσταση παραγγελίας",
			"statusesPlaceholder": "Επιλέξτε καταστάσεις…",
			"receiptType": "Τύπος παραστατικού",
			"paymentMethod": "Τρόπος πληρωμής",
			"paymentMethodPlaceholder": "Οποιοσδήποτε τρόπος",
			"shippingMethod": "Τρόπος αποστολής",
			"shippingMethodPlaceholder": "Οποιοσδήποτε τρόπος",
			"customer": "Πελάτης",
			"customerPlaceholder": "Όνομα, email ή τηλέφωνο…",
			"totalRange": "Σύνολο (€)",
			"quantityRange": "Τεμάχια",
			"flags": "Σημαίες",
			"flagIsPaid": "Πληρωμένη",
			"flagHasProcessing": "Με πολιτικές",
			"flagHasCoupon": "Με κουπόνι",
			"flagHasGiftcard": "Με δωροκάρτα",
			"flagHasLoyalty": "Με πόντους",
			"flagIsDraft": "Πρόχειρη",
			"from": "Από",
			"to": "Έως",
			"triAny": "Όλα",
			"apply": "Εφαρμογή φίλτρων",
			"clear": "Καθαρισμός όλων"
		},
		"pager": {
			"rowsPerPage": "Σειρές ανά σελίδα:",
			"first": "Πρώτη",
			"prev": "Προηγούμενη",
			"next": "Επόμενη",
			"last": "Τελευταία",
			"page": "Σελίδα {{page}}"
		},
		"empty": {
			"title": "Δεν υπάρχουν παραγγελίες ακόμα",
			"subtitle": "Δεν βρέθηκαν παραγγελίες.",
			"filteredTitle": "Κανένα αποτέλεσμα",
			"filteredSubtitle": "Δεν βρέθηκαν παραγγελίες με αυτά τα κριτήρια.",
			"clearFilters": "Καθαρισμός φίλτρων"
		},
		"error": {
			"title": "Κάτι πήγε στραβά",
			"subtitle": "Δεν ήταν δυνατή η φόρτωση των παραγγελιών.",
			"useDemo": "Προβολή δειγματικών δεδομένων"
		},
		"cancelDialog": {
			"title": "Ακύρωση παραγγελίας",
			"body": "Σίγουρα θέλετε να ακυρώσετε την παραγγελία #{{uid}};",
			"confirm": "Ακύρωση παραγγελίας"
		},
		"toasts": {
			"urlCopied": "Το URL αντιγράφηκε",
			"cancelComingSoon": "Η ακύρωση παραγγελίας θα είναι σύντομα διαθέσιμη",
			"comingSoon": "Σύντομα διαθέσιμο",
			"actionFailed": "Η ενέργεια απέτυχε"
		},
		"create": {
			"title": "Νέα Παραγγελία",
			"required": "Υποχρεωτικό",
			"optional": "Προαιρετικό",
			"crumbs": {
				"orders": "Παραγγελίες"
			},
			"nav": {
				"title": "Βήματα παραγγελίας",
				"customer": "Πελάτης",
				"cart": "Καλάθι",
				"address": "Διευθύνσεις",
				"shipping": "Αποστολή",
				"payment": "Πληρωμή",
				"adjustments": "Εκπτώσεις",
				"notes": "Σημειώσεις"
			},
			"customer": {
				"email": "Email",
				"guestLabel": "Επισκέπτης",
				"created": "Ο πελάτης δημιουργήθηκε"
			},
			"cart": {
				"searchPlaceholder": "Αναζήτηση με κωδικό, barcode ή όνομα προϊόντος…",
				"product": "Προϊόν",
				"variation1": "Παραλλαγή #1",
				"variation2": "Παραλλαγή #2",
				"qty": "Ποσότητα",
				"unit": "Τιμή",
				"total": "Σύνολο",
				"sku": "Κωδικός",
				"chooseVariation": "Επιλέξτε",
				"priceModified": "Τροποποιήθηκε",
				"addLine": "Προσθήκη γραμμής",
				"empty": "Το καλάθι είναι άδειο"
			},
			"address": {
				"title": "Διευθύνσεις",
				"sameAddress": "Ίδια διεύθυνση αποστολής & χρέωσης",
				"billing": "Διεύθυνση χρέωσης",
				"shipping": "Διεύθυνση αποστολής"
			},
			"shipping": {
				"title": "Μέθοδος αποστολής",
				"recommended": "Προτεινόμενο",
				"available": "Διαθέσιμο",
				"free": "Δωρεάν",
				"evaluatedFor": "Επιλογές παράδοσης για Τ.Κ.",
				"enterPostcodeHint": "Συμπληρώστε τον ταχυδρομικό κώδικα για προτάσεις αποστολής.",
				"none": "Δεν υπάρχουν διαθέσιμες μέθοδοι αποστολής.",
				"pickupPoint": "Σημείο παραλαβής",
				"chooseStore": "Επιλογή καταστήματος",
				"changeStore": "Αλλαγή",
				"storePickerTitle": "Επιλογή Καταστήματος",
				"storeSearchPlaceholder": "Αναζήτηση με όνομα ή περιοχή…",
				"storeSelect": "Επιλογή",
				"storeSelected": "Επιλεγμένο",
				"storeSelectUseAddress": "Επιλογή & Χρήση Διεύθυνσης"
			},
			"payment": {
				"title": "Μέθοδος πληρωμής"
			},
			"adjustments": {
				"title": "Εκπτώσεις & κουπόνια",
				"coupon": "Κουπόνι",
				"couponPlaceholder": "Κωδικός κουπονιού",
				"applied": "εφαρμόστηκε",
				"apply": "Εφαρμογή",
				"giftCard": "Δωροκάρτα",
				"giftCardHelp": "Εισάγετε τον κωδικό δωροκάρτας για εξαργύρωση.",
				"giftCardPlaceholder": "Κωδικός δωροκάρτας",
				"loyalty": "Πόντοι επιβράβευσης",
				"loyaltyGuestHelp": "Διαθέσιμο για εγγεγραμμένο πελάτη (όχι επισκέπτη).",
				"loyaltyPlaceholder": "Πόντοι προς εξαργύρωση",
				"loyaltyBalance": "Ο πελάτης έχει {{points}} πόντους.",
				"loyaltyInactive": "Οι πόντοι επιβράβευσης είναι ανενεργοί.",
				"loyaltyRefused": "Το ταμείο δεν δέχτηκε αυτούς τους πόντους· επιλέξτε ξανά.",
				"loyaltyNone": "Χωρίς πόντους",
				"loyaltyNoOptions": "Καμία επιλογή για αυτή την παραγγελία",
				"loyaltyOption": "{{points}} πόντοι · −{{amount}}"
			},
			"notes": {
				"title": "Σημειώσεις",
				"customerComments": "Σχόλια πελάτη",
				"customerPlaceholder": "Ό,τι ανέφερε ο πελάτης για αυτή την παραγγελία…",
				"adminNotes": "Εσωτερικές σημειώσεις",
				"adminPlaceholder": "Σημειώσεις για την ομάδα εκτέλεσης, οδηγίες αποστολής κ.λπ.",
				"communication": "Επικοινωνία",
				"email": "Email",
				"phone": "Τηλέφωνο"
			},
			"summary": {
				"title": "Σύνοψη παραγγελίας",
				"customer": "Πελάτης",
				"noCustomer": "Δεν έχει επιλεγεί πελάτης",
				"cart": "Καλάθι",
				"itemCount": "{{count}} είδη",
				"emptyCart": "Άδειο καλάθι",
				"recalculating": "Επανυπολογισμός…"
			},
			"checklist": {
				"customer": "Επιλογή πελάτη",
				"items": "Τουλάχιστον 1 είδος",
				"address": "Έγκυρες διευθύνσεις",
				"shipping": "Μέθοδος αποστολής",
				"payment": "Μέθοδος πληρωμής"
			},
			"actions": {
				"submit": "Δημιουργία παραγγελίας",
				"saveAsDraft": "Αποθήκευση ως πρόχειρη",
				"created": "Η παραγγελία δημιουργήθηκε επιτυχώς"
			},
			"validation": {
				"required": "Υποχρεωτικό πεδίο",
				"email": "Παρακαλώ εισάγετε ένα έγκυρο email",
				"cartEmpty": "Προσθέστε τουλάχιστον ένα προϊόν",
				"variationRequired": "Επιλέξτε παραλλαγή",
				"incomplete": "Συμπληρώστε όλα τα υποχρεωτικά πεδία",
				"impersonation": "Δεν ήταν δυνατή η ταυτοποίηση του πελάτη/επισκέπτη"
			}
		},
		"components": {
			"totals": {
				"quantity": "Ποσότητα",
				"net": "Καθαρή αξία",
				"vat": "ΦΠΑ",
				"totalDiscount": "Συνολική έκπτωση",
				"paymentSurcharge": "Επιβάρυνση πληρωμής",
				"shipping": "Μεταφορικά",
				"otherCharges": "Λοιπές χρεώσεις",
				"finalTotal": "Τελικό ποσό",
				"initialPaid": "Αρχικά πληρωμένο",
				"recalcNote": "Οι χειροκίνητες προσαρμογές δεν επανυπολογίζονται αυτόματα."
			},
			"address": {
				"title": "Τίτλος διεύθυνσης",
				"titlePlaceholder": "π.χ. Σπίτι, Γραφείο",
				"firstName": "Όνομα",
				"lastName": "Επώνυμο",
				"company": "Εταιρεία",
				"vatNo": "ΑΦΜ",
				"floorBell": "Όροφος / Κουδούνι",
				"addressLine": "Διεύθυνση",
				"city": "Πόλη",
				"postcode": "Τ.Κ.",
				"country": "Χώρα",
				"region": "Περιοχή",
				"mobile": "Κινητό",
				"phone": "Τηλέφωνο",
				"postcodeInvalid": "Ο Τ.Κ. πρέπει να έχει {{count}} ψηφία",
				"copyToShipping": "Αντιγραφή σε αποστολή",
				"copyFromBilling": "Αντιγραφή από τιμολόγηση"
			},
			"timeline": {
				"showAll": "Εμφάνιση όλων ({{count}})",
				"draftUnsaved": "Πρόχειρο · Μη αποθηκευμένο",
				"draftHint": "Θα αποθηκευτεί όταν πατήσετε Αποθήκευση.",
				"discardDraft": "Απόρριψη πρόχειρου",
				"type": {
					"status": "Κατάσταση",
					"comment": "Σχόλιο",
					"notification": "Ειδοποίηση",
					"emailChange": "Email",
					"created": "Δημιουργία",
					"draft": "Πρόχειρο"
				}
			},
			"stock": {
				"available": "Διαθέσιμο",
				"limited": "Περιορισμένο",
				"outOfStock": "Εξαντλημένο"
			},
			"lines": {
				"product": "Προϊόν",
				"availability": "Διαθεσιμότητα",
				"flags": "Σημάνσεις",
				"qty": "Ποσ.",
				"unit": "Τιμή",
				"vat": "ΦΠΑ",
				"discount": "Έκπτωση",
				"total": "Σύνολο",
				"sku": "Κωδ:",
				"barcode": "Barcode:",
				"gift": "Δώρο",
				"addLine": "Προσθήκη γραμμής"
			},
			"lineSheet": {
				"lineOf": "Γραμμή {{index}} από {{total}}",
				"prev": "Προηγούμενη",
				"next": "Επόμενη",
				"product": "Προϊόν",
				"productMeta": "Μόνο για ανάγνωση — για αλλαγή προϊόντος, αφαιρέστε τη γραμμή και προσθέστε νέα",
				"catalogPrice": "Τιμή καταλόγου",
				"stock": "Απόθεμα",
				"category": "Κατηγορία",
				"pricing": "Τιμολόγηση",
				"quantity": "Ποσότητα",
				"unitPrice": "Τιμή μονάδας (€)",
				"override": "Override",
				"catalogHint": "Κατάλογος: {{price}}",
				"vatRate": "Συντελεστής ΦΠΑ",
				"discount": "Έκπτωση",
				"discountAmount": "Ποσό (€)",
				"flags": "Σημάνσεις",
				"markAsGift": "Σήμανση ως δώρο",
				"markAsGiftHelp": "Κρύβει την τιμή στο δελτίο αποστολής και προσθέτει περιτύλιγμα δώρου.",
				"comment": "Σχόλιο γραμμής",
				"commentMeta": "Εμφανίζεται στο δελτίο αποστολής",
				"commentPlaceholder": "π.χ. Με ευχετήρια κάρτα Χρόνια Πολλά…",
				"previewMeta": "Ενημερώνεται καθώς πληκτρολογείτε",
				"lineTotal": "Σύνολο γραμμής",
				"previewNet": "{{qty}} × {{unit}} (καθαρή)",
				"previewVat": "ΦΠΑ ({{pct}})",
				"previewDiscount": "Έκπτωση",
				"removeLine": "Αφαίρεση γραμμής",
				"apply": "Εφαρμογή"
			},
			"productPicker": {
				"title": "Προσθήκη προϊόντος",
				"searchPlaceholder": "Αναζήτηση με SKU, barcode ή όνομα προϊόντος…",
				"startTyping": "Ξεκινήστε να πληκτρολογείτε για αναζήτηση προϊόντων",
				"add": "Προσθήκη",
				"increase": "Αύξηση ποσότητας",
				"decrease": "Μείωση ποσότητας"
			},
			"customerPicker": {
				"guestToggle": "Συνέχεια ως επισκέπτης",
				"searchPlaceholder": "Αναζήτηση με όνομα, email, τηλέφωνο ή κωδικό ERP…",
				"localGroup": "{{count}} τοπικοί πελάτες",
				"local": "Τοπικός",
				"orders": "{{count}} παραγγελίες",
				"createNamed": "Δημιουργία νέου πελάτη \"{{name}}\"",
				"createTitle": "Δημιουργία νέου πελάτη",
				"createHint": "Ελάχιστα στοιχεία για αυτή την παραγγελία. Το πλήρες προφίλ μπορεί να συμπληρωθεί αργότερα.",
				"firstName": "Όνομα",
				"lastName": "Επώνυμο",
				"email": "Email",
				"taxCategory": "Κατηγορία ΦΠΑ",
				"taxRetail": "Λιανική",
				"taxInvoice": "Τιμολόγιο",
				"mobile": "Κινητό",
				"phone": "Τηλέφωνο (προαιρετικό)",
				"useCustomer": "Χρήση αυτού του πελάτη",
				"statOrders": "Παραγγελίες",
				"statSpend": "Συνολικές αγορές",
				"statLastOrder": "Τελευταία παραγγελία"
			}
		},
		"detail": {
			"header": {
				"title": "Παραγγελία",
				"backToList": "Επιστροφή στη λίστα",
				"guest": "Επισκέπτης",
				"channelGuest": "Αγορά ως επισκέπτης",
				"channelAccount": "Λογαριασμός"
			},
			"actions": {
				"syncErp": "Συγχρονισμός ERP",
				"print": "Εκτύπωση",
				"notify": "Ειδοποίηση πελάτη",
				"changeEmail": "Αλλαγή email",
				"send": "Αποστολή παραγγελίας",
				"save": "Αποθήκευση αλλαγών"
			},
			"lines": {
				"title": "Γραμμές παραγγελίας",
				"itemCount": "{{count}} είδη"
			},
			"totals": {
				"title": "Σύνολα",
				"recalculate": "Επανυπολογισμός"
			},
			"info": {
				"title": "Στοιχεία παραγγελίας",
				"savesWithPage": "Οι αλλαγές αποθηκεύονται με το κουμπί Αποθήκευση",
				"purchaseDate": "Ημερομηνία αγοράς",
				"documentType": "Τύπος παραστατικού",
				"docRetail": "Απόδειξη",
				"docInvoice": "Τιμολόγιο",
				"currency": "Νόμισμα",
				"language": "Γλώσσα",
				"totalWeight": "Συνολικό βάρος",
				"erpCode": "Κωδικός ERP",
				"paymentWallet": "Πληρώθηκε με",
				"paymentMethod": "Τρόπος πληρωμής",
				"shippingMethod": "Τρόπος αποστολής",
				"courier": "Courier",
				"communicationType": "Τρόπος επικοινωνίας",
				"contactMethod_0": "Email",
				"contactMethod_1": "Κινητό",
				"shippingDate": "Ημερομηνία αποστολής",
				"trackingNumber": "Αριθμός αποστολής",
				"notSet": "Δεν έχει οριστεί",
				"newsletter": "Εγγραφή newsletter",
				"promo": "Προωθητικές ενέργειες",
				"personalizedMessages": "Προσωποποιημένα μηνύματα",
				"isGift": "Είναι δώρο"
			},
			"erpSyncLog": {
				"button": "Ιστορικό ERP",
				"title": "Ιστορικό συγχρονισμού ERP",
				"subtitle": "Όλες οι προσπάθειες συγχρονισμού ERP για αυτή την παραγγελία (αίτημα + απάντηση), πιο πρόσφατες πρώτα.",
				"success": "Επιτυχία",
				"failed": "Αποτυχία",
				"edit": "Τροποποίηση",
				"receiptNo": "Αρ. παραστατικού",
				"returnValue": "Τιμή επιστροφής",
				"error": "Σφάλμα",
				"request": "Αίτημα",
				"response": "Απάντηση",
				"loading": "Φόρτωση ιστορικού συγχρονισμού ERP...",
				"noData": "Δεν υπάρχουν καταγεγραμμένες προσπάθειες συγχρονισμού ERP για αυτή την παραγγελία."
			},
			"comments": {
				"customerTitle": "Σχόλια πελάτη",
				"customerMeta": "Ορατό στον πελάτη",
				"customerPlaceholder": "Σχόλιο του πελάτη για την παραγγελία, αν υπάρχει…",
				"adminTitle": "Σημειώσεις διαχειριστή",
				"adminMeta": "Μόνο εσωτερικά",
				"adminPlaceholder": "Σημειώσεις για την ομάδα — δεν είναι ποτέ ορατές στον πελάτη…"
			},
			"address": {
				"billing": "Διεύθυνση χρέωσης",
				"shipping": "Διεύθυνση αποστολής"
			},
			"customer": {
				"title": "Πελάτης",
				"orders": "Παραγγελίες",
				"lifetimeSpend": "Σύνολο αγορών",
				"lastOrder": "Τελευταία παραγγελία"
			},
			"status": {
				"title": "Κατάσταση παραγγελίας",
				"placeholder": "Κατάσταση…",
				"subStatusPlaceholder": "Υποκατάσταση…",
				"recentActivity": "Πρόσφατη δραστηριότητα",
				"viewFullHistory": "Προβολή πλήρους ιστορικού"
			},
			"history": {
				"title": "Ιστορικό παραγγελίας",
				"eventCount": "{{count}} συμβάντα",
				"commentPlaceholder": "Προσθέστε σχόλιο στο ιστορικό της παραγγελίας…",
				"addToHistory": "Προσθήκη στο ιστορικό",
				"empty": "Δεν υπάρχει ιστορικό ακόμη."
			},
			"notify": {
				"placeholder": "Μήνυμα προς τον πελάτη…",
				"send": "Αποστολή"
			},
			"toasts": {
				"sent": "Η παραγγελία στάλθηκε.",
				"notified": "Ο πελάτης ειδοποιήθηκε.",
				"emailChanged": "Το email ενημερώθηκε.",
				"erpSynced": "Συγχρονίστηκε με το ERP.",
				"historyAdded": "Προστέθηκε στο ιστορικό.",
				"recalculated": "Τα σύνολα επανυπολογίστηκαν."
			}
		},
		"orderStates": {
			"title": "Εσωτερικές Καταστάσεις",
			"add": "Νέα κατάσταση",
			"addTitle": "Νέα εσωτερική κατάσταση",
			"editTitle": "Επεξεργασία εσωτερικής κατάστασης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της εσωτερικής κατάστασης παραγγελίας.",
			"deleteTitle": "Διαγραφή κατάστασης",
			"deleteBody": "Διαγραφή της κατάστασης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"erpCode": "Κωδικός ERP",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"paymentTypes": {
			"title": "Τρόποι Πληρωμής",
			"add": "Νέος τρόπος πληρωμής",
			"untitled": "Νέος τρόπος πληρωμής",
			"notFound": "Ο τρόπος πληρωμής δεν βρέθηκε.",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατός",
			"statusHidden": "Κρυφός",
			"deleteTitle": "Διαγραφή τρόπου πληρωμής",
			"deleteBody": "Διαγραφή του τρόπου πληρωμής «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"erpCode2": "Κωδικός ERP (2)",
			"anyCountry": "Όλες οι χώρες",
			"anyRegion": "Όλοι οι νομοί",
			"customerGroups": "Προφίλ πελατών",
			"allCustomerGroups": "Όλα τα προφίλ",
			"excludedCustomerGroups": "Εξαιρούμενα προφίλ πελατών",
			"noExcludedCustomerGroups": "Καμία εξαίρεση",
			"minWeight": "Ελάχιστο βάρος",
			"maxWeight": "Μέγιστο βάρος",
			"installmentsLogic": "Λογική δόσεων",
			"installmentsHelp": "π.χ. 90:3,180:6 (από 90€ έως 3 δόσεις, από 180€ έως 6 δόσεις). Πρέπει να υποστηρίζεται από την τράπεζα.",
			"thresholdHelp": "Όριο αξίας καλαθιού πάνω από το οποίο εφαρμόζεται η χρέωση.",
			"supportStoredCards": "Υποστήριξη αποθηκευμένων καρτών",
			"allowEditOrder": "Επιτρέπεται επεξεργασία παραγγελίας",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"descriptionPlaceholder": "Κείμενο περιγραφής…",
			"tabs": {
				"general": "Γενικά",
				"rules": "Κανόνες & Χρεώσεις",
				"content": "Κείμενο",
				"image": "Εικόνα"
			},
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"onlineType": "Online Πληρωμή",
				"country": "Χώρα",
				"countries": "Διαθέσιμες Χώρες",
				"region": "Νομός",
				"regions": "Διαθέσιμοι Νομοί",
				"code": "Κωδικός",
				"erpCode": "Κωδικός ERP",
				"flatRate": "Σταθερή Χρέωση",
				"threshold": "Όριο τιμής καλαθιού",
				"minPrice": "Ελάχιστη τιμή καλαθιού",
				"maxPrice": "Μέγιστη τιμή καλαθιού",
				"retailOnly": "Μόνο Απόδειξη",
				"invoiceOnly": "Μόνο Τιμολόγιο",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"takeawayStores": {
			"title": "Σημεία Παραλαβής",
			"add": "Νέο σημείο παραλαβής",
			"untitled": "Νέο σημείο παραλαβής",
			"notFound": "Το σημείο παραλαβής δεν βρέθηκε.",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατό",
			"statusHidden": "Κρυφό",
			"deleteTitle": "Διαγραφή σημείου παραλαβής",
			"deleteBody": "Διαγραφή του σημείου παραλαβής «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectCountry": "Επιλέξτε χώρα…",
			"anyRegion": "Όλοι οι νομοί",
			"manager": "Υπεύθυνος καταστήματος",
			"email": "Email",
			"telephone": "Τηλέφωνο",
			"transitDays": "Ημέρες παράδοσης",
			"flatRate": "Σταθερή χρέωση",
			"threshold": "Όριο τιμής καλαθιού",
			"erpCode": "Κωδικός ERP",
			"addressLine": "Διεύθυνση",
			"addressLine2": "Διεύθυνση (2)",
			"area": "Περιοχή",
			"city": "Πόλη",
			"postalCode": "Τ.Κ.",
			"latitude": "Γεωγραφικό πλάτος",
			"longitude": "Γεωγραφικό μήκος",
			"openHourStart": "Ώρα έναρξης",
			"openHourEnd": "Ώρα λήξης",
			"workHours": "Ωράριο λειτουργίας",
			"workHoursPlaceholder": "Ωράριο λειτουργίας…",
			"descriptionPlaceholder": "Κείμενο περιγραφής…",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"tabs": {
				"general": "Γενικά",
				"address": "Διεύθυνση",
				"hours": "Ωράριο",
				"content": "Κείμενο",
				"images": "Εικόνες"
			},
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"country": "Χώρα",
				"region": "Νομός",
				"address": "Διεύθυνση",
				"email": "Email",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"warehouseCode": "Κωδικός αποθήκης",
			"warehouseCodeHelp": "Ο κωδικός της αποθήκης με το απόθεμα του καταστήματος (ακριβής αντιστοίχιση με τον κωδικό αποθήκης)· χρησιμοποιείται από το φίλτρο «Σε απόθεμα»."
		},
		"skroutz": {
			"title": "Λίστα Παραγγελιών Skroutz",
			"searchPlaceholder": "Αναζήτηση με όνομα, email, τηλέφωνο ή κωδικό…",
			"searchId": "Αναζήτηση με ID",
			"searchIdPlaceholder": "ID, π.χ. 100,101,500",
			"noLink": "Δεν υπάρχει διαθέσιμος σύνδεσμος για αυτή την παραγγελία.",
			"linkError": "Αποτυχία ανάκτησης της παραγγελίας Skroutz.",
			"columns": {
				"code": "Κωδικός Skroutz",
				"purchaseDate": "Ημ/νία Αγοράς",
				"firstName": "Όνομα",
				"lastName": "Επώνυμο",
				"email": "E-mail",
				"phone": "Τηλέφωνο",
				"status": "Κατάσταση Skroutz",
				"total": "Τελικό Ποσό",
				"quantity": "Τεμ."
			},
			"actions": {
				"details": "Λεπτομέρειες παραγγελίας",
				"showOnSkroutz": "Προβολή στο Skroutz",
				"printVoucher": "Εκτύπωση voucher"
			}
		},
		"shippingTypes": {
			"title": "Τρόποι Αποστολής",
			"add": "Νέος τρόπος αποστολής",
			"untitled": "Νέος τρόπος αποστολής",
			"notFound": "Ο τρόπος αποστολής δεν βρέθηκε.",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατός",
			"statusHidden": "Κρυφός",
			"deleteTitle": "Διαγραφή τρόπου αποστολής",
			"deleteBody": "Διαγραφή του τρόπου αποστολής «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"anyCountry": "Όλες οι χώρες",
			"anyRegion": "Όλοι οι νομοί",
			"customerGroups": "Προφίλ πελατών",
			"allCustomerGroups": "Όλα τα προφίλ",
			"excludedCustomerGroups": "Εξαιρούμενα προφίλ πελατών",
			"noExcludedCustomerGroups": "Καμία εξαίρεση",
			"erpCode2": "Κωδικός ERP (2)",
			"activeMaxCartPrice": "Μέγιστη αξία καλαθιού ενεργοποίησης",
			"activeMaxCartPriceHelp": "Ο τρόπος παύει να είναι διαθέσιμος όταν η αξία των προϊόντων του καλαθιού (μετά τις εκπτώσεις) φτάσει αυτό το ποσό. Κενό = χωρίς όριο.",
			"trackingUrlTemplate": "Πρότυπο URL παρακολούθησης",
			"trackingUrlTemplateHelp": "Πρότυπο Handlebars που πρέπει να παράγει απόλυτο σύνδεσμο http(s), π.χ. https://courier.example/track/{{variable}}. Διαθέσιμα επίσης: OrderUid, ShippingTypeCode, ShippingTypeName. Κενό = χωρίς σύνδεσμο.",
			"storeTakeAway": "Παραλαβή από κατάστημα",
			"contactlessDelivery": "Παράδοση χωρίς επαφή",
			"courierDelivery": "Παράδοση με courier",
			"transportCourier": "Μεταφορική / Courier",
			"minWeight": "Ελάχιστο βάρος",
			"maxWeight": "Μέγιστο βάρος",
			"maxLength": "Μέγιστο μήκος",
			"maxWidth": "Μέγιστο πλάτος",
			"maxHeight": "Μέγιστο ύψος",
			"maxVolWeight": "Μέγιστο ογκομετρικό βάρος",
			"maxWeightPerProduct": "Μέγιστο βάρος ανά προϊόν",
			"savePayments": "Αποθήκευση τρόπων πληρωμής",
			"saveFirst": "Αποθηκεύστε πρώτα τον τρόπο αποστολής για να διαχειριστείτε αυτή την ενότητα.",
			"descriptionPlaceholder": "Κείμενο περιγραφής…",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"tabs": {
				"general": "Γενικά",
				"delivery": "Παράδοση",
				"constraints": "Περιορισμοί",
				"charges": "Χρεώσεις",
				"payments": "Τρόποι πληρωμής",
				"postal": "Ταχ. Κώδικες",
				"content": "Κείμενο",
				"image": "Εικόνα"
			},
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"country": "Χώρα",
				"countries": "Διαθέσιμες Χώρες",
				"region": "Νομός",
				"regions": "Διαθέσιμοι Νομοί",
				"code": "Κωδικός",
				"erpCode": "Κωδικός ERP",
				"flatRate": "Σταθερή Χρέωση",
				"threshold": "Όριο τιμής καλαθιού",
				"storeTakeAway": "Παραλαβή",
				"default": "Προεπιλογή",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"shippingCharges": {
			"add": "Νέα χρέωση",
			"addTitle": "Νέα χρέωση αποστολής",
			"editTitle": "Επεξεργασία χρέωσης αποστολής",
			"formSubtitle": "Ορίστε το εύρος, τη χρέωση και τις συνθήκες τιμής / βάρους / όγκου.",
			"deleteTitle": "Διαγραφή χρέωσης",
			"deleteBody": "Διαγραφή αυτής της χρέωσης; Η ενέργεια δεν αναιρείται.",
			"empty": "Δεν υπάρχουν χρεώσεις ακόμη.",
			"scope": "Εμβέλεια",
			"allDestinations": "Όλοι οι προορισμοί",
			"classification": "Κατηγοριοποίηση χώρας",
			"country": "Χώρα",
			"region": "Νομός",
			"postalCode": "Ταχ. Κώδικας",
			"flatRate": "Σταθερή χρέωση",
			"percentageOrder": "Ποσοστό παραγγελίας (%)",
			"combineOperator": "Τελεστής συνδυασμού",
			"sort": "Σειρά",
			"chargePerPiece": "Χρέωση ανά τεμάχιο",
			"priceGroup": "Συνθήκη τιμής",
			"weightGroup": "Συνθήκη βάρους",
			"volumeGroup": "Συνθήκη όγκου",
			"operator": "Τελεστής",
			"from": "Από",
			"to": "Έως",
			"step": "Βήμα",
			"stepRate": "Χρέωση βήματος",
			"any": "— Όλα —"
		},
		"shippingPostal": {
			"add": "Προσθήκη",
			"addAll": "Προσθήκη όλων",
			"removeAll": "Αφαίρεση όλων",
			"removeAllTitle": "Αφαίρεση όλων των ταχ. κωδίκων",
			"removeAllBody": "Αφαίρεση όλων των ταχ. κωδίκων από αυτόν τον τρόπο αποστολής;",
			"pickPlaceholder": "Αναζήτηση ταχ. κώδικα…",
			"empty": "Δεν έχουν αντιστοιχιστεί ταχ. κώδικες.",
			"code": "Κώδικας",
			"area": "Περιοχή",
			"city": "Πόλη"
		},
		"filtered": {
			"title": "Φιλτραρισμένες Παραγγελίες",
			"searchPlaceholder": "Αναζήτηση με κωδικό, πελάτη, email ή τηλέφωνο…",
			"details": "Λεπτομέρειες παραγγελίας",
			"columns": {
				"code": "Κωδικός",
				"purchaseDate": "Ημ/νία Αγοράς",
				"deliveryDate": "Ημ/νία Παράδοσης",
				"customer": "Πελάτης",
				"quantity": "Τεμ.",
				"total": "Σύνολο",
				"shipping": "Αποστολή",
				"status": "Κατάσταση",
				"salesPersons": "Πωλητές"
			}
		},
		"returns": {
			"title": "Επιστροφές & αντικαταστάσεις",
			"moduleDisabled": "Η ενότητα επιστροφών δεν είναι ενεργή για αυτό το κατάστημα.",
			"loadFailed": "Η φόρτωση απέτυχε",
			"request": "Αίτημα επιστροφής",
			"requestSubtitle": "Ό,τι υπέβαλε ο πελάτης είναι μη επεξεργάσιμο. Η πλατφόρμα καταγράφει — δεν κινεί χρήματα και δεν στέλνει αντικαταστάσεις.",
			"piece": "Τεμάχιο",
			"show": "Εμφάνιση",
			"hide": "Απόκρυψη",
			"deliveryAddress": "Διεύθυνση παράδοσης",
			"returnMethod": "Τρόπος επιστροφής",
			"carrierReference": "Αναφορά μεταφορικής",
			"columns": {
				"id": "Id",
				"order": "Παραγγελία",
				"customer": "Πελάτης",
				"product": "Προϊόν",
				"piece": "Τεμάχιο #",
				"unitValue": "Αξία τεμαχίου",
				"reason": "Λόγος επιστροφής",
				"desiredAction": "Επιθυμία πελάτη",
				"paymentMethod": "Τρόπος πληρωμής",
				"deliveryMethod": "Τρόπος αποστολής",
				"refundExecutedAt": "Εκτέλεση επιστροφής χρημάτων",
				"submittedAt": "Ημ/νία καταχώρησης",
				"status": "Κατάσταση"
			},
			"toolbar": {
				"columns": "Στήλες",
				"resetColumns": "Επαναφορά στηλών",
				"export": "Εξαγωγή"
			},
			"actions": {
				"open": "Άνοιγμα αιτήματος"
			},
			"status": {
				"new": "Νέο αίτημα",
				"underReview": "Σε έλεγχο",
				"approved": "Εγκρίθηκε",
				"awaitingProduct": "Αναμονή προϊόντος",
				"inProgress": "Σε εξέλιξη",
				"completed": "Ολοκληρώθηκε",
				"rejected": "Απορρίφθηκε",
				"unknown": "—"
			},
			"reason": {
				"none": "Δεν δηλώθηκε",
				"changedMind": "Υπαναχώρηση",
				"poorCondition": "Κακή κατάσταση",
				"defective": "Ελαττωματικό",
				"wrongProduct": "Λάθος προϊόν",
				"missingPart": "Λείπει εξάρτημα",
				"fewerPieces": "Λιγότερα τεμάχια",
				"morePieces": "Περισσότερα τεμάχια",
				"wrongColour": "Λάθος χρώμα",
				"wrongSize": "Λάθος μέγεθος"
			},
			"action": {
				"none": "Δεν δηλώθηκε",
				"refund": "Επιστροφή χρημάτων",
				"replacement": "Αντικατάσταση",
				"credit": "Πίστωση"
			},
			"refundMethod": {
				"notExecuted": "Δεν εκτελέστηκε",
				"bankTransfer": "Τραπεζική μεταφορά",
				"providerReversal": "Ακύρωση μέσω παρόχου πληρωμών",
				"originalInstrument": "Αρχικό μέσο πληρωμής",
				"cashInStore": "Μετρητά στο κατάστημα",
				"coupon": "Κουπόνι"
			},
			"method": {
				"courierPickup": "Παραλαβή με courier",
				"lockerDropOff": "Παράδοση σε locker",
				"freightCarrier": "Μεταφορική"
			},
			"queue": {
				"approvedUnpaid": "Εγκεκριμένες & μη πληρωμένες"
			},
			"settlement": {
				"pending": "Εκκρεμεί",
				"done": "Έχει γίνει"
			},
			"filters": {
				"orderUid": "Κωδικός παραγγελίας",
				"customer": "Πελάτης",
				"customerHint": "Όνομα, email, τηλέφωνο ή ΑΦΜ",
				"product": "Προϊόν",
				"productHint": "Τίτλος, κωδικός ή barcode",
				"workQueue": "Ουρά εργασίας",
				"workQueueHint": "Καθορίζει μόνη της κατάσταση και ενέργεια",
				"statuses": "Καταστάσεις",
				"defaultOpen": "Ανοιχτά αιτήματα",
				"desiredAction": "Επιθυμία πελάτη",
				"refundExecution": "Εκτέλεση επιστροφής χρημάτων",
				"submittedFrom": "Καταχώρηση από",
				"submittedTo": "Καταχώρηση έως",
				"any": "Όλα",
				"clear": "Καθαρισμός φίλτρων"
			},
			"gate": {
				"refundExecutionRequired": "απαιτείται πρώτα καταγραφή της επιστροφής χρημάτων",
				"replacementDispatchRequired": "απαιτείται πρώτα καταγραφή της αποστολής αντικατάστασης"
			},
			"statusChange": {
				"title": "Αλλαγή κατάστασης",
				"current": "Τρέχουσα κατάσταση",
				"pickTarget": "Επιλέξτε νέα κατάσταση",
				"terminal": "Το τεμάχιο είναι σε τελική κατάσταση και δεν μετακινείται άλλο.",
				"confirm": "Επιβεβαίωση αλλαγής"
			},
			"bulk": {
				"title": "Μαζική αλλαγή κατάστασης",
				"subtitle_one": "{{count}} επιλεγμένο τεμάχιο κινείται μόνο του. Η αλλαγή εφαρμόζεται σε αυτό ή σε τίποτα.",
				"subtitle_other": "{{count}} επιλεγμένα τεμάχια κινούνται μαζί. Η αλλαγή εφαρμόζεται σε όλα ή σε κανένα.",
				"selected_one": "{{count}} επιλεγμένο",
				"selected_other": "{{count}} επιλεγμένα",
				"changeStatus": "Αλλαγή κατάστασης",
				"clear": "Καθαρισμός",
				"selectAll": "Επιλογή όλων των τεμαχίων της σελίδας",
				"selectRow": "Επιλογή τεμαχίου",
				"noTargets": "Καμία κατάσταση δεν δέχεται όλη την επιλογή. Περιορίστε την ή δουλέψτε τα τεμάχια χωριστά.",
				"apply_one": "Μετακίνηση {{count}} τεμαχίου",
				"apply_other": "Μετακίνηση {{count}} τεμαχίων",
				"applied_one": "Μετακινήθηκε {{count}} τεμάχιο",
				"applied_other": "Μετακινήθηκαν {{count}} τεμάχια",
				"blocked": {
					"count": "{{blocked}} από {{count}} δεν μπορούν",
					"settled": "έχουν ήδη πληρωθεί ή σταλεί, οπότε δεν απορρίπτονται",
					"illegal": "δεν είναι προσβάσιμη από την τρέχουσα κατάστασή τους"
				}
			},
			"checklist": {
				"title": "Για να κλείσει το αίτημα",
				"allClear": "Όλες οι καταγραφές υπάρχουν — τα ανοιχτά τεμάχια μπορούν να ολοκληρωθούν.",
				"refundPending": "Τεμάχιο #{{piece}} ({{product}}): εκτέλεσε την επιστροφή χρημάτων και κατέγραψέ την",
				"couponPending": "Τεμάχιο #{{piece}} ({{product}}): δημιούργησε χειροκίνητα το κουπόνι και κατέγραψέ το ως διακανονισμό",
				"dispatchPending": "Τεμάχιο #{{piece}} ({{product}}): κατέγραψε την αποστολή της αντικατάστασης",
				"basketDispatchPending_one": "Κατέγραψε την αποστολή {{count}} είδους αντικατάστασης στο καλάθι",
				"basketDispatchPending_other": "Κατέγραψε την αποστολή {{count}} ειδών αντικατάστασης στο καλάθι",
				"remainderPending": "Απόδωσε στον πελάτη το αδιάθετο υπόλοιπο {{amount}} — κουπόνι ή επιστροφή χρημάτων, χειροκίνητα"
			},
			"discard": {
				"title": "Απόρριψη μη αποθηκευμένων αλλαγών;",
				"body_one": "{{count}} τεμάχιο έχει μη αποθηκευμένες αλλαγές. Αν κλείσεις τώρα, θα χαθούν.",
				"body_other": "{{count}} τεμάχια έχουν μη αποθηκευμένες αλλαγές. Αν κλείσεις τώρα, θα χαθούν.",
				"keep": "Συνέχεια επεξεργασίας",
				"discard": "Απόρριψη αλλαγών"
			},
			"sections": {
				"request": "Στοιχεία αιτήματος",
				"refundBankDetails": "Τραπεζικά στοιχεία επιστροφής",
				"refundBankDetailsHint": "Ο λογαριασμός που έδωσε ο πελάτης. Η καταγραφή του διακανονισμού γίνεται ανά τεμάχιο.",
				"replacementBasket": "Καλάθι αντικατάστασης"
			},
			"refund": {
				"iban": "IBAN",
				"beneficiary": "Δικαιούχος",
				"bank": "Τράπεζα",
				"method": "Τρόπος επιστροφής χρημάτων",
				"amount": "Ποσό",
				"amountMax": "Έως {{max}}",
				"transactionReference": "Αναφορά συναλλαγής",
				"executedAt": "Ημ/νία εκτέλεσης",
				"executedAtHint": "Πότε έφυγαν πράγματι τα χρήματα",
				"recordedBy": "Η εκτέλεση καταγράφηκε από"
			},
			"item": {
				"submissionDetails": "Στοιχεία υποβολής",
				"edited": "Μη αποθηκευμένες αλλαγές",
				"refundRecordTitle": "Καταγραφή επιστροφής χρημάτων",
				"couponRecordTitle": "Καταγραφή διακανονισμού με κουπόνι",
				"replacementBlockTitle": "Αντικατάσταση & αποστολή",
				"unitValue": "Αξία τεμαχίου",
				"reason": "Λόγος επιστροφής",
				"lastStatusChange": "Τελευταία αλλαγή κατάστασης",
				"customerComment": "Σχόλιο πελάτη",
				"photos": "Φωτογραφίες",
				"status": "Κατάσταση",
				"statusHelp": "Μόνο οι επιτρεπτές επόμενες καταστάσεις, όπως τις επιστρέφει ο server",
				"statusUnchanged": "Χωρίς αλλαγή",
				"desiredAction": "Επιθυμία πελάτη",
				"policyNoRefund": "δεν την υποστηρίζει η πολιτική επιστροφών",
				"creditDisabled": "η πίστωση δεν είναι ενεργή",
				"manualCoupon": "Χειροκίνητη ενέργεια: δημιούργησε κουπόνι για την αξία του τεμαχίου και κατέγραψέ το παρακάτω ως διακανονισμό. Η πλατφόρμα δεν δημιουργεί κουπόνια αυτόματα.",
				"targetInBasket": "Τα ζητούμενα είδη και η αποστολή τους ζουν στο καλάθι αντικατάστασης παραπάνω — το αίτημα ήρθε από τον πελάτη, με κοινό πορτοφόλι για όλα τα τεμάχια.",
				"replacementProduct": "Προϊόν αντικατάστασης",
				"pickReplacementProduct": "Επιλέξτε προϊόν",
				"replacementVariant": "Παραλλαγή αντικατάστασης",
				"noVariant": "Χωρίς παραλλαγή",
				"variantUnavailable": "{{variant}} — δεν είναι πλέον διαθέσιμη",
				"replacementSearchHint": "Πληκτρολογήστε τουλάχιστον 2 χαρακτήρες για αναζήτηση προϊόντος",
				"dispatchedAt": "Ημ/νία αποστολής αντικατάστασης",
				"dispatchedAtHelp": "Καταγραφή αποστολής που έχει ήδη γίνει",
				"dispatchReference": "Αναφορά αποστολής",
				"dispatchRecordedBy": "Η αποστολή καταγράφηκε από",
				"adminNotes": "Παρατηρήσεις διαχειριστή",
				"settlementIncomplete": "Ελλιπής καταγραφή: χρειάζονται τρόπος, ποσό και ημερομηνία εκτέλεσης για να αποθηκευτεί.",
				"amountOutOfRange": "Το ποσό πρέπει να είναι μεγαλύτερο από μηδέν και όχι πάνω από την αξία του τεμαχίου.",
				"recordsNeedOpenApproval": "Εγκρίνετε πρώτα το τεμάχιο: επιστροφή χρημάτων ή αποστολή καταγράφεται μόνο σε εγκεκριμένο τεμάχιο που είναι ακόμα ανοιχτό.",
				"dispatchIncomplete": "Ελλιπής καταγραφή: χρειάζεται ημερομηνία αποστολής για να αποθηκευτεί."
			},
			"delete": {
				"title": "Διαγραφή αιτήματος επιστροφής",
				"body": "Θέλετε σίγουρα να διαγράψετε αυτό το αίτημα; Επιτρέπεται μόνο όσο κάθε τεμάχιο είναι σε «Νέο αίτημα»."
			},
			"policy": {
				"tabMeta": "Αποθηκεύεται ξεχωριστά από το προϊόν",
				"saved": "Η πολιτική επιστροφών αποθηκεύτηκε",
				"saveEntityFirst": "Αποθηκεύστε πρώτα την εγγραφή για να ορίσετε πολιτική επιστροφών.",
				"notDeclared": "Δεν έχει δηλωθεί",
				"allowed": "Επιτρέπεται",
				"blocked": "Αποκλείεται",
				"flagsTitle": "Περιορισμοί επιστροφής",
				"flagsSubtitle": "Τρικατάστατο: «Δεν έχει δηλωθεί» σημαίνει ότι ισχύει η πολιτική της κατηγορίας.",
				"noReturns": "Δεν υποστηρίζεται επιστροφή",
				"noReturnsHint": "Μπλοκάρει κάθε αίτημα για το είδος",
				"noWithdrawal": "Δεν υποστηρίζεται υπαναχώρηση",
				"noWithdrawalHint": "Μπλοκάρει τον λόγο «Υπαναχώρηση»",
				"noRefund": "Δεν υποστηρίζεται επιστροφή χρημάτων",
				"noRefundHint": "Μπλοκάρει την επιστροφή χρημάτων και την πίστωση",
				"blockedMethods": "Αποκλεισμένες μέθοδοι επιστροφής",
				"blockedMethodsHint": "Ενεργοποιήστε όποια μέθοδο δεν επιτρέπεται για το είδος."
			},
			"toasts": {
				"saved": "Οι αλλαγές αποθηκεύτηκαν",
				"deleted": "Το αίτημα διαγράφηκε",
				"statusChanged": "Η κατάσταση άλλαξε",
				"recordIncomplete": "Δεν αποθηκεύτηκε τίποτα — συμπλήρωσε ή καθάρισε πρώτα τις ελλιπείς καταγραφές που σημειώνονται στα τεμάχια.",
				"photoFailed": "Η φωτογραφία δεν άνοιξε",
				"exportTruncated": "Εξήχθησαν {{exported}} από {{total}} γραμμές — περιορίστε τα φίλτρα για πλήρη εξαγωγή."
			},
			"basket": {
				"wallet": "Αξία που επιστρέφεται",
				"charge": "Αξία που ζητήθηκε",
				"remainder": "Υπόλοιπο",
				"remainderAction": "Χειροκίνητη ενέργεια: μένει υπόλοιπο {{amount}}. Απόδοσέ το στον πελάτη με κουπόνι ή επιστροφή χρημάτων — η πλατφόρμα δεν δημιουργεί κανένα από τα δύο αυτόματα.",
				"overdrawn": "Το καλάθι ζητά {{amount}} περισσότερα από την αξία που επιστρέφεται. Έλεγξε ξανά τις επιθυμίες των τεμαχίων — τεμάχιο που έφυγε από «Αντικατάσταση» μικραίνει το πορτοφόλι χωρίς να επανελεγχθεί το καλάθι.",
				"pendingDispatch_one": "{{count}} είδος δεν έχει σταλεί ακόμα. Τεμάχιο αντικατάστασης δεν ολοκληρώνεται όσο δεν έχουν καταγραφεί όλες οι γραμμές.",
				"pendingDispatch_other": "{{count}} είδη δεν έχουν σταλεί ακόμα. Τεμάχιο αντικατάστασης δεν ολοκληρώνεται όσο δεν έχουν καταγραφεί όλες οι γραμμές.",
				"sameItem": "το ίδιο είδος ξανά, με την αξία που πληρώθηκε",
				"dispatched": "Στάλθηκε",
				"notDispatched": "Δεν στάλθηκε",
				"dispatchedAt": "Ημ/νία αποστολής",
				"recordDispatch": "Καταγραφή αποστολής",
				"showLines": "Εμφάνιση ειδών ({{count}})",
				"hideLines": "Απόκρυψη ειδών"
			},
			"settings": {
				"title": "Ρυθμίσεις επιστροφών",
				"subtitle": "Όλες οι ρυθμιζόμενες μεταβλητές του module επιστροφών. Μεταβλητή χωρίς αποθηκευμένη τιμή χρησιμοποιεί την προεπιλογή που εμφανίζεται.",
				"usingDefault": "Δεν έχει οριστεί — ισχύει η προεπιλογή",
				"defaultHint": "Προεπιλογή: {{value}}. Αφήστε το πεδίο κενό για επαναφορά.",
				"reset": "Επαναφορά προεπιλογής",
				"resetTitle": "Επαναφορά προεπιλογής",
				"resetBody": "Να αφαιρεθεί η αποθηκευμένη τιμή της {{name}}; Θα ισχύσει ξανά η προεπιλογή ({{value}}).",
				"resetNotStored": "Η {{name}} δεν έχει αποθηκευμένη τιμή — ήδη τρέχει με την προεπιλογή της, οπότε δεν υπάρχει κάτι να επαναφερθεί.",
				"resetDone": "Η {{name}} επανήλθε στην προεπιλογή της",
				"columns": {
					"name": "Όνομα μεταβλητής",
					"value": "Τιμή μεταβλητής",
					"description": "Περιγραφή μεταβλητής",
					"defaultValue": "Προεπιλογή",
					"kind": "Τύπος",
					"scope": "Εμβέλεια"
				},
				"kind": {
					"boolean": "Ναι / Όχι",
					"integer": "Αριθμός",
					"stringList": "Λίστα κειμένων",
					"integerList": "Λίστα αριθμών",
					"windowAnchor": "Έναρξη παραθύρου",
					"methodFlags": "Τρόποι επιστροφής"
				},
				"scope": {
					"unset": "Δεν έχει οριστεί",
					"allSites": "Όλα τα sites",
					"thisSite": "Αυτό το site"
				}
			}
		}
	},
	"system": {
		"languages": {
			"title": "Γλώσσες",
			"count": "{{count}} γλώσσες",
			"add": "Νέα γλώσσα",
			"addTitle": "Νέα γλώσσα",
			"editTitle": "Επεξεργασία γλώσσας",
			"deleteTitle": "Διαγραφή γλώσσας",
			"deleteBody": "Να διαγραφεί η γλώσσα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"localName": "Τοπικό Όνομα",
				"iso2": "Κωδικός ISO-2",
				"culture": "Κωδικός Culture",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"formSubtitle": "Συμπληρώστε τα στοιχεία της γλώσσας."
		},
		"countries": {
			"title": "Χώρες",
			"count": "{{count}} χώρες",
			"add": "Νέα χώρα",
			"addTitle": "Νέα χώρα",
			"editTitle": "Επεξεργασία χώρας",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της χώρας.",
			"classificationPlaceholder": "Επιλέξτε ομαδοποίηση",
			"deleteTitle": "Διαγραφή χώρας",
			"deleteBody": "Να διαγραφεί η χώρα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"iso2": "Κωδικός ISO-2",
				"classification": "Ομαδοποίηση",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"pagination": {
				"showing": "{{from}}–{{to}} από {{total}}"
			}
		},
		"users": {
			"title": "Χρήστες",
			"count": "{{count}} χρήστες",
			"add": "Νέος χρήστης",
			"addTitle": "Νέος χρήστης",
			"editTitle": "Επεξεργασία χρήστη",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του χρήστη.",
			"rolePlaceholder": "Επιλέξτε ρόλο",
			"password": "Κωδικός πρόσβασης",
			"passwordEdit": "Νέος κωδικός πρόσβασης",
			"passwordKeep": "Αφήστε κενό για να μην αλλάξει",
			"deleteTitle": "Διαγραφή χρήστη",
			"deleteBody": "Να διαγραφεί ο χρήστης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"role": "Ρόλος",
				"email": "E-mail",
				"firstName": "Όνομα",
				"lastName": "Επώνυμο",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"pagination": {
				"showing": "{{from}}–{{to}} από {{total}}"
			}
		},
		"settings": {
			"title": "Παράμετροι",
			"count": "{{count}} παράμετροι",
			"add": "Νέα παράμετρος",
			"addTitle": "Νέα παράμετρος",
			"editTitle": "Επεξεργασία παραμέτρου",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της παραμέτρου.",
			"baseSite": "Βασική (όλα τα sites)",
			"deleteTitle": "Διαγραφή παραμέτρου",
			"deleteBody": "Να διαγραφεί η παράμετρος «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Παράμετρος",
				"value": "Τιμή",
				"site": "Site"
			},
			"pagination": {
				"showing": "{{from}}–{{to}} από {{total}}"
			}
		},
		"grid": {
			"showing": "Εμφάνιση",
			"of": "από",
			"columns": "Στήλες",
			"columnsTitle": "Ορατές στήλες",
			"columnsReset": "Επαναφορά στηλών",
			"export": "Εξαγωγή σε Excel",
			"rowsPerPage": "Γραμμές ανά σελίδα",
			"comfortable": "Άνετη προβολή",
			"compact": "Συμπαγής προβολή",
			"first": "Πρώτη σελίδα",
			"prev": "Προηγούμενη",
			"next": "Επόμενη",
			"last": "Τελευταία σελίδα"
		},
		"countryRegions": {
			"title": "Νομοί",
			"add": "Νέος νομός",
			"addTitle": "Νέος νομός",
			"editTitle": "Επεξεργασία νομού",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του νομού.",
			"countryPlaceholder": "Επιλέξτε χώρα",
			"deleteTitle": "Διαγραφή νομού",
			"deleteBody": "Να διαγραφεί ο νομός «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"country": "Χώρα",
				"name": "Όνομα",
				"code": "Κωδικός",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"cities": {
			"title": "Πόλεις",
			"add": "Νέα πόλη",
			"addTitle": "Νέα πόλη",
			"editTitle": "Επεξεργασία πόλης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της πόλης.",
			"regionPlaceholder": "Επιλέξτε νομό",
			"deleteTitle": "Διαγραφή πόλης",
			"deleteBody": "Να διαγραφεί η πόλη «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"region": "Νομός",
				"name": "Όνομα",
				"code": "Κωδικός",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"systemLog": {
			"title": "Αρχείο καταγραφών",
			"columns": {
				"date": "Ημερομηνία",
				"level": "Επίπεδο",
				"module": "Module",
				"message": "Μήνυμα",
				"raw": "Raw Data"
			}
		},
		"erpLogs": {
			"title": "Σφάλματα ERP",
			"columns": {
				"date": "Ημερομηνία",
				"severity": "Σοβαρότητα",
				"service": "Υπηρεσία",
				"host": "Διακομιστής",
				"task": "Εργασία",
				"message": "Μήνυμα",
				"trace": "Trace ID"
			},
			"viewDetail": "Προβολή λεπτομερειών",
			"detail": {
				"title": "Λεπτομέρειες σφάλματος ERP",
				"copy": "Αντιγραφή μηνύματος",
				"copied": "Αντιγράφηκε"
			}
		},
		"activityLog": {
			"title": "Ιστορικό Ενεργειών",
			"columns": {
				"when": "Πότε",
				"actorRole": "Χρήστης / Ρόλος",
				"role": "Ρόλος",
				"action": "Ενέργεια",
				"entity": "Εγγραφή",
				"changedFields": "Πεδία που άλλαξαν",
				"permissions": "Δικαιώματα ρόλου",
				"ip": "Διεύθυνση IP",
				"endpoint": "Endpoint"
			},
			"filters": {
				"period": "Περίοδος",
				"last1": "24 ώρες",
				"last7": "7 ημέρες",
				"last30": "30 ημέρες",
				"action": "Ενέργεια",
				"allActions": "Όλες οι ενέργειες",
				"role": "Ρόλος",
				"allRoles": "Όλοι οι ρόλοι"
			},
			"actions": {
				"insert": "Δημιουργία",
				"update": "Τροποποίηση",
				"delete": "Διαγραφή",
				"restore": "Επαναφορά",
				"login": "Είσοδος",
				"logout": "Έξοδος",
				"loginFailed": "Αποτυχία εισόδου",
				"impersonationStart": "Έναρξη impersonation"
			},
			"actorKinds": {
				"system": "Σύστημα",
				"customer": "Πελάτης",
				"customerEmployee": "Χρήστης πελάτη",
				"salesPerson": "Πωλητής",
				"apiKey": "Κλειδί API"
			},
			"changedFields": {
				"title": "Πεδία που άλλαξαν",
				"open": "Εμφάνιση όλων των πεδίων που άλλαξαν"
			},
			"permissionsCount_one": "{{count}} δικαίωμα",
			"permissionsCount_other": "{{count}} δικαιώματα"
		},
		"robotsFile": {
			"title": "robots.txt",
			"subtitle": "Σερβίρεται ως απλό κείμενο στους crawlers των μηχανών αναζήτησης· χρησιμοποιείται και για το φιλτράρισμα του sitemap.",
			"notManaged": "Αυτό είναι το robots.txt που σερβίρει αυτή τη στιγμή το site και δεν έχει αποθηκευτεί ακόμα εδώ. Αποθηκεύστε το για να το διαχειρίζεστε από το admin.",
			"notManagedPill": "Δεν έχει αποθηκευτεί",
			"size": "{{kb}} KB από {{maxKb}} KB",
			"lastModified": "Τελευταία αποθήκευση {{date}}",
			"propagationHint": "Οι αλλαγές εμφανίζονται στο site μέσα σε περίπου 5 λεπτά.",
			"saved": "Το robots.txt αποθηκεύτηκε",
			"loadFailed": "Αποτυχία φόρτωσης του robots.txt",
			"noAccess": "Δεν έχετε πρόσβαση σε αυτή τη σελίδα.",
			"errors": {
				"empty": "Το περιεχόμενο δεν μπορεί να είναι κενό",
				"tooLarge": "Το περιεχόμενο υπερβαίνει το μέγιστο επιτρεπτό μέγεθος"
			}
		},
		"sitemapPages": {
			"title": "Σελίδες Sitemap",
			"add": "Νέα σελίδα",
			"addTitle": "Νέα σελίδα Sitemap",
			"editTitle": "Επεξεργασία σελίδας Sitemap",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της σελίδας.",
			"deleteTitle": "Διαγραφή σελίδας",
			"deleteBody": "Να διαγραφεί η σελίδα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"url": "URL Πλοήγησης"
			}
		},
		"urlRedirects": {
			"title": "301 Ανακατευθύνσεις",
			"add": "Νέα ανακατεύθυνση",
			"addTitle": "Νέα ανακατεύθυνση",
			"editTitle": "Επεξεργασία ανακατεύθυνσης",
			"formSubtitle": "Συμπληρώστε το URL προέλευσης και προορισμού.",
			"deleteTitle": "Διαγραφή ανακατεύθυνσης",
			"deleteBody": "Να διαγραφεί η ανακατεύθυνση «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"from": "Από",
				"to": "Προς",
				"modified": "Τροποποίηση"
			}
		},
		"smsTemplates": {
			"title": "Sms Templates",
			"add": "Νέο template",
			"addTitle": "Νέο SMS template",
			"editTitle": "Επεξεργασία SMS template",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του template.",
			"channelSms": "SMS",
			"channelViber": "Viber",
			"viberImageUrl": "Viber Image URL",
			"viberActionUrl": "Viber Action URL",
			"viberActionText": "Viber Action Text",
			"deleteTitle": "Διαγραφή template",
			"deleteBody": "Να διαγραφεί το template «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"channel": "Κανάλι",
				"body": "Κείμενο",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"taxOffices": {
			"title": "Εφορίες (ΔΟΥ)",
			"add": "Νέα ΔΟΥ",
			"addTitle": "Νέα ΔΟΥ",
			"editTitle": "Επεξεργασία ΔΟΥ",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της ΔΟΥ.",
			"noCountry": "— Καμία —",
			"deleteTitle": "Διαγραφή ΔΟΥ",
			"deleteBody": "Να διαγραφεί η ΔΟΥ «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"country": "Χώρα",
				"description": "Περιγραφή",
				"address": "Διεύθυνση",
				"city": "Πόλη",
				"postalCode": "Ταχ. Κώδικας",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"userRoles": {
			"title": "Ρόλοι Χρηστών",
			"add": "Νέος ρόλος",
			"addTitle": "Νέος ρόλος",
			"editTitle": "Επεξεργασία ρόλου",
			"formSubtitle": "Συμπληρώστε τα στοιχεία και τα δικαιώματα του ρόλου.",
			"permissions": "Δικαιώματα",
			"permissionCount": "{{count}} / {{total}} δικαιώματα",
			"deleteTitle": "Διαγραφή ρόλου",
			"deleteBody": "Να διαγραφεί ο ρόλος «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"permissions": "Δικαιώματα",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"perms": {
				"perm_dashboard": "Πίνακας Ελέγχου",
				"perm_clg": "Κατάλογος",
				"perm_prc": "Τιμολόγηση",
				"perm_cust": "Πελάτες",
				"perm_ord": "Παραγγελίες",
				"perm_oe": "Καταχώρηση Παραγγελιών",
				"perm_oa": "Έγκριση Παραγγελιών",
				"perm_prompol": "Εμπορικές Πολιτικές",
				"perm_cms": "Διαχείριση Περιεχομένου",
				"perm_rep": "Αναφορές",
				"perm_bookings": "Κρατήσεις",
				"perm_sys": "Σύστημα"
			}
		},
		"postalCodes": {
			"title": "Ταχ. Κωδικοί",
			"add": "Νέος Τ.Κ.",
			"addTitle": "Νέος Ταχ. Κώδικας",
			"editTitle": "Επεξεργασία Ταχ. Κώδικα",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του ταχ. κώδικα.",
			"none": "— Κανένα —",
			"deleteTitle": "Διαγραφή Ταχ. Κώδικα",
			"deleteBody": "Να διαγραφεί ο ταχ. κώδικας «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"country": "Χώρα",
				"region": "Νομός",
				"area": "Περιοχή",
				"city": "Πόλη",
				"district": "Δήμος / Περιοχή",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"eventSubscriptions": {
			"title": "Event Subscriptions",
			"editTitle": "Επεξεργασία συνδρομής",
			"formSubtitle": "Επεξεργαστείτε το e-mail ειδοποίησης και την κατάσταση.",
			"active": "Ενεργή",
			"disabled": "Ανενεργή",
			"deleteTitle": "Διαγραφή συνδρομής",
			"deleteBody": "Να διαγραφεί η συνδρομή «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"type": "Τύπος",
				"email": "E-mail",
				"payload": "Payload",
				"status": "Κατάσταση",
				"disabled": "Ανενεργή"
			}
		},
		"sites": {
			"title": "Sites",
			"add": "Νέο site",
			"addTitle": "Νέο site",
			"editTitle": "Επεξεργασία site",
			"formSubtitle": "Επεξεργαστείτε τα στοιχεία του site.",
			"deleteTitle": "Διαγραφή site",
			"deleteBody": "Να διαγραφεί το site «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"crawlState": "Crawl State",
				"defLanguage": "Προεπιλ. Γλώσσα",
				"defCurrency": "Προεπιλ. Νόμισμα",
				"appendLanguagePrefix": "Πρόθεμα Γλώσσας",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"taskSchedules": {
			"title": "Προγρ/μένες Εργασίες",
			"add": "Νέα εργασία",
			"addTitle": "Νέα προγραμματισμένη εργασία",
			"editTitle": "Επεξεργασία εργασίας",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της εργασίας.",
			"noVerbosity": "— Προεπιλογή —",
			"errorEmail": "E-mail σφαλμάτων",
			"run": "Εκτέλεση τώρα",
			"runQueued": "Η εκτέλεση προγραμματίστηκε.",
			"deleteTitle": "Διαγραφή εργασίας",
			"deleteBody": "Να διαγραφεί η εργασία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"enabled": "Ενεργή",
				"interval": "Διάστημα",
				"lastRun": "Τελευταία Εκτέλεση",
				"nextRun": "Επόμενη Εκτέλεση",
				"verbosity": "Επίπεδο Logs",
				"lastOutcome": "Αποτέλεσμα",
				"heartbeat": "Σήμα ζωής"
			},
			"outcomeOk": "Επιτυχία",
			"outcomeFailed": "Αποτυχία"
		},
		"aiPendingActions": {
			"title": "Ενέργειες AI σε αναμονή",
			"tabs": {
				"pending": "Σε αναμονή ({{count}})",
				"all": "Όλες ({{count}})"
			},
			"columns": {
				"id": "#",
				"tool": "Εργαλείο",
				"arguments": "Παράμετροι",
				"requestedBy": "Αιτήθηκε από",
				"estimated": "Εκτίμηση εγγραφών",
				"status": "Κατάσταση",
				"requestedAt": "Ημ/νία αιτήματος",
				"decidedBy": "Αποφασίστηκε από",
				"decidedAt": "Ημ/νία απόφασης",
				"keyId": "Κλειδί"
			},
			"status": {
				"Pending": "Σε αναμονή",
				"Executing": "Εκτελείται",
				"Executed": "Εκτελέστηκε",
				"Rejected": "Απορρίφθηκε",
				"Failed": "Απέτυχε"
			},
			"details": "Λεπτομέρειες",
			"detailsTitle": "Ενέργεια #{{id}}",
			"detailsMeta": "Αιτήθηκε από {{requestedBy}} στις {{requestedAt}}",
			"detailsDecision": "Αποφασίστηκε από {{decidedBy}} στις {{decidedAt}}",
			"approve": "Έγκριση",
			"approveTitle": "Έγκριση ενέργειας #{{id}};",
			"approveBody": "Η ενέργεια «{{tool}}» θα εκτελεστεί αμέσως με τις παρακάτω παραμέτρους. Η εκτέλεση δεν αναιρείται.",
			"approveConfirm": "Έγκριση και εκτέλεση",
			"approvedToast": "Η ενέργεια εγκρίθηκε και εκτελέστηκε.",
			"executionFailedToast": "Η ενέργεια εγκρίθηκε αλλά η εκτέλεση απέτυχε — δείτε το ιστορικό.",
			"reject": "Απόρριψη",
			"rejectTitle": "Απόρριψη ενέργειας #{{id}};",
			"rejectBody": "Η ενέργεια «{{tool}}» δεν θα εκτελεστεί ποτέ.",
			"rejectedToast": "Η ενέργεια απορρίφθηκε — δεν εκτελέστηκε.",
			"conflictToast": "Διεκπεραιώθηκε ήδη από άλλον χειριστή."
		},
		"apiKeys": {
			"title": "API Keys",
			"add": "Νέο κλειδί",
			"addTitle": "Νέο API Key",
			"editTitle": "Επεξεργασία API Key",
			"formSubtitle": "Ορίστε όνομα, περιγραφή και τα επιτρεπόμενα endpoints.",
			"description": "Περιγραφή",
			"endpoints": "Endpoints",
			"endpointsPlaceholder": "Επιλέξτε endpoints…",
			"endpointCount": "{{count}} endpoints",
			"generate": "Δημιουργία",
			"active": "Ενεργό",
			"revoked": "Ανακλήθηκε",
			"regenerate": "Αναδημιουργία κλειδιού",
			"revoke": "Ανάκληση",
			"revokedToast": "Το κλειδί ανακλήθηκε.",
			"copy": "Αντιγραφή",
			"copied": "Αντιγράφηκε στο πρόχειρο.",
			"copyFailed": "Η αντιγραφή απέτυχε.",
			"secretTitle": "Μυστικό κλειδί: {{name}}",
			"secretSubtitle": "Αντιγράψτε το τώρα — δεν θα εμφανιστεί ξανά.",
			"secretWarning": "Αυτό είναι το μοναδικό σημείο που θα δείτε το πλήρες κλειδί. Αποθηκεύστε το με ασφάλεια.",
			"secretDone": "Το αποθήκευσα",
			"revokeTitle": "Ανάκληση API Key",
			"revokeBody": "Να ανακληθεί το κλειδί «{{name}}»; Θα πάψει αμέσως να λειτουργεί.",
			"deleteTitle": "Διαγραφή API Key",
			"deleteBody": "Να διαγραφεί το κλειδί «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"key": "Κλειδί",
				"endpoints": "Endpoints",
				"lastUsed": "Τελευταία Χρήση",
				"status": "Κατάσταση"
			}
		},
		"mcpKeys": {
			"title": "Κλειδιά MCP",
			"add": "Νέο κλειδί",
			"addTitle": "Έκδοση κλειδιού MCP",
			"editTitle": "Επεξεργασία κλειδιού MCP",
			"formSubtitle": "Συνδέστε λογαριασμό υπηρεσίας, επιλέξτε εργαλεία και εκδώστε το εφάπαξ token.",
			"context": "Πλαίσιο",
			"contextAdmin": "Διαχείριση",
			"contextFrontEnd": "Κατάστημα",
			"backingIdentity": "Συνδεδεμένος λογαριασμός",
			"backingHint": "Το κλειδί δεν μπορεί ποτέ να ξεπεράσει τα δικαιώματα του λογαριασμού του. Συνδέστε τα κλειδιά διαχείρισης σε αποκλειστικό λογαριασμό υπηρεσίας ελάχιστων δικαιωμάτων — ποτέ σε προσωπικό λογαριασμό.",
			"backingUser": "Λογαριασμός υπηρεσίας",
			"backingUserPlaceholder": "Επιλέξτε χρήστη…",
			"backingPickExisting": "Επιλογή υπάρχοντος χρήστη",
			"backingCreateNew": "Δημιουργία λογαριασμού υπηρεσίας",
			"serviceUserEmail": "E-mail",
			"serviceUserPassword": "Κωδικός πρόσβασης",
			"serviceUserFirstName": "Όνομα",
			"serviceUserLastName": "Επώνυμο",
			"serviceUserRole": "Ρόλος",
			"serviceUserRolePlaceholder": "Επιλέξτε ρόλο…",
			"serviceUserCreated": "Ο λογαριασμός υπηρεσίας {{email}} δημιουργήθηκε.",
			"serviceUserFailed": "Η δημιουργία λογαριασμού υπηρεσίας απέτυχε.",
			"backingCustomer": "Id πελάτη",
			"siteId": "Id ιστότοπου (προαιρετικό)",
			"identityFrozen": "Κλειδί {{context}} · λογαριασμός: {{backing}} (δεν αλλάζει μετά την έκδοση)",
			"grants": "Δικαιώματα εργαλείων",
			"grantsSummary": "{{granted}} εργαλεία · {{gated}} με έγκριση",
			"riskSafe": "Ασφαλή — αναγνώσεις",
			"riskSensitive": "Ευαίσθητα — εγγραφές",
			"riskDestructive": "Καταστροφικά — απαιτείται πάντα έγκριση",
			"approval": "Έγκριση",
			"approvalFor": "Απαίτηση έγκρισης για {{tool}}",
			"requiresPerms": "απαιτεί: {{perms}}",
			"sensitiveWaiverWarning": "Ευαίσθητα εργαλεία χωρίς έγκριση: {{tools}}. Κλήσεις κάτω από το όριο εμβέλειας θα εκτελούνται χωρίς ανθρώπινη έγκριση.",
			"missingPermsWarning": "Ο ρόλος «{{role}}» δεν έχει: {{perms}}. Εργαλεία που τα απαιτούν θα απορρίπτονται κατά την κλήση.",
			"mint": "Έκδοση κλειδιού",
			"active": "Ενεργό",
			"revoked": "Ανακλήθηκε",
			"regenerate": "Επανέκδοση token",
			"revoke": "Ανάκληση",
			"revokedToast": "Το κλειδί ανακλήθηκε.",
			"copy": "Αντιγραφή",
			"copied": "Αντιγράφηκε στο πρόχειρο.",
			"copyFailed": "Η αντιγραφή απέτυχε.",
			"secretTitle": "Token MCP: {{name}}",
			"secretSubtitle": "Αντιγράψτε το τώρα — δεν θα εμφανιστεί ξανά.",
			"secretWarning": "Το πλήρες token εμφανίζεται μόνο αυτή τη φορά. Αποθηκεύεται μόνο το αποτύπωμά του.",
			"connectHint": "Συνδέστε τον MCP client σας (π.χ. Claude Code) στο /mcp με την κεφαλίδα",
			"secretDone": "Το αποθήκευσα",
			"revokeTitle": "Ανάκληση κλειδιού MCP",
			"revokeBody": "Ανάκληση του κλειδιού «{{name}}»; Η πρόσβαση του agent σταματά αμέσως.",
			"deleteTitle": "Διαγραφή κλειδιού MCP",
			"deleteBody": "Διαγραφή του κλειδιού «{{name}}»; Δεν μπορεί να αναιρεθεί.",
			"toolCount": "{{count}} εργαλεία",
			"columns": {
				"name": "Όνομα",
				"key": "Κλειδί",
				"context": "Πλαίσιο",
				"tools": "Εργαλεία",
				"lastUsed": "Τελευταία χρήση",
				"status": "Κατάσταση"
			}
		},
		"emailTemplates": {
			"title": "E-mail Templates",
			"add": "Νέο template",
			"addTitle": "Νέο E-mail Template",
			"editTitle": "Επεξεργασία E-mail Template",
			"formSubtitle": "Συμπληρώστε τα στοιχεία, τους παραλήπτες και το κείμενο.",
			"untitled": "Νέο template",
			"settings": "Ρυθμίσεις",
			"recipientsSubtitle": "Διαχωρίστε πολλαπλές τιμές με κόμμα ή νέα γραμμή.",
			"bodySubtitle": "Το περιεχόμενο HTML του e-mail.",
			"engineBizweb": "Bizweb",
			"engineHandlebars": "Handlebars",
			"allSites": "Όλα τα sites",
			"fromName": "Όνομα Αποστολέα",
			"toNames": "Ονόματα Προς",
			"toEmails": "E-mails Προς",
			"ccNames": "Ονόματα Cc",
			"ccEmails": "E-mails Cc",
			"bccNames": "Ονόματα Bcc",
			"bccEmails": "E-mails Bcc",
			"deleteTitle": "Διαγραφή template",
			"deleteBody": "Να διαγραφεί το template «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"tabs": {
				"basics": "Βασικά",
				"recipients": "Παραλήπτες",
				"body": "Κείμενο"
			},
			"columns": {
				"code": "Κωδικός",
				"subject": "Θέμα",
				"fromEmail": "E-mail Αποστολέα",
				"type": "Τύπος",
				"site": "Site",
				"body": "Κείμενο (HTML)",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"preview": {
				"open": "Προεπισκόπηση",
				"title": "Προεπισκόπηση «{{code}}»",
				"subtitle": "Εμφανίζει το τρέχον, μη αποθηκευμένο πρότυπο με τα παρακάτω δεδομένα. Τίποτα δεν αποθηκεύεται ή αποστέλλεται.",
				"loadFromOrder": "Φόρτωση δεδομένων από παραγγελία",
				"orderSearchPlaceholder": "Κωδικός παραγγελίας, όνομα ή e-mail πελάτη",
				"noOrders": "Δεν βρέθηκαν παραγγελίες",
				"orderNotFound": "Η παραγγελία δεν βρέθηκε",
				"orderLoadFailed": "Δεν ήταν δυνατή η φόρτωση των δεδομένων της παραγγελίας",
				"sampleData": "Δεδομένα δείγματος (JSON)",
				"resetSample": "Επαναφορά δείγματος",
				"invalidJson": "Μη έγκυρο JSON: {{error}}",
				"handlebarsOnly": "Η προεπισκόπηση είναι διαθέσιμη μόνο για πρότυπα Handlebars. Αλλάξτε τον τύπο του προτύπου σε Handlebars για προεπισκόπηση.",
				"frameTitle": "Προεπισκόπηση e-mail"
			}
		},
		"availableDates": {
			"title": "Διαθέσιμες Ημερομηνίες",
			"add": "Νέο ημερολόγιο",
			"addTitle": "Νέο ημερολόγιο εργασίας",
			"editTitle": "Επεξεργασία ημερολογίου",
			"formSubtitle": "Ορίστε έτος και ρυθμίσεις ημερολογίου.",
			"manageWorkDays": "Ημέρες εργασίας",
			"manageExceptions": "Εξαιρέσεις",
			"workDaysTitle": "Ημέρες εργασίας — {{year}}",
			"exceptionDaysTitle": "Εξαιρέσεις — {{year}}",
			"addDay": "Προσθήκη ημέρας",
			"addException": "Προσθήκη εξαίρεσης",
			"startTime": "Έναρξη",
			"endTime": "Λήξη",
			"startTime2": "Έναρξη (2)",
			"endTime2": "Λήξη (2)",
			"cutOffTime": "Ώρα cut-off",
			"fc": "Ημέρες προετοιμασίας",
			"deleteTitle": "Διαγραφή ημερολογίου",
			"deleteBody": "Να διαγραφεί το ημερολόγιο του {{year}}; Η ενέργεια δεν αναιρείται.",
			"days": {
				"Monday": "Δευτέρα",
				"Tuesday": "Τρίτη",
				"Wednesday": "Τετάρτη",
				"Thursday": "Πέμπτη",
				"Friday": "Παρασκευή",
				"Saturday": "Σάββατο",
				"Sunday": "Κυριακή"
			},
			"dayTypes": {
				"Working": "Εργάσιμη",
				"NonWorking": "Μη εργάσιμη"
			},
			"columns": {
				"year": "Έτος",
				"weeklyLimit": "Εβδομαδιαίο όριο",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"day": "Ημέρα",
				"date": "Ημερομηνία",
				"dayType": "Τύπος"
			}
		},
		"fields": {
			"erpCode": "Κωδικός ERP",
			"phone": "Τηλέφωνο",
			"paramGroup": "Ομάδα παραμέτρων",
			"description": "Περιγραφή",
			"createdAt": "Δημιουργήθηκε",
			"createdBy": "Δημιουργήθηκε από",
			"lastUsedIp": "IP τελ. χρήσης",
			"userAgent": "User Agent",
			"revokedAt": "Ημ/νία ανάκλησης",
			"lastRunEnd": "Τέλος τελ. εκτέλεσης",
			"firstRun": "Πρώτη εκτέλεση",
			"fromName": "Όνομα αποστολέα",
			"body": "Κείμενο"
		}
	},
	"catalog": {
		"relationTypes": {
			"title": "Τύποι Σχέσεων",
			"add": "Νέος τύπος σχέσης",
			"addTitle": "Νέος τύπος σχέσης",
			"editTitle": "Επεξεργασία τύπου σχέσης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του τύπου σχέσης.",
			"deleteTitle": "Διαγραφή τύπου σχέσης",
			"deleteBody": "Διαγραφή του τύπου σχέσης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"description": "Περιγραφή",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"seasons": {
			"title": "Σεζόν",
			"add": "Νέα σεζόν",
			"addTitle": "Νέα σεζόν",
			"editTitle": "Επεξεργασία σεζόν",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της σεζόν.",
			"deleteTitle": "Διαγραφή σεζόν",
			"deleteBody": "Διαγραφή της σεζόν «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"startDate": "Ημ. Έναρξης",
				"endDate": "Ημ. Λήξης",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"models": {
			"title": "Μοντέλα",
			"add": "Νέο μοντέλο",
			"addTitle": "Νέο μοντέλο",
			"editTitle": "Επεξεργασία μοντέλου",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του μοντέλου.",
			"deleteTitle": "Διαγραφή μοντέλου",
			"deleteBody": "Διαγραφή του μοντέλου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"erpCode": "Κωδικός ERP",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"warehouses": {
			"title": "Αποθήκες",
			"add": "Νέα αποθήκη",
			"addTitle": "Νέα αποθήκη",
			"editTitle": "Επεξεργασία αποθήκης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της αποθήκης.",
			"deleteTitle": "Διαγραφή αποθήκης",
			"deleteBody": "Διαγραφή της αποθήκης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectType": "Επιλέξτε τύπο…",
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"type": "Τύπος",
				"disabled": "Ανενεργή",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"themeTemplates": {
			"title": "Πρότυπα Θεμάτων",
			"add": "Νέο πρότυπο θέματος",
			"addTitle": "Νέο πρότυπο θέματος",
			"editTitle": "Επεξεργασία προτύπου θέματος",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του προτύπου θέματος.",
			"deleteTitle": "Διαγραφή προτύπου θέματος",
			"deleteBody": "Διαγραφή του προτύπου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"isForProducts": "Για Προϊόντα",
				"isForCategories": "Για Κατηγορίες"
			}
		},
		"wishlistTemplates": {
			"title": "Πρότυπα Wishlist",
			"add": "Νέο πρότυπο wishlist",
			"addTitle": "Νέο πρότυπο wishlist",
			"editTitle": "Επεξεργασία προτύπου wishlist",
			"formSubtitle": "Συμπληρώστε τα στοιχεία και τα προϊόντα του προτύπου.",
			"deleteTitle": "Διαγραφή προτύπου wishlist",
			"deleteBody": "Διαγραφή του προτύπου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"searchProducts": "Αναζήτηση προϊόντων…",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"products": "Προϊόντα",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"filterTemplates": {
			"title": "Πρότυπα Φίλτρων",
			"add": "Νέο πρότυπο φίλτρων",
			"addTitle": "Νέο πρότυπο φίλτρων",
			"editTitle": "Επεξεργασία προτύπου φίλτρων",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του προτύπου.",
			"deleteTitle": "Διαγραφή προτύπου φίλτρων",
			"deleteBody": "Διαγραφή του προτύπου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"filters": "Φίλτρα",
			"filtersTitle": "Φίλτρα προτύπου",
			"filterCount": "{{count}} φίλτρα",
			"orderHint": "Σύρετε τις γραμμές για να ορίσετε τη σειρά των φίλτρων στο κατάστημα. Όσα φίλτρα δεν υπάρχουν εδώ δεν εμφανίζονται.",
			"dragToReorder": "Σύρετε για αλλαγή σειράς",
			"addFilters": "Προσθήκη φίλτρων",
			"addFiltersTitle": "Προσθήκη φίλτρων",
			"addFiltersSubtitle": "Επιλέξτε φίλτρα για προσθήκη στο πρότυπο.",
			"noAvailableFilters": "Δεν υπάρχουν διαθέσιμα φίλτρα.",
			"addSelected": "Προσθήκη ({{count}})",
			"deleteFilterTitle": "Αφαίρεση φίλτρου",
			"deleteFilterBody": "Αφαίρεση του φίλτρου «{{name}}» από το πρότυπο;",
			"copy": "Δημιουργία αντιγράφου",
			"copyTitle": "Αντίγραφο του «{{name}}»",
			"copyBody": "Το αντίγραφο δημιουργείται με όλα τα φίλτρα, χωρίς κατηγορίες, και εμφανίζεται ακριβώς κάτω από το αρχικό. Οι κατηγορίες μένουν στο αρχικό πρότυπο· για να χρησιμοποιήσει μια κατηγορία το αντίγραφο, επιλέξτε το στο πεδίο «Πρότυπο φίλτρων» της κατηγορίας.",
			"copyNameSuffix": "Αντίγραφο",
			"copied": "Το αντίγραφο δημιουργήθηκε",
			"columns": {
				"name": "Όνομα",
				"isDefault": "Προεπιλογή",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"isManufacturerDefault": "Προεπιλογή κατασκευαστή"
			},
			"filterColumns": {
				"name": "Φίλτρο",
				"extended": "Εκτεταμένο",
				"singleSelect": "Μονή επιλογή",
				"showInWizard": "Στον οδηγό",
				"featured": "Προβεβλημένο",
				"imageFilter": "Φίλτρο εικόνας"
			},
			"settings": {
				"title": "Ρυθμίσεις φίλτρου",
				"toolTip": "Tooltip",
				"toolTipPlaceholder": "Κείμενο που εμφανίζεται με hover δίπλα στο φίλτρο…",
				"categoryFilterMode": "Εμφάνιση κατηγοριών",
				"modes": {
					"default": "Προεπιλογή (υποκατηγορίες)",
					"subcategories": "Υποκατηγορίες",
					"siblings": "Αδελφές κατηγορίες",
					"byLevel": "Κατηγορίες επιπέδου"
				},
				"categoryNestingDepth": "Βάθος υποκατηγοριών",
				"categoryNestingDepthHelp": "Πόσα επίπεδα υποκατηγοριών εμφανίζονται. Κενό ή 1 = μόνο οι άμεσες, -1 = όλα τα επίπεδα.",
				"categoryLevel": "Επίπεδο κατηγορίας",
				"categoryLevelHelp": "Το επίπεδο του δέντρου του οποίου οι κατηγορίες εμφανίζονται (1 = πρώτο). Κενό ή -1 = όλα τα επίπεδα."
			}
		},
		"statuses": {
			"title": "Καταστάσεις",
			"add": "Νέα κατάσταση",
			"untitled": "Νέα κατάσταση",
			"notFound": "Η κατάσταση δεν βρέθηκε.",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατή",
			"statusHidden": "Κρυφή",
			"schedulingTitle": "Προγραμματισμός",
			"schedulingSubtitle": "Προαιρετικό χρονικό παράθυρο εμφάνισης.",
			"startDate": "Ημ/νία έναρξης",
			"endDate": "Ημ/νία λήξης",
			"deleteTitle": "Διαγραφή κατάστασης",
			"deleteBody": "Διαγραφή της κατάστασης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"entityUrl": "URL σελίδας",
			"color": "Χρώμα",
			"textColor": "Χρώμα κειμένου",
			"headerTitle": "Τίτλος επικεφαλίδας (H1)",
			"metaTitle": "Meta τίτλος",
			"metaKeywords": "Meta λέξεις-κλειδιά",
			"metaDescription": "Meta περιγραφή",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Απενεργοποίηση indexation",
			"disableFollow": "Απενεργοποίηση follow",
			"image": "Εικόνα",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"bodyPlaceholder": "Κείμενο περιγραφής…",
			"tabs": {
				"general": "Γενικά",
				"seo": "SEO",
				"content": "Κείμενο",
				"image": "Εικόνα"
			},
			"columns": {
				"image": "Εικόνα",
				"code": "Κωδικός",
				"name": "Όνομα",
				"disableCart": "Απενεργοποίηση καλαθιού",
				"showAsTag": "Εμφάνιση ως tag",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"tooltip": "Tooltip",
			"tooltipHelp": "Κείμενο που εμφανίζεται με hover δίπλα στην κατάσταση στο κατάστημα."
		},
		"manufacturers": {
			"title": "Κατασκευαστές",
			"add": "Νέος κατασκευαστής",
			"untitled": "Νέος κατασκευαστής",
			"notFound": "Ο κατασκευαστής δεν βρέθηκε.",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατός",
			"statusHidden": "Κρυφός",
			"deleteTitle": "Διαγραφή κατασκευαστή",
			"deleteBody": "Διαγραφή του κατασκευαστή «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"code": "Κωδικός",
			"entityUrl": "URL σελίδας",
			"landingUrl": "Landing URL",
			"erpCode": "Κωδικός ERP",
			"erpCode2": "Κωδικός ERP 2",
			"filterTemplate": "Πρότυπο φίλτρων",
			"selectFilterTemplate": "Επιλέξτε πρότυπο…",
			"noFilterTemplate": "— Κανένα —",
			"isTopPage": "Top page",
			"headerTitle": "Τίτλος επικεφαλίδας (H1)",
			"metaTitle": "Meta τίτλος",
			"metaKeywords": "Meta λέξεις-κλειδιά",
			"metaDescription": "Meta περιγραφή",
			"disableIndexation": "Απενεργοποίηση indexation",
			"disableFollow": "Απενεργοποίηση follow",
			"descriptionPlaceholder": "Περιγραφή κατασκευαστή…",
			"image1": "Εικόνα 1",
			"image2": "Εικόνα 2",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"garan": {
				"title": "Προεπιλογές GARAN",
				"subtitle": "Εμπορική εγγύηση ανθεκτικότητας (Καν. ΕΕ 2025/1960). Εφαρμόζεται από προεπιλογή στα προϊόντα αυτού του παραγωγού· κάθε προϊόν μπορεί να την υπερισχύσει.",
				"enabled": "Ενεργοποίηση GARAN από προεπιλογή",
				"years": "Προεπιλεγμένη διάρκεια (έτη)",
				"yearsHelp": "Πρέπει να υπερβαίνει τα 2 έτη για να ισχύει η σήμανση."
			},
			"tabs": {
				"general": "Γενικά",
				"seo": "SEO",
				"content": "Περιγραφή",
				"images": "Εικόνες"
			},
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"code": "Κωδικός",
				"featured": "Προβεβλημένος",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"staticPageUrl": "URL στατικής σελίδας",
			"staticPageUrlHelp": "Αν οριστεί, οι σύνδεσμοι του καταστήματος προς τον κατασκευαστή οδηγούν εδώ αντί για την προεπιλεγμένη σελίδα."
		},
		"categories": {
			"title": "Κατηγορίες",
			"subtitle": "{{count}} κατηγορίες",
			"add": "Νέα κατηγορία",
			"untitled": "Νέα κατηγορία",
			"notFound": "Η κατηγορία δεν βρέθηκε.",
			"dynamic": "Δυναμική",
			"hidden": "Κρυφή",
			"productCount": "Προϊόντα",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατή",
			"statusHidden": "Κρυφή",
			"flagsTitle": "Επιλογές",
			"customerGroupsTitle": "Προφίλ πελατών",
			"customerGroupsSubtitle": "Περιορισμός ορατότητας σε συγκεκριμένα προφίλ πελατών.",
			"selectCustomerGroups": "Επιλέξτε προφίλ…",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Διαγραφή κατηγορίας «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"deleteWithChildrenBody": "Η «{{name}}» έχει υποκατηγορίες. Να διαγραφούν κι αυτές ή να μετακινηθούν ένα επίπεδο πάνω;",
			"deleteKeepChildren": "Διατήρηση υποκατηγοριών",
			"deleteAll": "Διαγραφή όλων",
			"code": "Κωδικός",
			"entityUrl": "SEO Url",
			"productSort": "Σειρά προϊόντων",
			"discount": "Έκπτωση (%)",
			"erpCode": "Κωδικός ERP",
			"filterTemplate": "Πρότυπο φίλτρων",
			"selectFilterTemplate": "Επιλέξτε πρότυπο…",
			"noFilterTemplate": "— Κανένα —",
			"categoryWizard": "Οδηγός κατηγορίας",
			"noCategoryWizard": "— Κανένα —",
			"cacheRevalidation": "Cache Revalidation",
			"cacheRevalidationInterval": "Διάστημα revalidation (λεπτά)",
			"isDynamic": "Δυναμική κατηγορία",
			"filtersSubtitle": "Αυτόματη συμπλήρωση της κατηγορίας από δυναμικά φίλτρα.",
			"productFilters": "Δυναμικά φίλτρα",
			"excludedProductFilters": "Εξαιρούμενα φίλτρα",
			"selectProductFilters": "Επιλέξτε φίλτρα…",
			"infoText": "Κείμενο περιγραφής ({{n}})",
			"infoTextPlaceholder": "Περιγραφή κατηγορίας…",
			"image": "Εικόνα {{n}}",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"headerTitle": "Header Title (H1)",
			"metaTitle": "Meta Title",
			"metaKeywords": "Meta Keywords",
			"metaDescription": "Meta Description",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Απενεργοποίηση indexation",
			"disableFollow": "Απενεργοποίηση follow",
			"parent": "Γονική κατηγορία",
			"noParent": "— Πρώτο επίπεδο —",
			"color": "Χρώμα",
			"walkTree": "Walk tree",
			"showZeroQty": "Εμφάνιση μηδενικής ποσότητας",
			"landingPage": "Landing page",
			"topPage": "Top page",
			"excludeFromSubcategory": "Εξαίρεση από υποκατηγορία",
			"excludeFromRelated": "Εξαίρεση από σχετικές κατηγορίες",
			"frontExclusion": "Front exclusion",
			"highlighted": "Επισήμανση",
			"tabs": {
				"general": "Βασικά στοιχεία",
				"filters": "Δυναμικά φίλτρα",
				"descriptions": "Περιγραφές",
				"images": "Εικόνες",
				"seo": "SEO",
				"returnPolicy": "Επιστροφές προϊόντων"
			},
			"columns": {
				"name": "Όνομα",
				"visible": "Ορατή",
				"sort": "Σειρά",
				"dynamic": "Δυναμική",
				"productSort": "Σειρά προϊόντων",
				"filterTemplate": "Πρότυπο φίλτρων",
				"color": "Χρώμα",
				"productCount": "Προϊόντα",
				"code": "Κωδικός",
				"erpCode": "Κωδ. ERP",
				"categoryWizard": "Οδηγός κατηγορίας",
				"walkTree": "Walk tree",
				"showZeroQty": "Μηδ. ποσότητα",
				"landingPage": "Landing",
				"topPage": "Top page",
				"excludeSubcategory": "Εξαίρ. υποκατ.",
				"excludeRelated": "Εξαίρ. σχετικές",
				"frontExclusion": "Front excl.",
				"highlighted": "Επισήμανση"
			},
			"relations": {
				"manage": "Διαχείριση",
				"products": "Προϊόντα",
				"manufacturers": "Κατασκευαστές",
				"news": "Νέα",
				"attributes": "Χαρακτηριστικά",
				"faq": "Συχνές ερωτήσεις",
				"themeTemplates": "Πρότυπα θεμάτων",
				"count": "{{count}} εγγραφές",
				"capped": "Εμφάνιση πρώτων {{shown}} από {{total}} — περιορίστε την αναζήτηση",
				"colName": "Όνομα",
				"colCode": "Κωδικός",
				"colSort": "Σειρά",
				"colFeatured": "Προβολή",
				"colHidden": "Κρυφό",
				"colTitle": "Τίτλος",
				"productsTitle": "Προβεβλημένα προϊόντα · {{name}}",
				"productsSubtitle": "Ορίστε ποια προϊόντα προβάλλονται σε αυτή την κατηγορία.",
				"manufacturersTitle": "Κατασκευαστές · {{name}}",
				"manufacturersSubtitle": "Προσθήκη, ταξινόμηση, προβολή ή αφαίρεση κατασκευαστών στην κατηγορία.",
				"selectManufacturer": "Επιλέξτε κατασκευαστή…",
				"newsTitle": "Νέα · {{name}}",
				"newsSubtitle": "Ταξινόμηση, προβολή ή αφαίρεση νέων στην κατηγορία.",
				"newsAddDeferred": "Η προσθήκη νέων γίνεται από τη σελίδα Νέα (εκκρεμεί εδώ).",
				"attributesTitle": "Χαρακτηριστικά · {{name}}",
				"attributesSubtitle": "Ορίστε κρυφό / προβεβλημένο για τα χαρακτηριστικά της κατηγορίας."
			},
			"buyGuide": "Οδηγός αγοράς",
			"buyGuideHelp": "Εμφανίζεται στις σελίδες των προϊόντων της κατηγορίας.",
			"noBuyGuide": "— Κανένας —",
			"staticPageUrl": "URL στατικής σελίδας",
			"staticPageUrlHelp": "Αν οριστεί, τα breadcrumbs και οι σύνδεσμοι σχετικών κατηγοριών οδηγούν εδώ αντί για την προεπιλεγμένη σελίδα.",
			"googleTaxonomyId": "Google taxonomy ID",
			"googleTaxonomyIdHelp": "Κωδικός κατηγορίας Google που χρησιμοποιείται στα product feeds."
		},
		"filters": {
			"title": "Δυναμικά Φίλτρα",
			"add": "Νέο φίλτρο",
			"addTitle": "Νέο δυναμικό φίλτρο",
			"editTitle": "Επεξεργασία φίλτρου",
			"formSubtitle": "Όνομα και περιγραφή του φίλτρου· οι συνθήκες ορίζονται ξεχωριστά.",
			"editDefinition": "Επεξεργασία συνθηκών",
			"builderTitle": "Συνθήκες · {{name}}",
			"builderSubtitle": "Συνδυάστε συνθήκες με AND / ANY / NOT για να ορίσετε ποια προϊόντα ταιριάζουν.",
			"deleteTitle": "Διαγραφή φίλτρου",
			"deleteBody": "Διαγραφή φίλτρου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectFilter": "Επιλέξτε συνθήκη…",
			"combine": "Συνδυασμός",
			"conditions": "Συνθήκες",
			"addCondition": "Προσθήκη συνθήκης",
			"unwrap": "Αφαίρεση ομάδας (διατήρηση πρώτης συνθήκης)",
			"operand": "Τελεστής",
			"operandRequired": "Ο τελεστής είναι υποχρεωτικός",
			"from": "Από",
			"to": "Έως",
			"value": "Τιμή",
			"limit": "Όριο",
			"topSellingLimit": "Όριο",
			"dayWindow": "Παράθυρο ημερών",
			"searchFields": "Πεδία (κενό = όλα)",
			"term": "Όρος",
			"selectEntities": "Επιλέξτε…",
			"metricType": "Τύπος μετρικής…",
			"addMetricCondition": "Προσθήκη συνθήκης μετρικής",
			"manualRun": "Χειροκίνητη εκτέλεση",
			"manualRunHelp": "Εξαιρείται από τον αυτόματο υπολογισμό· υπολογίζεται και εφαρμόζει αναθέσεις μόνο με «Εκτέλεση».",
			"run": "Εκτέλεση τώρα",
			"runDone": "Το φίλτρο υπολογίστηκε",
			"neverRun": "Δεν έχει εκτελεστεί",
			"assignments": {
				"edit": "Αναθέσεις",
				"title": "Αναθέσεις: {{name}}",
				"subtitle": "Καταστάσεις και τιμές χαρακτηριστικών που δίνονται στα προϊόντα του φίλτρου και αφαιρούνται όταν ένα προϊόν πάψει να ταιριάζει. Τιμές που έχει ήδη ένα προϊόν δεν αγγίζονται.",
				"manualNote": "Η χειροκίνητη εκτέλεση είναι ενεργή: εφαρμόζονται στην επόμενη «Εκτέλεση».",
				"statuses": "Καταστάσεις",
				"attributes": "Χαρακτηριστικά",
				"attribute": "Χαρακτηριστικό…",
				"addAttribute": "Προσθήκη χαρακτηριστικού"
			},
			"advancedUnsupported": "Σύνθετη συνθήκη — επεξεργασία στο παλιό admin (διατηρείται στην αποθήκευση).",
			"columns": {
				"name": "Όνομα",
				"description": "Περιγραφή",
				"manualRun": "Χειροκίνητη (τελευταία)"
			},
			"types": {
				"daysSinceCreation": "Ημέρες από δημιουργία",
				"daysSinceRelease": "Ημέρες από κυκλοφορία",
				"discount": "Έκπτωση",
				"initialPrice": "Αρχική τιμή",
				"finalPrice": "Τελική τιμή",
				"quantity": "Ποσότητα",
				"bestSellers": "Ευπώλητα",
				"topSelling": "Κορυφαία σε πωλήσεις",
				"searchTerm": "Όρος αναζήτησης",
				"inCategories": "Σε κατηγορίες",
				"hasStatuses": "Έχει καταστάσεις",
				"hasManufacturers": "Έχει κατασκευαστές",
				"hasSubTypes": "Έχει υποτύπους",
				"hasAvailabilities": "Έχει διαθεσιμότητες",
				"hasAvailableStock": "Διαθέσιμο σε αποθήκη",
				"metricTypes": "Τύποι μετρικών",
				"hasModels": "Έχει μοντέλα",
				"productAttribute": "Χαρακτηριστικό προϊόντος",
				"discountBetweenPriceTypes": "Έκπτωση μεταξύ τύπων τιμής",
				"promotedByPolicy": "Προωθείται από πολιτική",
				"partakesInPolicy": "Συμμετέχει σε πολιτική"
			}
		},
		"reviews": {
			"excludedGroups": {
				"button": "Εξαιρούμενα προφίλ πελατών",
				"title": "Εξαιρούμενα προφίλ πελατών",
				"subtitle": "Τα μέλη αυτών των προφίλ δεν μπορούν να γράψουν αξιολογήσεις.",
				"group": "Προφίλ πελατών",
				"selectGroup": "Επιλέξτε προφίλ…",
				"add": "Προσθήκη"
			},
			"title": "Αξιολογήσεις",
			"editTitle": "Επεξεργασία αξιολόγησης",
			"title_field": "Τίτλος",
			"comment": "Σχόλιο",
			"featured": "Προβεβλημένη",
			"allStatuses": "Όλες οι καταστάσεις",
			"any": "Όλα",
			"ratingFrom": "Βαθμολογία από",
			"ratingTo": "Βαθμολογία έως",
			"dateFrom": "Ημ/νία από",
			"dateTo": "Ημ/νία έως",
			"clearFilters": "Καθαρισμός φίλτρων",
			"approve": "Έγκριση",
			"decline": "Απόρριψη",
			"deleteTitle": "Διαγραφή αξιολόγησης",
			"deleteBody": "Διαγραφή της αξιολόγησης; Η ενέργεια δεν αναιρείται.",
			"addButton": "Νέα κριτική",
			"addTitle": "Νέα κριτική συντελεστή",
			"addSubtitle": "Κριτική από συντελεστή ή έντυπο, που εμφανίζεται στη σελίδα του προϊόντος.",
			"openTarget": "Άνοιγμα στο κατάστημα",
			"targetType": "Τύπος αξιολογούμενου",
			"allTargetTypes": "Όλοι οι τύποι",
			"targetReadOnly": "Αλλάζει μόνο το προϊόν· η αξιολόγηση άλλου είδους μένει σε αυτό που αφορά.",
			"targets": {
				"product": "Προϊόν",
				"contributor": "Συντελεστής",
				"brand": "Μάρκα",
				"contentPage": "Σελίδα περιεχομένου",
				"customer": "Πελάτης",
				"other": "Άλλο"
			},
			"author": {
				"customer": "Πελάτης",
				"editorial": "Κριτική συντελεστή"
			},
			"tabs": {
				"customer": "Σχόλια πελατών",
				"contributor": "Κριτικές συντελεστών",
				"recommendations": "Προτάσεις"
			},
			"columns": {
				"product": "Προϊόν",
				"target": "Αξιολογούμενο",
				"reviewer": "Αξιολογητής",
				"rating": "Βαθμολογία",
				"status": "Κατάσταση",
				"date": "Ημερομηνία",
				"comment": "Σχόλιο",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"helpful": "Χρήσιμη",
				"openReports": "Ανοιχτές αναφορές"
			},
			"fields": {
				"contributor": "Συντελεστής",
				"category": "Κατηγορία συντελεστή",
				"reviewer": "Αξιολογητής (κείμενο)",
				"source": "Πηγή",
				"pickContributor": "Επιλέξτε συντελεστή…",
				"searchContributor": "Αναζήτηση με όνομα ή επώνυμο…",
				"searchContributorHint": "Πληκτρολογήστε όνομα για αναζήτηση"
			},
			"export": {
				"button": "Εξαγωγή",
				"targetType": "Τύπος",
				"targetCode": "Κωδικός",
				"email": "Email",
				"truncated": "Εξήχθησαν {{exported}} από {{total}} αξιολογήσεις — περιορίστε τα φίλτρα για πλήρη εξαγωγή."
			},
			"details": {
				"title": "Στοιχεία αξιολόγησης",
				"review": "Αξιολόγηση",
				"customer": "Πελάτης",
				"name": "Ονοματεπώνυμο",
				"registered": "Εγγραφή",
				"orders": "Ολοκληρωμένες παραγγελίες",
				"reviews": "Προϊόντα που αξιολόγησε",
				"target": "Αξιολογούμενο",
				"category": "Κατηγορία",
				"publisher": "Εκδότης / κατασκευαστής"
			},
			"copy": {
				"title": "Αντιγραφή σε προϊόντα της ομάδας",
				"subtitle": "Αντιγραφή της κριτικής του «{{product}}» στα προϊόντα της ίδιας ομάδας.",
				"none": "Το προϊόν δεν ανήκει σε ομάδα με άλλα προϊόντα.",
				"selectAll": "Επιλογή όλων",
				"submit_one": "Αντιγραφή σε {{count}} προϊόν",
				"submit_other": "Αντιγραφή σε {{count}} προϊόντα",
				"done_one": "Αντιγράφηκε σε {{count}} προϊόν.",
				"done_other": "Αντιγράφηκε σε {{count}} προϊόντα.",
				"partial": "Αντιγράφηκε σε {{ok}}, απέτυχε σε {{failed}} — δείτε τη λίστα.",
				"copied": "Αντιγράφηκε"
			},
			"recalculate": {
				"button": "Επανυπολογισμός βαθμολογιών",
				"title": "Επανυπολογισμός βαθμολογιών προϊόντων",
				"body": "Ξαναϋπολογίζει τη βαθμολογία και το πλήθος αξιολογήσεων κάθε προϊόντος από τις εγκεκριμένες αξιολογήσεις. Κανονικά γίνεται αυτόματα· χρησιμοποιήστε το μετά από μαζικές εισαγωγές.",
				"confirm": "Επανυπολογισμός",
				"done": "Οι βαθμολογίες των προϊόντων επανυπολογίστηκαν."
			},
			"recommendations": {
				"customer": "Πελάτες",
				"contributor": "Συντελεστές",
				"from": "Προτείνεται από",
				"deleteTitle": "Διαγραφή πρότασης",
				"deleteBody": "Διαγραφή της πρότασης; Η ενέργεια δεν αναιρείται."
			},
			"photos": {
				"title": "Φωτογραφίες",
				"count_one": "{{count}} φωτογραφία",
				"count_other": "{{count}} φωτογραφίες",
				"open": "Άνοιγμα φωτογραφίας",
				"delete": "Αφαίρεση φωτογραφίας",
				"deleted": "Η φωτογραφία αφαιρέθηκε.",
				"deleteTitle": "Αφαίρεση φωτογραφίας",
				"deleteBody": "Να αφαιρεθεί η φωτογραφία από την αξιολόγηση; Δεν θα τη βλέπει ούτε ο πελάτης. Η ενέργεια δεν αναιρείται."
			},
			"reports": {
				"title": "Αναφορές",
				"none": "Κανένας πελάτης δεν ανέφερε αυτή την αξιολόγηση.",
				"resolve": "Σήμανση αναφορών ως επιλυμένων",
				"resolved": "Οι αναφορές σημειώθηκαν ως επιλυμένες.",
				"stateOpen": "Ανοιχτή",
				"stateResolved": "Επιλυμένη",
				"onlyReported": "Μόνο με αναφορές",
				"openCount_one": "{{count}} ανοιχτή αναφορά",
				"openCount_other": "{{count}} ανοιχτές αναφορές",
				"reasons": {
					"spam": "Spam ή διαφήμιση",
					"offensive": "Προσβλητικό ή υβριστικό",
					"offTopic": "Δεν αφορά το προϊόν",
					"misleading": "Ψευδές ή παραπλανητικό",
					"other": "Άλλο"
				}
			},
			"bulk": {
				"selected_one": "{{count}} αξιολόγηση επιλεγμένη",
				"selected_other": "{{count}} αξιολογήσεις επιλεγμένες",
				"clear": "Καθαρισμός επιλογής",
				"selectAll": "Επιλογή όλων της σελίδας",
				"selectRow": "Επιλογή αξιολόγησης",
				"approveTitle_one": "Έγκριση {{count}} αξιολόγησης",
				"approveTitle_other": "Έγκριση {{count}} αξιολογήσεων",
				"declineTitle_one": "Απόρριψη {{count}} αξιολόγησης",
				"declineTitle_other": "Απόρριψη {{count}} αξιολογήσεων",
				"deleteTitle_one": "Διαγραφή {{count}} αξιολόγησης",
				"deleteTitle_other": "Διαγραφή {{count}} αξιολογήσεων",
				"approveBody_one": "Η αξιολόγηση θα εμφανίζεται στη σελίδα του προϊόντος.",
				"approveBody_other": "Οι αξιολογήσεις θα εμφανίζονται στις σελίδες των προϊόντων.",
				"approveCustomerBody_one": "Η αξιολόγηση θα εμφανίζεται στη σελίδα του προϊόντος. Ο συντάκτης της λαμβάνει το email «η αξιολόγηση εγκρίθηκε» και τους πόντους επιβράβευσης της αξιολόγησης, όπως σε μεμονωμένη έγκριση.",
				"approveCustomerBody_other": "Οι αξιολογήσεις θα εμφανίζονται στις σελίδες των προϊόντων. Κάθε συντάκτης λαμβάνει το email «η αξιολόγηση εγκρίθηκε» και τους πόντους επιβράβευσης της αξιολόγησης, όπως σε μεμονωμένη έγκριση.",
				"declineBody_one": "Η αξιολόγηση δεν θα εμφανίζεται στη σελίδα του προϊόντος.",
				"declineBody_other": "Οι αξιολογήσεις δεν θα εμφανίζονται στις σελίδες των προϊόντων.",
				"deleteBody_one": "Να διαγραφεί η επιλεγμένη αξιολόγηση; Η ενέργεια δεν αναιρείται.",
				"deleteBody_other": "Να διαγραφούν οι {{count}} επιλεγμένες αξιολογήσεις; Η ενέργεια δεν αναιρείται.",
				"approveConfirm_one": "Έγκριση",
				"approveConfirm_other": "Έγκριση {{count}}",
				"declineConfirm_one": "Απόρριψη",
				"declineConfirm_other": "Απόρριψη {{count}}",
				"deleteConfirm_one": "Διαγραφή",
				"deleteConfirm_other": "Διαγραφή {{count}}",
				"done": {
					"approve_one": "Εγκρίθηκε {{count}} αξιολόγηση.",
					"approve_other": "Εγκρίθηκαν {{count}} αξιολογήσεις.",
					"decline_one": "Απορρίφθηκε {{count}} αξιολόγηση.",
					"decline_other": "Απορρίφθηκαν {{count}} αξιολογήσεις.",
					"delete_one": "Διαγράφηκε {{count}} αξιολόγηση.",
					"delete_other": "Διαγράφηκαν {{count}} αξιολογήσεις."
				}
			}
		},
		"backInStock": {
			"title": "Ειδοποιήσεις διαθεσιμότητας",
			"noAccess": "Χρειάζεστε τον ρόλο Catalog για να δείτε τις ειδοποιήσεις διαθεσιμότητας.",
			"variant": "παραλλαγή #{{id}}",
			"columns": {
				"email": "E-mail",
				"product": "Προϊόν",
				"language": "Γλώσσα",
				"status": "Κατάσταση",
				"requested": "Αίτηση",
				"confirmed": "Επιβεβαίωση",
				"notified": "Ειδοποίηση"
			},
			"status": {
				"pendingConfirmation": "Αναμονή επιβεβαίωσης",
				"pendingNotification": "Αναμονή διαθεσιμότητας",
				"notified": "Ειδοποιήθηκε",
				"disabled": "Ανενεργή"
			}
		},
		"buyGuides": {
			"title": "Οδηγοί Αγοράς",
			"add": "Νέος οδηγός αγοράς",
			"untitled": "Νέος οδηγός αγοράς",
			"notFound": "Ο οδηγός αγοράς δεν βρέθηκε.",
			"noAccess": "Χρειάζεστε δικαίωμα Καταλόγου για τη διαχείριση των οδηγών αγοράς.",
			"statusTitle": "Κατάσταση",
			"statusVisible": "Ορατός",
			"statusHidden": "Κρυφός",
			"deleteTitle": "Διαγραφή οδηγού αγοράς",
			"deleteBody": "Διαγραφή οδηγού αγοράς «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"backgroundColor": "Χρώμα φόντου",
			"image": "Εικόνα",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"contentPlaceholder": "Περιεχόμενο οδηγού αγοράς…",
			"categories": "Κατηγορίες",
			"categoriesSubtitle": "Τα προϊόντα αυτών των κατηγοριών εμφανίζουν τον οδηγό στη σελίδα τους.",
			"categoriesHelp": "Κάθε κατηγορία εμφανίζει έναν οδηγό· αν επιλέξετε κατηγορία με άλλον οδηγό, μεταφέρεται σε αυτόν.",
			"categoriesPlaceholder": "Επιλέξτε κατηγορίες…",
			"otherGuide": "Άλλος οδηγός",
			"tabs": {
				"general": "Γενικά",
				"content": "Περιεχόμενο",
				"categories": "Κατηγορίες"
			},
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"background": "Φόντο",
				"categories": "Κατηγορίες",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"bundles": {
			"title": "Πακέτα",
			"subtitle": "Προϊόντα τύπου Πακέτο και Συσκευασία δώρου και τα περιεχόμενά τους. Δημιουργήστε το προϊόν στην καρτέλα προϊόντος και διαχειριστείτε εδώ τα περιεχόμενά του.",
			"add": "Νέο πακέτο",
			"noAccess": "Χρειάζεστε το δικαίωμα Καταλόγου για να διαχειριστείτε πακέτα.",
			"notFound": "Το πακέτο δεν βρέθηκε — το προϊόν δεν υπάρχει ή δεν είναι Πακέτο / Συσκευασία δώρου.",
			"loadError": "Δεν ήταν δυνατή η φόρτωση των πακέτων.",
			"newTitle": "Επιλογή προϊόντος πακέτου",
			"newBody": "Προϊόντα Πακέτο και Συσκευασία δώρου χωρίς περιεχόμενα. Επιλέξτε ένα για να ορίσετε τα περιεχόμενά του· νέα προϊόντα πακέτων δημιουργούνται στην καρτέλα προϊόντος.",
			"newEmpty": "Όλα τα προϊόντα Πακέτο / Συσκευασία δώρου έχουν ήδη περιεχόμενα. Δημιουργήστε πρώτα νέο προϊόν τύπου Πακέτο ή Συσκευασία δώρου στην καρτέλα προϊόντος.",
			"openProduct": "Άνοιγμα προϊόντος",
			"activeWindow": "Περίοδος ισχύος",
			"activeWindowHelp": "Αφήστε κενό για χωρίς όριο έναρξης / λήξης.",
			"activeFrom": "Ισχύει από",
			"activeTo": "Ισχύει έως",
			"datesInvalid": "Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης.",
			"contents": "Περιεχόμενα",
			"contentsHelpBundle": "Όλες οι γραμμές αποθηκεύονται μαζί. Οι κρυφές γραμμές διατηρούνται αλλά δεν υπολογίζονται.",
			"contentsHelpGiftbox": "Κάθε γραμμή χρειάζεται προϊόν ή περιγραφή. Όλες οι γραμμές αποθηκεύονται μαζί.",
			"addRow": "Προσθήκη γραμμής",
			"removeRow": "Αφαίρεση γραμμής",
			"noRows": "Δεν υπάρχουν περιεχόμενα. Προσθέστε μια γραμμή για να ξεκινήσετε.",
			"summary": "Σύνοψη",
			"totalsPending_one": "{{count}} γραμμή δεν έχει ακόμη γνωστή τιμή· τα σύνολα ενημερώνονται μετά την αποθήκευση.",
			"totalsPending_other": "{{count}} γραμμές δεν έχουν ακόμη γνωστή τιμή· τα σύνολα ενημερώνονται μετά την αποθήκευση.",
			"saved": "Το πακέτο αποθηκεύτηκε",
			"pickProduct": "Επιλογή προϊόντος…",
			"searchProduct": "Αναζήτηση με κωδικό ή όνομα…",
			"searchHint": "Πληκτρολογήστε για αναζήτηση προϊόντων",
			"clearProduct": "Καθαρισμός προϊόντος",
			"types": {
				"bundle": "Πακέτο",
				"giftbox": "Συσκευασία δώρου"
			},
			"status": {
				"active": "Ενεργό",
				"inactive": "Ανενεργό",
				"activeBanner": "Ενεργό — το πακέτο εφαρμόζεται στο ταμείο.",
				"inactiveBanner": "Ανενεργό — το πακέτο δεν εφαρμόζεται στο ταμείο:"
			},
			"filters": {
				"type": "Τύπος",
				"allTypes": "Όλοι οι τύποι",
				"status": "Κατάσταση",
				"allStatuses": "Όλες οι καταστάσεις",
				"containsProduct": "Περιέχει προϊόν…"
			},
			"columns": {
				"image": "Εικόνα",
				"name": "Όνομα",
				"code": "Κωδικός",
				"type": "Τύπος",
				"count": "Προϊόντα",
				"regularTotal": "Κανονικό σύνολο",
				"bundleTotal": "Σύνολο πακέτου",
				"saving": "Όφελος",
				"status": "Κατάσταση",
				"dates": "Περίοδος ισχύος",
				"product": "Προϊόν",
				"qty": "Ποσ.",
				"livePrice": "Τρέχουσα τιμή",
				"bundlePrice": "Τιμή πακέτου",
				"priceBd": "Τιμή προ έκπτωσης",
				"refPrice": "Τιμή αναφοράς",
				"description": "Περιγραφή",
				"sort": "Σειρά",
				"visible": "Ορατό",
				"unitSaving": "Όφελος / τεμ.",
				"lineTotal": "Σύνολο γραμμής"
			},
			"reasons": {
				"BundleProductMissing": "Το προϊόν πακέτου δεν υπάρχει",
				"BundleProductDeleted": "Το προϊόν πακέτου έχει διαγραφεί",
				"BundleProductHidden": "Το προϊόν πακέτου είναι κρυφό",
				"NotABundleProduct": "Το προϊόν δεν είναι Πακέτο / Συσκευασία δώρου",
				"NotStarted": "Η περίοδος ισχύος δεν έχει ξεκινήσει",
				"Ended": "Η περίοδος ισχύος έχει λήξει",
				"CustomerHasNoAccess": "Οι πελάτες δεν έχουν πρόσβαση στο προϊόν πακέτου",
				"NoContents": "Χωρίς περιεχόμενα",
				"InvalidRow": "Μια γραμμή δεν είναι έγκυρη",
				"ChildInTwoRows": "Ένα προϊόν υπάρχει σε δύο γραμμές",
				"ChildMissing": "Ένα προϊόν του πακέτου δεν υπάρχει",
				"ChildDeleted": "Ένα προϊόν του πακέτου έχει διαγραφεί",
				"ChildHidden": "Ένα προϊόν του πακέτου είναι κρυφό",
				"ChildNotASimpleProduct": "Ένα προϊόν του πακέτου δεν είναι απλό προϊόν",
				"ChildCustomerHasNoAccess": "Οι πελάτες δεν έχουν πρόσβαση σε προϊόν του πακέτου"
			},
			"warnings": {
				"ChildMissing": "Το προϊόν δεν υπάρχει",
				"ChildDeleted": "Το προϊόν έχει διαγραφεί",
				"ChildHidden": "Το προϊόν είναι κρυφό",
				"ChildNotASimpleProduct": "Δεν είναι απλό προϊόν",
				"ChildHasDimensions": "Το προϊόν έχει διαστάσεις (παραλλαγές)",
				"NoSaving": "Χωρίς όφελος: η τιμή πακέτου δεν είναι χαμηλότερη από την τρέχουσα τιμή",
				"InvalidRow": "Μη έγκυρη γραμμή",
				"ChildInTwoRows": "Το προϊόν υπάρχει σε άλλη γραμμή"
			},
			"productTab": {
				"contentsTitle": "Περιεχόμενα πακέτου",
				"manage": "Διαχείριση περιεχομένων",
				"saveTypeFirst": "Αποθηκεύστε το προϊόν ως Πακέτο ή Συσκευασία δώρου για να διαχειριστείτε τα περιεχόμενά του.",
				"partOfTitle": "Μέρος πακέτων",
				"partOfHelp": "Πακέτα και συσκευασίες δώρου που περιέχουν αυτό το προϊόν.",
				"partOfEmpty": "Το προϊόν δεν ανήκει σε κανένα πακέτο.",
				"saveFirst": "Αποθηκεύστε πρώτα το προϊόν για να δείτε τα πακέτα του."
			}
		}
	},
	"loyalty": {
		"ranges": {
			"title": "Εύρος πόντων",
			"add": "Νέο εύρος",
			"addTitle": "Νέο εύρος πόντων",
			"editTitle": "Επεξεργασία εύρους πόντων",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του εύρους πόντων.",
			"guide": "Η προσθήκη ενός πόντου όπου υπάρχει ήδη, θα ακυρώσει τον προηγούμενο.",
			"deleteTitle": "Διαγραφή εύρους πόντων",
			"deleteBody": "Να διαγραφεί το εύρος των {{points}} πόντων; Η ενέργεια δεν αναιρείται.",
			"deleteResult": {
				"already_cancelled": "Το εύρος έχει ήδη ακυρωθεί.",
				"expired_successfully": "Το εύρος έληξε με επιτυχία.",
				"deleted_sucessfully": "Το εύρος διαγράφηκε με επιτυχία."
			},
			"columns": {
				"points": "Πόντοι",
				"discount": "Έκπτωση",
				"minimumAmount": "Ελάχιστο όριο",
				"activeFrom": "Ισχύει από",
				"activeTo": "Ισχύει εώς",
				"updated": "Ημ/νία τροποποίησης"
			}
		},
		"perEntity": {
			"title": "Ανάθεση πόντων",
			"editTitle": "Επεξεργασία ανάθεσης πόντων",
			"formSubtitle": "Ορίστε τους πόντους που αποδίδονται για το συμβάν.",
			"columns": {
				"name": "Παράμετρος",
				"description": "Περιγραφή",
				"points": "Πόντοι",
				"activeFrom": "Ισχύει από",
				"activeTo": "Ισχύει εώς",
				"updated": "Ημ/νία τροποποίησης"
			}
		},
		"overview": {
			"title": "Παράμετροι",
			"editTitle": "Επεξεργασία παραμέτρου",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της παραμέτρου.",
			"deleteTitle": "Διαγραφή παραμέτρου",
			"deleteBody": "Να διαγραφεί η παράμετρος «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Παράμετρος",
				"value": "Τιμή",
				"description": "Περιγραφή"
			},
			"valueHint": {
				"onOff": "Εισάγετε 1 (ενεργό) ή 0 (ανενεργό).",
				"wholeNumber": "Εισάγετε ακέραιο αριθμό, 0 ή μεγαλύτερο.",
				"amount": "Εισάγετε ποσό, π.χ. 0.5."
			}
		},
		"products": {
			"title": "Πόντοι προϊόντων",
			"subtitle": "{{count}} προϊόντα",
			"searchPlaceholder": "Αναζήτηση με όνομα ή κωδικό…",
			"pageInfo": "Σελίδα {{page}} / {{pages}} · {{total}} σύνολο",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"barcode": "Barcode",
				"points": "Πόντοι",
				"activeFrom": "Ισχύει από",
				"activeTo": "Ισχύει εώς"
			},
			"showHistory": "Εμφάνιση παλαιότερων τιμών"
		},
		"customers": {
			"title": "Πόντοι πελατών",
			"columns": {
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"points": "Πόντοι",
				"email": "E-mail",
				"mobile": "Κινητό",
				"expiration": "Ημ. Λήξης",
				"reserved": "Δεσμευμένοι"
			},
			"history": {
				"action": "Ιστορικό",
				"title": "Ιστορικό πόντων",
				"subtitle": "Ιστορικό συναλλαγών πόντων του πελάτη.",
				"columns": {
					"description": "Περιγραφή",
					"date": "Ημερομηνία",
					"points": "Πόντοι",
					"status": "Κατάσταση"
				},
				"noteBy": "{{note}} — {{admin}}"
			},
			"eventTypes": {
				"1": "Εκκρεμής παραγγελία προϊόντος",
				"2": "Πίστωση πόντων στην παραγγελία",
				"3": "Εξαργύρωση πόντων στην παραγγελία",
				"4": "Επιστροφή προϊόντος",
				"5": "Ημέρα γενεθλίων",
				"6": "Εγγραφή",
				"7": "Προς χρήση",
				"8": "Εισαγωγή φύλου",
				"9": "Εγγραφή στο newsletter",
				"10": "Εισαγωγή ημερομηνίας γενεθλίων",
				"11": "Κλείσιμο ραντεβού",
				"12": "Ανάγνωση άρθρου",
				"13": "Προβολή βίντεο",
				"14": "Πρόταση φίλου",
				"15": "Αποδοχή φίλου",
				"16": "Κριτική",
				"17": "Επιστροφή πόντων",
				"18": "Ακύρωση ραντεβού",
				"19": "Λήξη πόντων",
				"20": "Χειροκίνητη διόρθωση"
			},
			"pointStatus": {
				"1": "Επιβεβαιωμένοι Πόντοι",
				"2": "Πόντοι σε εκκρεμότητα",
				"3": "Δεσμευμένοι πόντοι"
			},
			"subtitle": "{{count}} πελάτες με πόντους",
			"searchPlaceholder": "Αναζήτηση με όνομα, e-mail ή κινητό",
			"export": "Εξαγωγή",
			"exportTruncated": "Εξήχθησαν {{exported}} από {{total}} πελάτες — περιόρισε την αναζήτηση για πλήρη εξαγωγή.",
			"adjust": {
				"action": "Διόρθωση πόντων",
				"anyCustomer": "Διόρθωση πόντων πελάτη",
				"title": "Διόρθωση πόντων",
				"subtitle": "{{name}} · {{points}} πόντοι τώρα",
				"pickCustomer": "Επιλέξτε τον πελάτη του οποίου τους πόντους διορθώνετε.",
				"customer": "Πελάτης",
				"points": "Πόντοι",
				"pointsHint": "Θετικός αριθμός προσθέτει πόντους, αρνητικός αφαιρεί. Ό,τι αφαιρείται πέρα από το υπόλοιπο γίνεται οφειλή.",
				"pointsInvalid": "Δώστε ακέραιους πόντους διαφορετικούς από 0, από -100000 έως 100000",
				"note": "Λόγος (τον βλέπουν μόνο οι διαχειριστές)",
				"expiry": "Ημερομηνία λήξης",
				"expiryHint": "Κενό: όπως ορίζει η ρύθμιση λήξης.",
				"expiryInvalid": "Η λήξη πρέπει να είναι μελλοντική",
				"submit": "Διόρθωση",
				"saved": "Οι πόντοι διορθώθηκαν. Ο πελάτης έχει τώρα {{points}} πόντους."
			}
		},
		"tierRules": {
			"title": "Κανόνες Επιπέδων",
			"add": "Νέος Κανόνας",
			"addTitle": "Νέος Κανόνας Επιπέδου",
			"editTitle": "Επεξεργασία Κανόνα",
			"formSubtitle": "Όρια προαγωγής πελατών σε επίπεδα επιβράβευσης.",
			"deleteTitle": "Διαγραφή κανόνα",
			"deleteBody": "Διαγραφή του κανόνα για «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"fields": {
				"tier": "Επίπεδο",
				"criteriaType": "Τύπος κριτηρίου",
				"value": "Τιμή",
				"timeFrameMonth": "Χρονικό πλαίσιο (μήνες)",
				"description": "Περιγραφή",
				"active": "Ενεργό"
			}
		},
		"loadError": "Δεν ήταν δυνατή η φόρτωση των δεδομένων πόντων."
	},
	"customers": {
		"list": {
			"title": "Πελάτες",
			"subtitle": "{{count}} πελάτες",
			"add": "Νέος πελάτης",
			"addTitle": "Νέος πελάτης",
			"editTitle": "Επεξεργασία πελάτη",
			"formSubtitle": "Στοιχεία λογαριασμού, κατηγοριοποίησης, εμπορικά και εταιρείας.",
			"searchPlaceholder": "Αναζήτηση με όνομα, email ή τηλέφωνο…",
			"pageInfo": "Σελίδα {{page}} / {{pages}} · {{total}} σύνολο",
			"deleteTitle": "Διαγραφή πελάτη",
			"deleteBody": "Διαγραφή πελάτη «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"email": "Email",
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"category": "Κατηγορία",
				"active": "Ενεργός",
				"confirmed": "Επιβεβαιωμένος"
			},
			"sections": {
				"account": "Λογαριασμός",
				"classification": "Κατηγοριοποίηση",
				"commercial": "Εμπορικά",
				"company": "Εταιρεία / Τιμολόγηση",
				"flags": "Προτιμήσεις",
				"erp": "Κωδικοί ERP",
				"image": "Εικόνα"
			},
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"fields": {
				"username": "Όνομα χρήστη",
				"password": "Κωδικός",
				"passwordEdit": "Κωδικός (κενό για διατήρηση)",
				"tier": "Βαθμίδα",
				"gender": "Φύλο",
				"dob": "Ημ. γέννησης",
				"discount": "Έκπτωση",
				"priceType": "Τύπος τιμής",
				"paymentType": "Τρόπος πληρωμής",
				"shippingType": "Τρόπος αποστολής",
				"takeawayStore": "Σημείο παραλαβής",
				"company": "Εταιρεία",
				"descriptiveTitle": "Περιγραφικός τίτλος",
				"vat": "ΑΦΜ",
				"irs": "ΔΟΥ",
				"tel": "Τηλέφωνο",
				"mobile": "Κινητό",
				"fax": "Φαξ",
				"newsletter": "Λήψη newsletters",
				"promoOptin": "Συναίνεση προωθητικών",
				"personalizedMessages": "Προσωποποιημένα μηνύματα",
				"hiddenReader": "Κρυφός αναγνώστης",
				"image": "Εικόνα πελάτη"
			},
			"actions": {
				"branches": "Υποκαταστήματα",
				"coupons": "Κουπόνια",
				"groupOverrides": "Ανάθεση σε προφίλ",
				"impersonate": "Σύνδεση ως πελάτης",
				"referrals": "Συστάσεις"
			},
			"branches": {
				"title": "Υποκαταστήματα",
				"subtitle": "Υποκαταστήματα του πελάτη.",
				"add": "Νέο υποκατάστημα",
				"code": "Κωδικός",
				"name": "Όνομα",
				"email": "Email",
				"tel": "Τηλέφωνο",
				"address": "Διεύθυνση",
				"area": "Περιοχή",
				"city": "Πόλη",
				"postalCode": "Ταχ. κώδικας",
				"erpCode": "Κωδικός ERP",
				"sort": "Σειρά",
				"visible": "Ορατό"
			},
			"coupons": {
				"title": "Κουπόνια",
				"subtitle": "Κουπόνια του πελάτη.",
				"add": "Νέο κουπόνι",
				"code": "Κωδικός",
				"name": "Όνομα",
				"barcode": "Barcode",
				"amount": "Ποσό",
				"discount": "Έκπτωση",
				"registerDate": "Ημ. εγγραφής",
				"expiryDate": "Ημ. λήξης",
				"description": "Περιγραφή",
				"active": "Ενεργό"
			},
			"groupOverrides": {
				"title": "Ανάθεση σε προφίλ",
				"subtitle": "Ανάθεση του πελάτη σε προφίλ ή εξαίρεσή του από αυτά, ανεξάρτητα από τα κριτήρια κάθε προφίλ.",
				"included": "Ένταξη σε προφίλ",
				"excluded": "Εξαίρεση από προφίλ",
				"none": "Κανένα προφίλ"
			},
			"referrals": {
				"title": "Συστάσεις",
				"subtitle": "Σύσταση φίλου",
				"code": "Κωδικός σύστασης",
				"noCode": "Δεν υπάρχει ακόμη κωδικός",
				"copy": "Αντιγραφή κωδικού",
				"copied": "Αντιγράφηκε",
				"copyFailed": "Η αντιγραφή απέτυχε",
				"createdOn": "Δημιουργήθηκε στις {{date}}",
				"referredBy": "Σύσταση από",
				"regenerate": "Νέος κωδικός",
				"regenerateWarning": "Ο πελάτης παίρνει νέο κωδικό και ο τρέχων παύει να ισχύει: οι προσκλήσεις που έχουν ήδη σταλεί με αυτόν δεν θα μετράνε πλέον.",
				"regenerated": "Δημιουργήθηκε νέος κωδικός",
				"none": "Κανείς δεν έχει εγγραφεί ακόμη με τον κωδικό αυτού του πελάτη.",
				"customer": "Πελάτης",
				"email": "E-mail",
				"joined": "Εγγραφή",
				"status": "Κατάσταση",
				"statusJoined": "Εγγράφηκε",
				"statusRewarded": "Επιβραβεύτηκε (+{{points}} πόντοι)",
				"statusReversed": "Η επιβράβευση ακυρώθηκε",
				"showingNewest": "Εμφανίζονται οι {{shown}} πιο πρόσφατοι από {{total}}."
			}
		},
		"groups": {
			"title": "Προφίλ Πελατών",
			"add": "Νέο προφίλ",
			"addTitle": "Νέο προφίλ",
			"editTitle": "Επεξεργασία προφίλ",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του προφίλ πελατών. Τα κριτήρια μελών επεξεργάζονται ξεχωριστά.",
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"description": "Περιγραφή"
			},
			"criteria": {
				"title": "Επεξεργασία κριτηρίων",
				"subtitle": "Ορίστε ποιοι πελάτες ανήκουν σε αυτό το προφίλ.",
				"selectFilter": "Επιλογή συνθήκης",
				"combine": "Συνδυασμός",
				"conditions": "Συνθήκες",
				"operand": "Τελ.",
				"addCondition": "Προσθήκη συνθήκης",
				"tier": "Βαθμίδα",
				"ageFrom": "Ηλικία από",
				"ageTo": "Ηλικία έως",
				"selectGenders": "Επιλογή φύλων…",
				"selectCustomers": "Αναζήτηση πελατών…",
				"selectCategories": "Επιλογή κατηγοριών πελατών…",
				"advanced": "για προχωρημένους",
				"advancedPreserved": "Σύνθετη συνθήκη — επεξεργασία στο παλαιό admin (διατηρείται)",
				"types": {
					"customerTier": "Βαθμίδα Πελάτη",
					"customerGender": "Φύλο Πελάτη",
					"customerAge": "Ηλικία Πελάτη",
					"customerId": "Επιλογή Πελατών",
					"customerCategory": "Κατηγορία Πελάτη",
					"customerOrderStats": "Στατιστικά Παραγγελιών"
				}
			},
			"members": {
				"title": "Μέλη",
				"subtitle": "Πελάτες που ταιριάζουν αυτή τη στιγμή στο προφίλ.",
				"name": "Όνομα",
				"email": "Email"
			},
			"memberOverrides": {
				"title": "Ανάθεση/εξαίρεση πελατών",
				"subtitle": "Ανάθεση ή εξαίρεση συγκεκριμένων πελατών σε/από αυτό το προφίλ, ανεξάρτητα από τα κριτήριά του.",
				"included": "Ανάθεση πελατών",
				"excluded": "Εξαίρεση πελατών",
				"search": "Αναζήτηση πελατών…",
				"none": "Κανένας"
			}
		},
		"categories": {
			"title": "Κατηγορίες Πελατών",
			"subtitle": "{{count}} κατηγορίες",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία",
			"editTitle": "Επεξεργασία κατηγορίας",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της κατηγορίας πελάτη.",
			"rootParent": "— Χωρίς γονέα (ρίζα) —",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Διαγραφή κατηγορίας «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"deleteWithChildrenBody": "Διαγραφή κατηγορίας «{{name}}» και όλων των υποκατηγοριών της; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"parent": "Γονική κατηγορία",
				"discount": "Έκπτωση",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"tiers": {
			"title": "Βαθμίδες Πελατών",
			"add": "Νέα βαθμίδα",
			"addTitle": "Νέα βαθμίδα",
			"editTitle": "Επεξεργασία βαθμίδας",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της βαθμίδας πελάτη.",
			"deleteTitle": "Διαγραφή βαθμίδας",
			"deleteBody": "Διαγραφή βαθμίδας «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"description": "Περιγραφή",
				"level": "Επίπεδο",
				"multiplier": "Πολλαπλασιαστής",
				"color": "Χρώμα",
				"visible": "Ορατό",
				"active": "Ενεργό",
				"sort": "Σειρά",
				"purchaseAmountFrom": "Αγορές από (€)"
			},
			"bullets": {
				"title": "Προνόμια",
				"empty": "Δεν υπάρχουν προνόμια.",
				"placeholder": "Κείμενο νέου προνομίου",
				"add": "Προσθήκη"
			}
		},
		"registerRequests": {
			"title": "Αιτήσεις Εγγραφής",
			"editTitle": "Επεξεργασία Αίτησης",
			"formSubtitle": "Στοιχεία πελάτη που υπέβαλε αίτηση εγγραφής.",
			"deleteTitle": "Διαγραφή αίτησης",
			"deleteBody": "Διαγραφή της αίτησης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"email": "E-mail",
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"company": "Επωνυμία",
				"vat": "ΑΦΜ",
				"tel": "Τηλέφωνο",
				"mobile": "Κινητό",
				"irs": "ΔΟΥ",
				"createDate": "Δημιουργία"
			},
			"fields": {
				"email": "E-mail",
				"createDate": "Ημ. Δημιουργίας",
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"company": "Επωνυμία",
				"descriptiveTitle": "Διακριτικός τίτλος",
				"vat": "ΑΦΜ",
				"irs": "ΔΟΥ",
				"address": "Διεύθυνση",
				"tel": "Τηλέφωνο",
				"mobile": "Κινητό",
				"fax": "Φαξ",
				"gender": "Φύλο",
				"dob": "Ημ. Γέννησης",
				"newsletter": "Λήψη newsletters",
				"promoOptin": "Συναίνεση προωθητικών"
			}
		},
		"links": {
			"linked": "Συνδεδεμένος",
			"inspectors": "Επιθεωρητές",
			"customers": "Πελάτες",
			"inspectorsTitle": "Επιθεωρητές: {{name}}",
			"customersTitle": "Πελάτες: {{name}}"
		},
		"inspectors": {
			"title": "Επιθεωρητές",
			"add": "Νέος Επιθεωρητής",
			"addTitle": "Νέος Επιθεωρητής",
			"editTitle": "Επεξεργασία Επιθεωρητή",
			"formSubtitle": "Στοιχεία επιθεωρητή.",
			"deleteTitle": "Διαγραφή επιθεωρητή",
			"deleteBody": "Διαγραφή του επιθεωρητή «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"fields": {
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"email": "E-mail",
				"tel": "Τηλέφωνο",
				"mobile": "Κινητό",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"createDate": "Δημιουργία"
			}
		},
		"salesPersons": {
			"title": "Πωλητές",
			"add": "Νέος Πωλητής",
			"addTitle": "Νέος Πωλητής",
			"editTitle": "Επεξεργασία Πωλητή",
			"formSubtitle": "Στοιχεία λογαριασμού και αντικατάστασης πωλητή.",
			"deleteTitle": "Διαγραφή πωλητή",
			"deleteBody": "Διαγραφή του πωλητή «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"fields": {
				"username": "Username",
				"password": "Κωδικός",
				"passwordEdit": "Κωδικός (κενό για διατήρηση)",
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"email": "E-mail",
				"active": "Ενεργός",
				"confirmed": "Επιβεβαιωμένος",
				"erpCode": "Κωδικός ERP",
				"replaceSalesPerson": "Αντικαταστάτης",
				"replaceStart": "Έναρξη αντικατάστασης",
				"replaceEnd": "Λήξη αντικατάστασης"
			}
		},
		"coupons": {
			"title": "Κουπόνια",
			"subtitle": "{{count}} κουπόνια",
			"add": "Νέο Κουπόνι",
			"addTitle": "Νέο Κουπόνι",
			"editTitle": "Επεξεργασία Κουπονιού",
			"formSubtitle": "Στοιχεία, κανόνες εφαρμογής και ενέργειες κουπονιού.",
			"searchPlaceholder": "Αναζήτηση με κωδικό ή όνομα",
			"deleteTitle": "Διαγραφή κουπονιού",
			"deleteBody": "Διαγραφή του κουπονιού «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"tabs": {
				"basic": "Βασικά Στοιχεία",
				"conditions": "Κανόνες",
				"actions": "Ενέργειες"
			},
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"amount": "Έκπτωση (€)",
				"discount": "Έκπτωση %",
				"turnover": "Τζίρος",
				"redeemedAmount": "Εξαργύρωση",
				"isRedeemed": "Εξαργυρώθηκε",
				"startDate": "Ημ. Έναρξης",
				"endDate": "Ημ. Λήξης"
			},
			"fields": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"sort": "Σειρά",
				"description": "Περιγραφή",
				"active": "Ενεργό",
				"visible": "Ορατό",
				"generatePerCustomer": "Δημιουργία ανά πελάτη",
				"codeTemplate": "Πρότυπο κωδικού",
				"bulkCount": "Μαζική δημιουργία (πλήθος)",
				"onceOff": "Μιας χρήσης",
				"partialRedemption": "Μερική εξαργύρωση",
				"allowMultRedeem": "Πολλαπλές εξαργυρώσεις",
				"activeFrom": "Ενεργό από",
				"activeTo": "Ενεργό έως",
				"amountThreshold": "Όριο ποσού",
				"nonDiscountAmountThreshold": "Όριο ποσού (χωρίς εκπτώσεις)",
				"allowedDomains": "Επιτρεπόμενα domains",
				"emailExceptions": "Εξαιρέσεις email",
				"assignedToEmails": "Ανάθεση σε emails",
				"customers": "Πελάτες",
				"customerCategories": "Κατηγορίες πελατών",
				"shippingDiscount": "Έκπτωση μεταφορικών",
				"amount": "Ποσό έκπτωσης (€)",
				"discount": "Έκπτωση %",
				"discountMode": "Τρόπος εφαρμογής έκπτωσης",
				"maxRedeemableItems": "Μέγ. εξαργυρώσιμα είδη",
				"products": "Προϊόντα",
				"categories": "Κατηγορίες",
				"ignoreDiscExceptions": "Αγνόηση εξαιρέσεων έκπτωσης",
				"productApplicationScope": "Η έκπτωση εφαρμόζεται σε",
				"productApplicationScopeHint": "Κάθε τεμάχιο ξεχωριστά: το ποσό μοιράζεται στα προϊόντα που ταιριάζουν. Σύνολο καλαθιού: το ποσό εφαρμόζεται μία φορά στο καλάθι όταν υπάρχει τουλάχιστον ένα προϊόν που ταιριάζει (ο μέγ. αριθμός ειδών αγνοείται)."
			},
			"discountModes": {
				"0": "Προϊόν",
				"2": "Μέγιστο",
				"3": "Άθροισμα",
				"4": "Συνδυασμός"
			},
			"applicationScopes": {
				"0": "Κάθε τεμάχιο ξεχωριστά",
				"1": "Σύνολο καλαθιού"
			},
			"validation": {
				"percentage": "Η έκπτωση πρέπει να είναι μεταξύ 0 και 100."
			}
		}
	},
	"prices": {
		"priceTypes": {
			"title": "Είδη Τιμών",
			"add": "Νέο είδος τιμής",
			"addTitle": "Νέο είδος τιμής",
			"editTitle": "Επεξεργασία είδους τιμής",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του είδους τιμής.",
			"deleteTitle": "Διαγραφή είδους τιμής",
			"deleteBody": "Διαγραφή του είδους τιμής «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"base": "Βασικό",
				"tax": "ΦΠΑ",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"currencies": {
			"title": "Νομίσματα",
			"add": "Νέο νόμισμα",
			"addTitle": "Νέο νόμισμα",
			"editTitle": "Επεξεργασία νομίσματος",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του νομίσματος.",
			"deleteTitle": "Διαγραφή νομίσματος",
			"deleteBody": "Διαγραφή του νομίσματος «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"iso": "Κωδικός ISO-3",
				"format": "Κείμενο Διαμόρφωσης",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"taxCategories": {
			"title": "Κατηγορίες ΦΠΑ",
			"add": "Νέα κατηγορία ΦΠΑ",
			"addTitle": "Νέα κατηγορία ΦΠΑ",
			"editTitle": "Επεξεργασία κατηγορίας ΦΠΑ",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της κατηγορίας ΦΠΑ.",
			"noCountry": "— Καμία —",
			"deleteTitle": "Διαγραφή κατηγορίας ΦΠΑ",
			"deleteBody": "Διαγραφή της κατηγορίας ΦΠΑ «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"type": "Τύπος ΦΠΑ",
				"status": "Καθεστώς ΦΠΑ",
				"country": "Χώρα",
				"rate": "Ποσοστό",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"taxRules": {
			"title": "Φορολογικοί Κανόνες",
			"add": "Νέος φορολογικός κανόνας",
			"addTitle": "Νέος φορολογικός κανόνας",
			"editTitle": "Επεξεργασία φορολογικού κανόνα",
			"formSubtitle": "Αντιστοιχίστε γεωγραφική εμβέλεια (χώρα / νομός / ΤΚ) σε ένα καθεστώς ΦΠΑ.",
			"selectCountry": "Επιλέξτε χώρα…",
			"noRegion": "— Όλοι οι νομοί —",
			"deleteTitle": "Διαγραφή φορολογικού κανόνα",
			"deleteBody": "Διαγραφή του φορολογικού κανόνα για «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"country": "Χώρα",
				"region": "Νομός",
				"postalCode": "ΤΚ",
				"taxStatus": "Καθεστώς ΦΠΑ"
			}
		}
	},
	"validation": {
		"required": "Υποχρεωτικό πεδίο",
		"tooLong": "Υπερβαίνει το μέγιστο μήκος",
		"email": "Μη έγκυρη διεύθυνση e-mail",
		"passwordMin": "Τουλάχιστον 8 χαρακτήρες",
		"wholeNumber": "Εισάγετε ακέραιο αριθμό, 0 ή μεγαλύτερο",
		"positiveNumber": "Εισάγετε αριθμό πάνω από 0",
		"notNegative": "Δεν μπορεί να είναι αρνητικό",
		"endBeforeStart": "Η λήξη πρέπει να είναι μετά την έναρξη",
		"ratingMax": "Έως 5"
	},
	"attributes": {
		"sizeGuides": {
			"title": "Μεγεθολόγιο",
			"add": "Νέο μεγεθολόγιο",
			"untitled": "Νέο μεγεθολόγιο",
			"notFound": "Το μεγεθολόγιο δεν βρέθηκε.",
			"detailsTitle": "Στοιχεία",
			"bodyTitle": "Κείμενο",
			"bodyPlaceholder": "Κείμενο μεγεθολογίου…",
			"statusVisible": "Ορατό",
			"statusHidden": "Κρυφό",
			"deleteTitle": "Διαγραφή μεγεθολογίου",
			"deleteBody": "Διαγραφή του μεγεθολογίου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"title": "Τίτλος",
				"code": "Κωδικός",
				"visible": "Ορατό"
			}
		},
		"dimensions": {
			"title": "Διαστάσεις",
			"add": "Νέα διάσταση",
			"addTitle": "Νέα διάσταση",
			"editTitle": "Επεξεργασία διάστασης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της διάστασης.",
			"deleteTitle": "Διαγραφή διάστασης",
			"deleteBody": "Διαγραφή της διάστασης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectType": "Επιλέξτε τύπο…",
			"values": "Τιμές",
			"filterableHint": "Εμφάνιση της διάστασης ως φίλτρο στις λίστες προϊόντων",
			"columns": {
				"erpCode": "Κωδικός ERP",
				"name": "Όνομα",
				"type": "Τύπος",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"filterable": "Φίλτρο καταστήματος"
			}
		},
		"dimensionGroupings": {
			"title": "Ομαδοποίηση Διαστάσεων",
			"add": "Νέα ομαδοποίηση",
			"addTitle": "Νέα ομαδοποίηση",
			"editTitle": "Επεξεργασία ομαδοποίησης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της ομαδοποίησης.",
			"deleteTitle": "Διαγραφή ομαδοποίησης",
			"deleteBody": "Διαγραφή της ομαδοποίησης «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectType": "Επιλέξτε τύπο…",
			"values": "Τιμές",
			"noDimension": "— Καμία —",
			"columns": {
				"erpCode": "Κωδικός ERP",
				"name": "Όνομα",
				"color": "Χρώμα",
				"code": "Κωδικός",
				"type": "Τύπος",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"dimension": "Διάσταση"
			}
		},
		"dimensionValues": {
			"title": "Τιμές διάστασης",
			"add": "Νέα τιμή",
			"addTitle": "Νέα τιμή διάστασης",
			"editTitle": "Επεξεργασία τιμής διάστασης",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της τιμής.",
			"deleteTitle": "Διαγραφή τιμής",
			"deleteBody": "Διαγραφή της τιμής «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"count": "{{count}} τιμές",
			"noGrouping": "— Καμία —",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"columns": {
				"erpCode": "Κωδικός ERP",
				"value": "Τιμή",
				"code": "Κωδικός",
				"color": "Χρώμα",
				"grouping": "Ομαδοποίηση",
				"altValue1": "Εναλλακτική τιμή 1",
				"altValue2": "Εναλλακτική τιμή 2",
				"image": "Εικόνα",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"categories": {
			"title": "Κατηγορίες Χαρακτηριστικών",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία",
			"editTitle": "Επεξεργασία κατηγορίας",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Να διαγραφεί η κατηγορία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της κατηγορίας χαρακτηριστικών.",
			"columns": {
				"name": "Όνομα",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"list": {
			"title": "Τεχνικά Χαρακτηριστικά",
			"add": "Νέο χαρακτηριστικό",
			"addTitle": "Νέο χαρακτηριστικό",
			"editTitle": "Επεξεργασία χαρακτηριστικού",
			"deleteTitle": "Διαγραφή χαρακτηριστικού",
			"deleteBody": "Να διαγραφεί το χαρακτηριστικό «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"formSubtitle": "Συμπληρώστε τα στοιχεία του χαρακτηριστικού.",
			"displayName": "Όνομα Εμφάνισης",
			"categoryPlaceholder": "Επιλέξτε κατηγορία",
			"noCategory": "— Καμία —",
			"valueFormat": "Μορφή Τιμής",
			"valueFormatHelp": "Προαιρετική μορφοποίηση τιμής (π.χ. {0} σελ.).",
			"erpCode": "Κωδικός ERP",
			"infoText": "Κείμενο Πληροφοριών",
			"infoTextHelp": "Περιγραφικό κείμενο που εμφανίζεται στο κατάστημα.",
			"image": "Εικόνα",
			"imageHelp": "PNG, JPG ή WebP έως 2MB.",
			"disableFromFilters": "Απόκρυψη από τα φίλτρα",
			"mandatory": "Υποχρεωτικό",
			"searchable": "Με δυνατότητα αναζήτησης",
			"infoVisible": "Ορατές πληροφορίες",
			"columns": {
				"code": "Κωδικός",
				"name": "Όνομα",
				"category": "Κατηγορία",
				"type": "Τύπος",
				"valueDataType": "Τύπος Δεδομένων",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"values": {
			"title": "Τιμές Χαρακτηριστικού",
			"add": "Νέα τιμή",
			"addTitle": "Νέα τιμή",
			"editTitle": "Επεξεργασία τιμής",
			"deleteTitle": "Διαγραφή τιμής",
			"deleteBody": "Να διαγραφεί η τιμή «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"formSubtitle": "Συμπληρώστε τα στοιχεία της τιμής.",
			"colorHelp": "Προαιρετικό χρώμα (π.χ. #FF0000).",
			"erpCode": "Κωδικός ERP",
			"image": "Εικόνα",
			"imageHelp": "PNG, JPG ή WebP έως 2MB.",
			"columns": {
				"value": "Τιμή",
				"code": "Κωδικός",
				"color": "Χρώμα",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"types": {
			"1": "Μονή τιμή",
			"2": "Λίστα τιμών"
		},
		"valueDataTypes": {
			"1": "Κείμενο",
			"2": "Ακέραιος",
			"3": "Δεκαδικός",
			"4": "Ναι/Όχι",
			"5": "Ημερομηνία"
		},
		"map": {
			"title": "Απόδοση Χαρακτηριστικών σε Κατηγορίες",
			"subtitle": "Επιλέξτε κατηγορία και ορίστε τα χαρακτηριστικά που της αποδίδονται.",
			"categories": "Κατηγορίες",
			"attributes": "Χαρακτηριστικά",
			"selectCategory": "Επιλέξτε μια κατηγορία για να ορίσετε τα χαρακτηριστικά της.",
			"assignedCount": "{{count}} αποδοσμένα χαρακτηριστικά",
			"selectAll": "Επιλογή όλων",
			"clearAll": "Καθαρισμός",
			"expandAll": "Ανάπτυξη όλων",
			"collapseAll": "Σύμπτυξη όλων",
			"expand": "Ανάπτυξη",
			"collapse": "Σύμπτυξη"
		}
	},
	"content": {
		"pages": {
			"title": "Στατικές Σελίδες",
			"add": "Νέα σελίδα",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Η σελίδα δεν βρέθηκε.",
			"clone": "Κλωνοποίηση",
			"cloned": "Η σελίδα κλωνοποιήθηκε",
			"cloneTitle": "Κλωνοποίηση σελίδας",
			"cloneBody": "Δώστε κωδικό και τίτλο για το αντίγραφο. Θα δημιουργηθεί ανενεργό.",
			"deleteTitle": "Διαγραφή σελίδας",
			"deleteBody": "Να διαγραφεί η σελίδα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"statusVisible": "Ορατή",
			"statusHidden": "Κρυφή",
			"columns": {
				"code": "Κωδικός",
				"title": "Τίτλος",
				"parent": "Ομάδα",
				"visible": "Ορατό",
				"created": "Δημιουργία",
				"sort": "Σειρά"
			},
			"tabs": {
				"general": "Βασικά Στοιχεία",
				"content": "Κείμενο",
				"seo": "SEO"
			},
			"entityUrl": "URL σελίδας",
			"entityUrlHelp": "Το φιλικό URL με το οποίο εμφανίζεται η σελίδα.",
			"bodyPlaceholder": "Γράψτε το περιεχόμενο της σελίδας…",
			"seoSubtitle": "Μετα-δεδομένα και ρυθμίσεις ευρετηρίασης.",
			"metaTitle": "Meta Title",
			"headerTitle": "Επικεφαλίδα (H1)",
			"metaDescription": "Meta Description",
			"metaKeywords": "Meta Keywords",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Απενεργοποίηση ευρετηρίασης (noindex)",
			"disableFollow": "Απενεργοποίηση follow (nofollow)",
			"statusTitle": "Κατάσταση",
			"parentHelp": "Ομαδοποίηση κάτω από γονική σελίδα.",
			"noParent": "Καμία"
		},
		"bannerGroups": {
			"title": "Ομάδες Banner",
			"add": "Νέα ομάδα",
			"addTitle": "Νέα ομάδα banner",
			"editTitle": "Επεξεργασία ομάδας banner",
			"formSubtitle": "Όνομα, κωδικός, γονική ομάδα και σειρά εμφάνισης.",
			"deleteTitle": "Διαγραφή ομάδας",
			"deleteBody": "Να διαγραφεί η ομάδα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"noParent": "Καμία",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"parent": "Γονική ομάδα",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"banners": {
			"title": "Banners",
			"add": "Νέο banner",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Το banner δεν βρέθηκε.",
			"statusVisible": "Ορατό",
			"statusHidden": "Κρυφό",
			"setAsHero": "Ορισμός ως Hero",
			"heroSet": "Ορίστηκε ως Hero banner",
			"deleteTitle": "Διαγραφή banner",
			"deleteBody": "Να διαγραφεί το banner «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectGroup": "Επιλέξτε ομάδα…",
			"columns": {
				"image": "Εικόνα",
				"title": "Τίτλος",
				"group": "Ομάδα",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"window": "Περίοδος"
			},
			"tabs": {
				"general": "Βασικά",
				"links": "Σύνδεσμοι",
				"content": "Κείμενο",
				"images": "Εικόνες"
			},
			"subtitle": "Υπότιτλος",
			"videoUrl": "URL βίντεο",
			"videoUrlMobile": "URL βίντεο (mobile)",
			"color": "Χρώμα",
			"colorHelp": "Χρώμα φόντου/τόνου του banner.",
			"linksSubtitle": "Έως 4 σύνδεσμοι call-to-action.",
			"ctaN": "Σύνδεσμος {{n}}",
			"ctaText": "Κείμενο",
			"ctaUrl": "URL",
			"ctaTarget": "Άνοιγμα",
			"targetDefault": "Προεπιλογή",
			"targetSelf": "Ίδια καρτέλα",
			"targetBlank": "Νέα καρτέλα",
			"bodyPlaceholder": "Κείμενο banner…",
			"imagesSubtitle": "Κύρια και δευτερεύουσα εικόνα (π.χ. desktop/mobile).",
			"image1": "Εικόνα 1",
			"image2": "Εικόνα 2",
			"uploadImage": "Μεταφόρτωση",
			"replaceImage": "Αντικατάσταση",
			"statusTitle": "Κατάσταση",
			"startDate": "Έναρξη",
			"endDate": "Λήξη",
			"targetingTitle": "Στόχευση",
			"targetingSubtitle": "Εμφάνιση μόνο σε επιλεγμένα προφίλ πελατών (κενό = όλοι).",
			"targetingPlaceholder": "Όλα τα προφίλ"
		},
		"menus": {
			"title": "Στοιχεία Μενού",
			"add": "Νέο στοιχείο",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Το στοιχείο δεν βρέθηκε.",
			"addChild": "Προσθήκη υπο-στοιχείου",
			"expand": "Ανάπτυξη",
			"collapse": "Σύμπτυξη",
			"highlighted": "Τονισμένο",
			"statusVisible": "Ορατό",
			"statusHidden": "Κρυφό",
			"deleteTitle": "Διαγραφή στοιχείου",
			"deleteBody": "Να διαγραφεί το «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"deleteBodyChildren": "Το «{{name}}» έχει υπο-στοιχεία. Επιλέξτε αν θα διαγραφούν μαζί ή θα διατηρηθούν (θα ανέβουν ένα επίπεδο).",
			"deleteWithChildren": "Διαγραφή με υπο-στοιχεία",
			"deleteKeepChildren": "Διατήρηση υπο-στοιχείων",
			"columns": {
				"title": "Τίτλος",
				"code": "Κωδικός",
				"url": "Σύνδεσμος",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			},
			"tabs": {
				"general": "Βασικά",
				"content": "Κείμενο",
				"images": "Εικόνες"
			},
			"erpCode": "Κωδικός ERP",
			"url": "Σύνδεσμος (URL)",
			"urlHelp": "Σχετική διαδρομή ή πλήρες URL.",
			"target": "Άνοιγμα",
			"targetDefault": "Προεπιλογή",
			"targetSelf": "Ίδια καρτέλα",
			"targetBlank": "Νέα καρτέλα",
			"contentSubtitle": "Προαιρετικό κείμενο/περιγραφή για το στοιχείο μενού.",
			"imagesSubtitle": "Προαιρετικές εικόνες με δικό τους σύνδεσμο.",
			"image1": "Εικόνα 1",
			"image2": "Εικόνα 2",
			"imageLink": "Σύνδεσμος εικόνας (URL)",
			"uploadImage": "Μεταφόρτωση",
			"replaceImage": "Αντικατάσταση",
			"statusTitle": "Κατάσταση",
			"parent": "Γονικό στοιχείο",
			"parentHelp": "Τοποθέτηση κάτω από άλλο στοιχείο.",
			"topLevel": "Πρώτο επίπεδο"
		},
		"footer": {
			"title": "Υποσέλιδο",
			"subtitle": "Οι στήλες του υποσέλιδου του καταστήματος και οι σύνδεσμοί τους.",
			"add": "Νέο στοιχείο",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Το στοιχείο δεν βρέθηκε.",
			"addChild": "Προσθήκη συνδέσμου",
			"expand": "Ανάπτυξη",
			"collapse": "Σύμπτυξη",
			"statusVisible": "Ορατό",
			"statusHidden": "Κρυφό",
			"deleteTitle": "Διαγραφή στοιχείου υποσέλιδου",
			"deleteBody": "Να διαγραφεί το «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"deleteBodyChildren": "Το «{{name}}» έχει υπο-στοιχεία. Επιλέξτε αν θα διαγραφούν μαζί ή θα διατηρηθούν (θα ανέβουν ένα επίπεδο).",
			"deleteWithChildren": "Διαγραφή με υπο-στοιχεία",
			"deleteKeepChildren": "Διατήρηση υπο-στοιχείων",
			"columns": {
				"title": "Τίτλος",
				"code": "Κωδικός",
				"url": "Σύνδεσμος",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			},
			"tabs": {
				"general": "Βασικά",
				"image": "Εικόνα"
			},
			"codeHelp": "Προαιρετικό σταθερό κλειδί για χρήση από το κατάστημα (π.χ. about_us).",
			"url": "Σύνδεσμος (URL)",
			"urlHelp": "Σχετική διαδρομή ή πλήρες URL. Σε αυτό οδηγεί και η εικόνα.",
			"target": "Άνοιγμα",
			"targetDefault": "Προεπιλογή",
			"targetSelf": "Ίδια καρτέλα",
			"targetBlank": "Νέα καρτέλα",
			"imageSubtitle": "Προαιρετική εικόνα που εμφανίζεται με το στοιχείο και οδηγεί στον σύνδεσμό του.",
			"image": "Εικόνα",
			"uploadImage": "Μεταφόρτωση",
			"replaceImage": "Αντικατάσταση",
			"statusTitle": "Κατάσταση",
			"parent": "Στήλη / γονικό στοιχείο",
			"parentHelp": "Τα στοιχεία πρώτου επιπέδου είναι οι στήλες του υποσέλιδου.",
			"topLevel": "Πρώτο επίπεδο (στήλη)"
		},
		"faqs": {
			"title": "Συχνές Ερωτήσεις",
			"add": "Νέα ομάδα",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Η ομάδα δεν βρέθηκε.",
			"statusVisible": "Ορατή",
			"statusHidden": "Κρυφή",
			"deleteTitle": "Διαγραφή ομάδας",
			"deleteBody": "Να διαγραφεί η ομάδα «{{name}}» και όλες οι ερωτήσεις της; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"title": "Τίτλος",
				"path": "Διαδρομή",
				"section": "Ενότητα",
				"count": "Ερωτήσεις",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"detailsTitle": "Στοιχεία ομάδας",
			"path": "Διαδρομή (path)",
			"pathHelp": "Προαιρετική σελίδα όπου εμφανίζεται η ομάδα.",
			"section": "Ενότητα",
			"sectionHelp": "Προαιρετική ομαδοποίηση/ενότητα.",
			"statusTitle": "Κατάσταση",
			"questionsTitle": "Ερωτήσεις",
			"questionsSubtitle": "Ερωτήσεις και απαντήσεις αυτής της ομάδας.",
			"addQuestion": "Νέα ερώτηση",
			"editQuestion": "Επεξεργασία ερώτησης",
			"questionSubtitle": "Ερώτηση και απάντηση (με μορφοποίηση).",
			"question": "Ερώτηση",
			"answer": "Απάντηση",
			"noQuestions": "Δεν υπάρχουν ερωτήσεις ακόμη.",
			"saveGroupFirst": "Αποθηκεύστε πρώτα την ομάδα για να προσθέσετε ερωτήσεις.",
			"entryCount": "{{count}} ερωτήσεις",
			"deleteQuestionTitle": "Διαγραφή ερώτησης",
			"deleteQuestionBody": "Να διαγραφεί η ερώτηση; Η ενέργεια δεν αναιρείται.",
			"pathOrSectionRequired": "Συμπληρώστε διαδρομή ή ενότητα."
		},
		"events": {
			"title": "Εκδηλώσεις",
			"add": "Νέα εκδήλωση",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Η εκδήλωση δεν βρέθηκε.",
			"statusVisible": "Ορατή",
			"statusHidden": "Κρυφή",
			"featured": "Προβεβλημένη",
			"deleteTitle": "Διαγραφή εκδήλωσης",
			"deleteBody": "Να διαγραφεί η εκδήλωση «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"title": "Τίτλος",
				"category": "Κατηγορία",
				"placed": "Τρόπος διεξαγωγής",
				"location": "Τοποθεσία",
				"interest": "Εκδήλωση ενδιαφέροντος",
				"visible": "Ορατή",
				"sort": "Σειρά"
			},
			"tabs": {
				"general": "Βασικά",
				"taxonomy": "Κατηγορίες & Tags",
				"content": "Κείμενο",
				"media": "Εικόνες",
				"dates": "Ημερομηνίες",
				"participations": "Συμμετοχές",
				"seo": "SEO"
			},
			"subtitle": "Υπότιτλος",
			"summary": "Περίληψη",
			"editor": "Συντάκτης",
			"entityUrl": "SEO Url",
			"entityUrlHelp": "Φιλικό URL για την εκδήλωση.",
			"placed": "Τρόπος διεξαγωγής",
			"location": "Τοποθεσία",
			"selectPlaceholder": "Επιλέξτε…",
			"noLocation": "Καμία",
			"noLocationsHint": "Δεν υπάρχουν διαθέσιμες τοποθεσίες. Προσθέστε τες από τις «Τοποθεσίες εκδηλώσεων».",
			"startDate": "Ημ. εμφάνισης από",
			"endDate": "Ημ. εμφάνισης έως",
			"taxonomySubtitle": "Κατηγορίες και ετικέτες της εκδήλωσης.",
			"categories": "Κατηγορίες",
			"categoriesPlaceholder": "Επιλέξτε κατηγορίες",
			"tags": "Ετικέτες (tags)",
			"tagsPlaceholder": "Επιλέξτε ετικέτες",
			"body": {
				"bd": "Κείμενο",
				"bd2": "Παρακολούθηση online",
				"bd3": "Χορηγοί"
			},
			"bodyMainSubtitle": "Το κύριο κείμενο της εκδήλωσης.",
			"mediaSubtitle": "Κύρια και δευτερεύουσα εικόνα.",
			"image1": "Εικόνα 1",
			"image2": "Εικόνα 2",
			"uploadImage": "Μεταφόρτωση",
			"replaceImage": "Αντικατάσταση",
			"seoSubtitle": "Μετα-δεδομένα και ευρετηρίαση.",
			"metaTitle": "Meta Title",
			"headerTitle": "Επικεφαλίδα (H1)",
			"metaDescription": "Meta Description",
			"metaKeywords": "Meta Keywords",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Απενεργοποίηση ευρετηρίασης (noindex)",
			"disableFollow": "Απενεργοποίηση follow (nofollow)",
			"statusTitle": "Κατάσταση",
			"showFront": "Εμφάνιση στην αρχική",
			"sort": "Σειρά",
			"interestTitle": "Εκδήλωση ενδιαφέροντος",
			"acceptInterest": "Αποδοχή εκδήλωσης ενδιαφέροντος",
			"externalFormUrl": "URL φόρμας ενδιαφέροντος",
			"datesSubtitle": "Ημερομηνίες/ώρες διεξαγωγής της εκδήλωσης.",
			"dates": {
				"add": "Προσθήκη ημερομηνίας",
				"empty": "Δεν υπάρχουν ημερομηνίες.",
				"start": "Έναρξη",
				"end": "Λήξη",
				"addTitle": "Νέα ημερομηνία",
				"editTitle": "Επεξεργασία ημερομηνίας",
				"deleteTitle": "Διαγραφή ημερομηνίας",
				"invalidRange": "Συμπληρώστε έγκυρη ημερομηνία έναρξης και λήξης."
			},
			"participationsSubtitle": "Συμμετοχές πελατών στην εκδήλωση.",
			"participationsEmpty": "Δεν υπάρχουν συμμετοχές.",
			"participations": {
				"start": "Ημ. Έναρξης",
				"end": "Ημ. Λήξης",
				"firstName": "Όνομα",
				"lastName": "Επώνυμο",
				"email": "E-mail",
				"mobile": "Κινητό"
			}
		},
		"news": {
			"title": "Νέα-Ανακοινώσεις",
			"add": "Νέο άρθρο",
			"untitled": "Χωρίς τίτλο",
			"notFound": "Το άρθρο δεν βρέθηκε.",
			"statusVisible": "Ορατό",
			"statusHidden": "Κρυφό",
			"featured": "Προβεβλημένο",
			"deleteTitle": "Διαγραφή άρθρου",
			"deleteBody": "Να διαγραφεί το άρθρο «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"title": "Τίτλος",
				"category": "Κατηγορία",
				"publishDate": "Δημοσίευση",
				"featured": "Προβολή",
				"visible": "Ορατό",
				"sort": "Σειρά"
			},
			"tabs": {
				"general": "Βασικά",
				"taxonomy": "Κατηγορίες & Tags",
				"content": "Κείμενο",
				"media": "Πολυμέσα",
				"seo": "SEO"
			},
			"subtitle": "Υπότιτλος",
			"summary": "Περίληψη",
			"editor": "Συντάκτης",
			"group": "Ομάδα άρθρων",
			"noGroup": "Καμία",
			"source": "Πηγή",
			"sourceInternal": "Εσωτερικό",
			"sourceExternal": "Εξωτερικό",
			"externalUrl": "Εξωτερικό URL",
			"entityUrl": "URL άρθρου",
			"entityUrlHelp": "Φιλικό URL για το άρθρο.",
			"minutesToRead": "Λεπτά ανάγνωσης",
			"publishDate": "Ημ. δημοσίευσης",
			"startDate": "Έναρξη",
			"endDate": "Λήξη",
			"taxonomySubtitle": "Κατηγορίες και ετικέτες του άρθρου.",
			"categories": "Κατηγορίες",
			"categoriesPlaceholder": "Επιλέξτε κατηγορίες",
			"tags": "Ετικέτες (tags)",
			"tagsPlaceholder": "Επιλέξτε ετικέτες",
			"body": {
				"bd": "Κύριο κείμενο",
				"bd2": "Κείμενο (online)",
				"bd3": "Κείμενο (χορηγοί)"
			},
			"bodyMainSubtitle": "Το κύριο σώμα του άρθρου.",
			"mediaSubtitle": "Κύρια και δευτερεύουσα εικόνα.",
			"image1": "Εικόνα 1",
			"image2": "Εικόνα 2",
			"uploadImage": "Μεταφόρτωση",
			"replaceImage": "Αντικατάσταση",
			"ctaTitle": "Κουμπί δράσης",
			"ctaSubtitle": "Προαιρετικό call-to-action.",
			"ctaText": "Κείμενο",
			"ctaUrl": "URL",
			"ctaTarget": "Άνοιγμα",
			"targetDefault": "Προεπιλογή",
			"targetSelf": "Ίδια καρτέλα",
			"targetBlank": "Νέα καρτέλα",
			"seoSubtitle": "Μετα-δεδομένα και ευρετηρίαση.",
			"metaTitle": "Meta Title",
			"headerTitle": "Επικεφαλίδα (H1)",
			"metaDescription": "Meta Description",
			"metaKeywords": "Meta Keywords",
			"canonicalUrl": "Canonical URL",
			"disableIndexation": "Απενεργοποίηση ευρετηρίασης (noindex)",
			"disableFollow": "Απενεργοποίηση follow (nofollow)",
			"statusTitle": "Κατάσταση",
			"showFront": "Εμφάνιση στην αρχική",
			"sort": "Σειρά",
			"sortFront": "Σειρά αρχικής",
			"sortFeatured": "Σειρά προβολής",
			"productsDisplayMode": "Τρόπος προβολής προϊόντων",
			"productsDisplayModeHelp": "Πώς εμφανίζονται τα συνδεδεμένα προϊόντα κάτω από το άρθρο.",
			"productsDisplayMode_0": "Κλασική",
			"productsDisplayMode_1": "Λίστα προϊόντων (PLP)",
			"visibility": "Ορατότητα",
			"visibilityHelp": "Τα κρυφά άρθρα δεν εμφανίζονται σε λίστες αλλά ανοίγουν με απευθείας σύνδεσμο· τα πρόχειρα δεν εμφανίζονται ποτέ.",
			"visibility_0": "Δημοσιευμένο",
			"visibility_1": "Πρόχειρο",
			"visibility_2": "Κρυφό",
			"bulk": {
				"selected": "{{count}} επιλεγμένα",
				"setDisplayMode": "Ορισμός τρόπου προβολής",
				"clear": "Καθαρισμός",
				"title": "Ορισμός τρόπου προβολής προϊόντων",
				"subtitle": "Εφαρμογή σε {{count}} επιλεγμένα άρθρα.",
				"apply": "Εφαρμογή σε {{count}}",
				"applied": "Ενημερώθηκαν {{count}} άρθρα",
				"selectAll": "Επιλογή όλων στη σελίδα",
				"selectRow": "Επιλογή άρθρου"
			}
		},
		"socialMedia": {
			"title": "Μέσα Κοινωνικής Δικτύωσης",
			"add": "Νέα πλατφόρμα",
			"addTitle": "Νέα πλατφόρμα κοινωνικής δικτύωσης",
			"editTitle": "Επεξεργασία πλατφόρμας",
			"formSubtitle": "Όνομα πλατφόρμας, σύνδεσμος, ορατότητα και εικόνα.",
			"deleteTitle": "Διαγραφή πλατφόρμας",
			"deleteBody": "Να διαγραφεί η πλατφόρμα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"tabs": {
				"basic": "Βασικά στοιχεία",
				"image": "Εικόνα"
			},
			"columns": {
				"platformName": "Όνομα πλατφόρμας",
				"url": "URL",
				"visible": "Ορατό",
				"showOnFooter": "Ορατό στο Footer",
				"showOnHeader": "Ορατό στο Header",
				"sort": "Σειρά",
				"image": "Εικόνα"
			}
		},
		"logo": {
			"title": "Logo",
			"add": "Νέο logo",
			"addTitle": "Νέο logo",
			"editTitle": "Επεξεργασία logo",
			"formSubtitle": "Όνομα, κωδικός, σύνδεσμος, ορατότητα και έως δύο εικόνες.",
			"deleteTitle": "Διαγραφή logo",
			"deleteBody": "Να διαγραφεί το logo «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"navigateUrl": "URL πλοήγησης",
			"tabs": {
				"basic": "Βασικά στοιχεία",
				"images": "Εικόνες"
			},
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"url": "URL",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"image": "Εικόνα"
			}
		},
		"customMessageGroups": {
			"title": "Ομάδες Προσαρμοσμένου Μηνύματος",
			"add": "Νέα ομάδα",
			"addTitle": "Νέα ομάδα μηνυμάτων",
			"editTitle": "Επεξεργασία ομάδας",
			"formSubtitle": "Όνομα, κωδικός, ορατότητα και σειρά ταξινόμησης.",
			"deleteTitle": "Διαγραφή ομάδας",
			"deleteBody": "Να διαγραφεί η ομάδα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"customMessages": {
			"title": "Προσαρμοσμένα Μηνύματα",
			"add": "Νέο μήνυμα",
			"addTitle": "Νέο προσαρμοσμένο μήνυμα",
			"editTitle": "Επεξεργασία μηνύματος",
			"formSubtitle": "Προγραμματισμός, ομάδα, περιεχόμενο και σύνδεσμοι CTA.",
			"deleteTitle": "Διαγραφή μηνύματος",
			"deleteBody": "Να διαγραφεί το μήνυμα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"noGroup": "Καμία",
			"cta": "Σύνδεσμος {{n}}",
			"tabs": {
				"basic": "Βασικά στοιχεία",
				"content": "Περιεχόμενο",
				"links": "Σύνδεσμοι"
			},
			"columns": {
				"code": "Κωδικός",
				"group": "Ομάδα",
				"color": "Χρώμα",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"navigateUrl": "URL",
				"urlTarget": "Target",
				"ctaLabel": "Ετικέτα"
			}
		},
		"pageBuilder": {
			"open": "Άνοιγμα στο Page Builder του καταστήματος",
			"summary": "Δομικά στοιχεία: {{count}}",
			"handoffFailed": "Δεν ήταν δυνατό το άνοιγμα του Page Builder",
			"entityRequired": "Το περιεχόμενο Page Builder επεξεργάζεται στο κατάστημα, που το ανοίγει μέσω της σελίδας, του προϊόντος ή της εγγραφής στην οποία ανήκει. Αυτό το περιεχόμενο δεν συνδέεται με κάποια εγγραφή, οπότε δεν μπορεί να ανοίξει από εδώ."
		},
		"customContent": {
			"title": "Δυναμικό Περιεχόμενο",
			"deleteTitle": "Διαγραφή περιεχομένου",
			"deleteBody": "Να διαγραφεί η εγγραφή περιεχομένου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"entityType": "Τύπος οντότητας",
				"entityId": "ID οντότητας",
				"published": "Δημοσιευμένο",
				"visible": "Ορατό",
				"schema": "Τύπος Περιεχομένου",
				"sort": "Σειρά"
			},
			"add": "Νέο περιεχόμενο",
			"untitled": "Χωρίς κωδικό",
			"statusPublished": "Δημοσιευμένο",
			"statusUnpublished": "Μη δημοσιευμένο",
			"generalTitle": "Γενικά",
			"dataTitle": "Περιεχόμενο",
			"dataSubtitle": "Το περιεχόμενο (data) της εγγραφής, ανάλογα με τον τύπο.",
			"dataPlaceholder": "Εισάγετε το περιεχόμενο…",
			"statusTitle": "Κατάσταση",
			"entityTitle": "Σύνδεση με οντότητα",
			"entitySubtitle": "Η εγγραφή είναι συνδεδεμένη με οντότητα και δεν διαχειρίζεται αυτόνομα.",
			"entityKey": "Κλειδί περιεχομένου",
			"codeHelp": "Μοναδικός κωδικός αναφοράς του περιεχομένου.",
			"codeEntityHelp": "Το περιεχόμενο είναι συνδεδεμένο με οντότητα και δεν έχει κωδικό.",
			"notFound": "Το δυναμικό περιεχόμενο δεν βρέθηκε.",
			"lexicalNotice": "Το περιεχόμενο Lexical αποθηκεύεται ως σειριοποιημένο JSON. Εδώ εμφανίζεται η ακατέργαστη κατάσταση — επεξεργαστείτε με προσοχή.",
			"schema": {
				"html": "Html",
				"plainText": "Απλό κείμενο",
				"markdown": "Markdown",
				"puck": "Page Builder",
				"lexical": "Lexical"
			}
		},
		"newsGroups": {
			"title": "Ομάδες άρθρων",
			"add": "Νέα ομάδα",
			"addTitle": "Νέα ομάδα άρθρων",
			"editTitle": "Επεξεργασία ομάδας",
			"formSubtitle": "Όνομα, κωδικός, ορατότητα και σειρά ταξινόμησης.",
			"deleteTitle": "Διαγραφή ομάδας",
			"deleteBody": "Να διαγραφεί η ομάδα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"videoGroups": {
			"title": "Ομάδες Video",
			"add": "Νέα ομάδα",
			"addTitle": "Νέα ομάδα video",
			"editTitle": "Επεξεργασία ομάδας",
			"formSubtitle": "Όνομα, κωδικός, ορατότητα και σειρά ταξινόμησης.",
			"deleteTitle": "Διαγραφή ομάδας",
			"deleteBody": "Να διαγραφεί η ομάδα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"notificationCategories": {
			"title": "Κατηγορίες Ειδοποιήσεων",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία ειδοποιήσεων",
			"editTitle": "Επεξεργασία κατηγορίας",
			"formSubtitle": "Όνομα, κωδικός, ορατότητα και σειρά ταξινόμησης.",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Να διαγραφεί η κατηγορία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"notifications": {
			"title": "Ειδοποιήσεις",
			"add": "Νέα ειδοποίηση",
			"addTitle": "Νέα ειδοποίηση",
			"editTitle": "Επεξεργασία ειδοποίησης",
			"formSubtitle": "Τίτλος, κατηγορία, URL προορισμού, περιεχόμενο και εικόνα.",
			"deleteTitle": "Διαγραφή ειδοποίησης",
			"deleteBody": "Να διαγραφεί η ειδοποίηση «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"noCategory": "Καμία",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"tabs": {
				"basic": "Βασικά στοιχεία",
				"content": "Περιεχόμενο",
				"image": "Εικόνα"
			},
			"columns": {
				"title": "Τίτλος",
				"code": "Κωδικός",
				"category": "Κατηγορία",
				"url": "URL",
				"image": "Εικόνα",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"newsTags": {
			"title": "Tags για Νέα-Ανακοινώσεις",
			"add": "Νέο tag",
			"addTitle": "Νέο tag άρθρων",
			"editTitle": "Επεξεργασία tag",
			"formSubtitle": "Όνομα, κωδικός, χρώμα, ορατότητα, σειρά και εμφάνιση ως tag.",
			"deleteTitle": "Διαγραφή tag",
			"deleteBody": "Να διαγραφεί το tag «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"color": "Χρώμα",
				"showAsTag": "Εμφάνιση ως tag",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"eventTags": {
			"title": "Tags εκδηλώσεων",
			"add": "Νέο tag",
			"addTitle": "Νέο tag εκδηλώσεων",
			"editTitle": "Επεξεργασία tag",
			"formSubtitle": "Όνομα, κωδικός, χρώμα, ορατότητα, σειρά και εμφάνιση ως tag.",
			"deleteTitle": "Διαγραφή tag",
			"deleteBody": "Να διαγραφεί το tag «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"color": "Χρώμα",
				"showAsTag": "Εμφάνιση ως tag",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"contactForms": {
			"title": "Φόρμες Επικοινωνίας",
			"add": "Νέα φόρμα",
			"addTitle": "Νέα φόρμα επικοινωνίας",
			"editTitle": "Επεξεργασία φόρμας",
			"formSubtitle": "Δρομολόγηση email για φόρμα επικοινωνίας του καταστήματος.",
			"deleteTitle": "Διαγραφή φόρμας",
			"deleteBody": "Να διαγραφεί η φόρμα «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"code": "Κωδικός",
				"fromName": "Όνομα αποστολέα",
				"fromEmail": "Email αποστολέα",
				"subject": "Θέμα",
				"toNames": "Ονόματα παραληπτών",
				"toEmails": "Emails παραληπτών",
				"cc": "Κοιν.",
				"body": "Περιεχόμενο",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"pushSubscriptions": {
			"title": "Εγγραφές συσκευών για push messages",
			"add": "Νέα εγγραφή",
			"addTitle": "Νέα εγγραφή συσκευής",
			"editTitle": "Επεξεργασία εγγραφής",
			"formSubtitle": "Καταχωρημένη συσκευή για push μηνύματα.",
			"deleteTitle": "Διαγραφή εγγραφής",
			"deleteBody": "Να διαγραφεί αυτή η εγγραφή; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"deviceToken": "Token συσκευής",
				"deviceType": "Τύπος συσκευής",
				"entityType": "Τύπος οντότητας",
				"entityId": "ID οντότητας",
				"environment": "Περιβάλλον",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"fileManager": {
			"title": "File Manager",
			"root": "Αρχικός",
			"newFolder": "Νέος φάκελος",
			"newFolderPrompt": "Όνομα φακέλου",
			"upload": "Μεταφόρτωση",
			"uploading": "Μεταφόρτωση…",
			"uploaded": "Το αρχείο μεταφορτώθηκε",
			"uploadRejected": "Μη υποστηριζόμενος τύπος αρχείου. Επιτρέπονται: εικόνες, ZIP, XML, DOC, DOCX, XLS, XLSX, CSV, TXT, PDF.",
			"copyLink": "Αντιγραφή συνδέσμου",
			"linkCopied": "Ο σύνδεσμος αντιγράφηκε",
			"copyFailed": "Δεν ήταν δυνατή η αντιγραφή του συνδέσμου.",
			"preview": "Προεπισκόπηση",
			"image": "Εικόνα",
			"file": "Αρχείο",
			"noPreview": "Δεν υπάρχει διαθέσιμη προεπισκόπηση για αυτόν τον τύπο αρχείου.",
			"openInNewTab": "Άνοιγμα σε νέα καρτέλα",
			"download": "Λήψη",
			"rename": "Μετονομασία",
			"renamePrompt": "Νέο όνομα",
			"deleteTitle": "Διαγραφή στοιχείου",
			"deleteBody": "Να διαγραφεί το «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"errorLoad": "Αποτυχία φόρτωσης αρχείων.",
			"empty": "Ο φάκελος είναι κενός."
		},
		"newsCategories": {
			"title": "Κατηγορίες για Νέα-Ανακοινώσεις",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία νέων",
			"editTitle": "Επεξεργασία κατηγορίας",
			"formSubtitle": "Τίτλος, κωδικός, ορατότητα και SEO μεταδεδομένα.",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Να διαγραφεί η κατηγορία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"tabs": {
				"basic": "Βασικά στοιχεία",
				"seo": "SEO"
			},
			"columns": {
				"title": "Τίτλος",
				"code": "Κωδικός",
				"sort": "Σειρά",
				"erpCode": "Κωδικός ERP",
				"visible": "Ορατό",
				"showFront": "Εμφάνιση στην αρχική",
				"entityUrl": "URL slug",
				"canonicalUrl": "Canonical URL",
				"h1": "Επικεφαλίδα H1",
				"metaTitle": "Meta τίτλος",
				"metaKeywords": "Meta λέξεις-κλειδιά",
				"metaDescription": "Meta περιγραφή",
				"disableIndexation": "Απενεργοποίηση indexation",
				"disableFollow": "Απενεργοποίηση follow",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"eventCategories": {
			"title": "Κατηγορίες Εκδηλώσεων",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία εκδηλώσεων",
			"editTitle": "Επεξεργασία κατηγορίας",
			"formSubtitle": "Τίτλος, υπότιτλος, κωδικός, URL slug, ορατότητα και σειρά.",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Να διαγραφεί η κατηγορία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"title": "Τίτλος",
				"subtitle": "Υπότιτλος",
				"code": "Κωδικός",
				"entityUrl": "URL slug",
				"erpCode": "Κωδικός ERP",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"eventLocations": {
			"title": "Τοποθεσίες εκδηλώσεων",
			"add": "Νέα τοποθεσία",
			"addTitle": "Νέα τοποθεσία εκδήλωσης",
			"editTitle": "Επεξεργασία τοποθεσίας",
			"formSubtitle": "Χώρος, διεύθυνση, χώρα/περιφέρεια και συντεταγμένες.",
			"deleteTitle": "Διαγραφή τοποθεσίας",
			"deleteBody": "Να διαγραφεί η τοποθεσία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"none": "Καμία",
			"columns": {
				"name": "Όνομα",
				"url": "URL",
				"address1": "Διεύθυνση 1",
				"address2": "Διεύθυνση 2",
				"area": "Περιοχή",
				"city": "Πόλη",
				"postalCode": "Τ.Κ.",
				"country": "Χώρα",
				"region": "Περιφέρεια",
				"lat": "Γεωγρ. πλάτος",
				"lng": "Γεωγρ. μήκος",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"videoCategories": {
			"title": "Κατηγορίες Video",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία video",
			"editTitle": "Επεξεργασία κατηγορίας",
			"formSubtitle": "Τίτλος, URL slug, ορατότητα και σειρά.",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Να διαγραφεί η κατηγορία «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"title": "Τίτλος",
				"entityUrl": "URL slug",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		},
		"videos": {
			"title": "Video",
			"add": "Νέο βίντεο",
			"addTitle": "Νέο βίντεο",
			"editTitle": "Επεξεργασία βίντεο",
			"formSubtitle": "Τίτλος, ομάδα, URL πηγής, περιεχόμενο και εικόνες.",
			"deleteTitle": "Διαγραφή βίντεο",
			"deleteBody": "Να διαγραφεί το βίντεο «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"selectGroup": "Επιλέξτε ομάδα",
			"uploadImage": "Μεταφόρτωση εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"tabs": {
				"basic": "Βασικά στοιχεία",
				"content": "Περιεχόμενο",
				"images": "Εικόνες"
			},
			"columns": {
				"title": "Τίτλος",
				"group": "Ομάδα",
				"videoUrl": "URL βίντεο",
				"duration": "Διάρκεια",
				"entityUrl": "URL slug",
				"image": "Εικόνα",
				"showFront": "Εμφάνιση στην αρχική",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"startDate": "Ημ/νία έναρξης",
				"endDate": "Ημ/νία λήξης"
			}
		}
	},
	"contributors": {
		"categories": {
			"title": "Κατηγορίες συντελεστών",
			"add": "Νέα κατηγορία",
			"addTitle": "Νέα κατηγορία συντελεστή",
			"editTitle": "Επεξεργασία κατηγορίας συντελεστή",
			"formSubtitle": "Όνομα, κωδικός, χρώμα και ορατότητα της κατηγορίας.",
			"deleteTitle": "Διαγραφή κατηγορίας",
			"deleteBody": "Διαγραφή κατηγορίας «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"color": "Χρώμα Ομάδας",
				"assignToProduct": "Ανάθεση σε προϊόν",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"groups": {
			"title": "Ομάδες συντελεστών",
			"add": "Νέα ομάδα",
			"addTitle": "Νέα ομάδα συντελεστών",
			"editTitle": "Επεξεργασία ομάδας συντελεστών",
			"formSubtitle": "Όνομα, κωδικός, περιγραφή και ορατότητα της ομάδας.",
			"deleteTitle": "Διαγραφή ομάδας",
			"deleteBody": "Διαγραφή ομάδας «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"columns": {
				"name": "Όνομα",
				"code": "Κωδικός",
				"description": "Περιγραφή",
				"visible": "Ορατό",
				"sort": "Σειρά"
			}
		},
		"list": {
			"title": "Συντελεστές",
			"subtitle": "{{count}} συντελεστές",
			"add": "Νέος συντελεστής",
			"addTitle": "Νέος συντελεστής",
			"editTitle": "Επεξεργασία συντελεστή",
			"formSubtitle": "Βασικά στοιχεία, εικόνες και SEO του συντελεστή.",
			"searchPlaceholder": "Αναζήτηση με όνομα ή επώνυμο…",
			"pageInfo": "Σελίδα {{page}} / {{pages}} · {{total}} σύνολο",
			"deleteTitle": "Διαγραφή συντελεστή",
			"deleteBody": "Διαγραφή συντελεστή «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"filters": {
				"toggle": "Πρόσθετα φίλτρα",
				"name": "Αναζήτηση βάσει ονόματος/επωνύμου",
				"categories": "Κατηγορίες",
				"pendingReview": "Εκκρεμείς κριτικές",
				"award": "Βραβευμένος",
				"erp": "Κωδικός ERP",
				"all": "Όλα",
				"yes": "Ναι",
				"apply": "Εφαρμογή",
				"clear": "Καθαρισμός"
			},
			"columns": {
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"country": "Χώρα",
				"categories": "Κατηγορίες",
				"reviews": "Κριτικές",
				"awards": "Βραβεία",
				"visible": "Ορατό",
				"erp": "Κωδικός ERP"
			},
			"tabs": {
				"basic": "Βασικά Στοιχεία",
				"images": "Εικόνες",
				"seo": "SEO"
			},
			"fields": {
				"name": "Όνομα",
				"surname": "Επώνυμο",
				"country": "Χώρα",
				"dob": "Ημ/νία Γέννησης",
				"sort": "Σειρά",
				"visible": "Ορατό",
				"frontExclusion": "Front Exclusion",
				"groups": "Ομάδες συντελεστών",
				"erp": "Κωδικός ERP",
				"seoUrl": "SEO URL",
				"landingUrl": "Landing URL"
			},
			"images": {
				"slot": "Εικόνα {{n}}",
				"upload": "Μεταφόρτωση εικόνας",
				"replace": "Αντικατάσταση εικόνας",
				"remove": "Αφαίρεση εικόνας",
				"saveFirst": "Αποθηκεύστε τον συντελεστή πριν τη μεταφόρτωση εικόνων."
			},
			"actions": {
				"categories": "Κατηγορίες",
				"reviews": "Κριτικές",
				"awards": "Βραβεία"
			},
			"subviews": {
				"categoryMap": {
					"title": "Κατηγορίες συντελεστή",
					"add": "Νέα ανάθεση",
					"category": "Κατηγορία",
					"summary": "Περίληψη",
					"bio": "Βιογραφικό",
					"jobTitle": "Τίτλος Εργασίας",
					"email": "E-mail",
					"tel": "Τηλέφωνο",
					"mobile": "Κινητό",
					"website": "Website",
					"featured": "Featured",
					"visible": "Ορατό",
					"sort": "Σειρά"
				},
				"reviews": {
					"title": "Κριτικές",
					"add": "Νέα κριτική",
					"productId": "ID Προϊόντος",
					"target": "Αξιολογούμενο",
					"reviewTitle": "Τίτλος",
					"reviewer": "Κριτικός",
					"source": "Πηγή",
					"review": "Κριτική",
					"rating": "Βαθμολογία",
					"status": "Κατάσταση",
					"reviewDate": "Ημ. Κριτικής",
					"featured": "Featured",
					"visible": "Ορατό",
					"statusPending": "Εκκρεμεί",
					"statusAccepted": "Εγκεκριμένη",
					"statusDeclined": "Απορρίφθηκε"
				},
				"awards": {
					"title": "Βραβεία",
					"add": "Νέο βραβείο",
					"name": "Όνομα",
					"description": "Περιγραφή",
					"location": "Τοποθεσία",
					"date": "Ημερομηνία",
					"visible": "Ορατό",
					"sort": "Σειρά"
				}
			}
		}
	},
	"importExport": {
		"import": {
			"title": "Εισαγωγή δεδομένων",
			"subtitle": "Μεταφορτώστε ένα αρχείο .xlsx για μαζική εισαγωγή ή αφαίρεση δεδομένων.",
			"modeTitle": "Λειτουργία εισαγωγής",
			"modeHelp": "Επιλέξτε αν το αρχείο θα προσθέσει ή θα αφαιρέσει τις εγγραφές που περιέχει.",
			"modeAdd": "Προσθήκη",
			"modeRemove": "Αφαίρεση",
			"removeWarning": "Στη λειτουργία αφαίρεσης, οι εγγραφές που περιέχονται στο αρχείο θα διαγραφούν. Η ενέργεια δεν αναιρείται.",
			"templatesTitle": "Πρότυπα αρχεία",
			"templatesHelp": "Κατεβάστε ένα κενό πρότυπο .xlsx με τις σωστές στήλες για κάθε τύπο εισαγωγής.",
			"downloadTemplate": "Λήψη προτύπου",
			"templateColumns": "Στήλες",
			"uploadTitle": "Μεταφόρτωση αρχείου",
			"uploadHelp": "Επιλέξτε ένα αρχείο .xlsx και πατήστε Μεταφόρτωση.",
			"chooseFile": "Επιλογή αρχείου",
			"noFile": "Δεν έχει επιλεγεί αρχείο",
			"upload": "Μεταφόρτωση",
			"uploadDone": "Η μεταφόρτωση ολοκληρώθηκε",
			"allowedExtensions": "Επιτρεπόμενες επεκτάσεις: .xlsx",
			"recentTitle": "Πρόσφατες εισαγωγές",
			"recentHelp": "Αποτελέσματα των πρόσφατων μεταφορτώσεων εισαγωγής.",
			"recentEmpty": "Δεν υπάρχουν πρόσφατες εισαγωγές.",
			"completed": "Ολοκληρώθηκε",
			"failed": "Απέτυχε",
			"removeConfirm": "Είστε βέβαιοι ότι θέλετε να αφαιρέσετε τις εγγραφές που περιέχονται στο αρχείο;",
			"confirmRemoveCta": "Αφαίρεση",
			"errorsTitle": "Σφάλματα εισαγωγής",
			"errorsCount": "σφάλματα",
			"noErrors": "Δεν βρέθηκαν σφάλματα.",
			"entityTitle": "Τύπος δεδομένων",
			"entityHelp": "Επιλέξτε τι περιέχει το αρχείο: προϊόντα (φύλλα δεδομένων προϊόντων) ή πελάτες (φύλλα Customers / Addresses).",
			"entityProducts": "Προϊόντα",
			"entityCustomers": "Πελάτες"
		},
		"export": {
			"title": "Εξαγωγή δεδομένων",
			"subtitle": "Επιλέξτε πίνακα, εφαρμόστε φίλτρα και κατεβάστε τα δεδομένα σε αρχείο .xlsx.",
			"step1Title": "Επιλέξτε τον πίνακα που θέλετε να εξάγετε",
			"step1Help": "Κάθε φορά που αλλάζετε τον πίνακα, στα επόμενα βήματα εμφανίζονται διαφορετικές επιλογές.",
			"entityLabel": "Πίνακας",
			"entityNone": "—",
			"entityProducts": "Προϊόντα",
			"entityCustomers": "Πελάτες",
			"entityOrders": "Παραγγελίες",
			"step2Title": "Επιλέξτε τα φίλτρα που θέλετε να εφαρμοστούν",
			"step2Help": "Τα φίλτρα περιορίζουν τα δεδομένα που εξάγονται. Εφαρμόστε μόνο τα φίλτρα που σας ενδιαφέρουν για ταχύτερη εξαγωγή.",
			"step3Title": "Επιλέξτε τι θα εξαχθεί",
			"step3Help": "Κάθε επιλογή εμφανίζεται σε διαφορετικό φύλλο (sheet) στο αρχείο Excel.",
			"exportCta": "Εξαγωγή",
			"clearFilters": "Καθαρισμός φίλτρων",
			"exportDone": "Η εξαγωγή ξεκίνησε",
			"selectEntityFirst": "Παρακαλώ επιλέξτε πίνακα",
			"selectSomething": "Παρακαλώ επιλέξτε τι θα εξαχθεί",
			"activeCount_zero": "Δεν έχουν επιλεγεί φίλτρα",
			"activeCount_one": "1 φίλτρο έχει επιλεγεί",
			"activeCount_other": "{{count}} φίλτρα έχουν επιλεγεί",
			"filters": {
				"search": "Αναζήτηση με όνομα ή κωδικό",
				"hasImage": "Με φωτογραφία",
				"statuses": "Καταστάσεις",
				"isVisible": "Είναι ορατό",
				"subTypes": "Υπο-τύπος",
				"priceFrom": "Ποσό από",
				"priceTo": "Ποσό έως",
				"categories": "Κατηγορίες",
				"manufacturers": "Κατασκευαστές",
				"createdFrom": "Ημ. εγγραφής από",
				"createdTo": "Ημ. εγγραφής έως",
				"orderSearch": "Κωδικός παραγγελίας, Όνομα, Επώνυμο, Email, Κινητό, Κωδικός συναλλαγής",
				"searchProductCode": "Αναζήτηση με κωδικό προϊόντος",
				"searchGiftCard": "Αναζήτηση με δωροκάρτα",
				"searchCoupon": "Αναζήτηση με κουπόνι",
				"amountFrom": "Ποσό από",
				"amountTo": "Ποσό έως",
				"isPaid": "Έχει πληρωθεί",
				"hasEdited": "Έχει επεξεργαστεί",
				"containsPromotion": "Περιέχει πολιτική προσφορών",
				"containsCoupon": "Περιέχει κουπόνια",
				"containsGiftCard": "Περιέχει δωροκάρτα",
				"containsLoyalty": "Περιέχει πόντους επιβράβευσης",
				"isDraft": "Πρόχειρη",
				"isGuest": "Επισκέπτης / Συνδεδεμένος",
				"searchProductName": "Αναζήτηση με όνομα προϊόντος",
				"searchManufacturerName": "Αναζήτηση με όνομα κατασκευαστή",
				"countries": "Χώρες",
				"orderStatuses": "Καταστάσεις παραγγελίας",
				"paymentTypes": "Τρόποι πληρωμής",
				"shippingTypes": "Τρόποι αποστολής",
				"methodOfPurchase": "Τρόπος αγοράς",
				"takeAwayStores": "Καταστήματα παραλαβής",
				"availabilityStatus": "Κατάσταση διαθεσιμότητας",
				"quantityFrom": "Ποσότητα από",
				"quantityTo": "Ποσότητα έως",
				"purchaseFrom": "Ημ. αγοράς από",
				"purchaseTo": "Ημ. αγοράς έως",
				"customerSearch": "Αναζήτηση με όνομα, email, κωδικό, κινητό ή ΑΦΜ",
				"isActive": "Ενεργός",
				"isConfirmed": "Επιβεβαιωμένος",
				"receiveNewsletters": "Newsletter",
				"hasOrders": "Έχει παραγγελίες",
				"customerCategories": "Κατηγορίες πελάτη",
				"customerTiers": "Tier",
				"genders": "Φύλο",
				"addressCountries": "Χώρα (διεύθυνσης)",
				"registeredFrom": "Ημ. εγγραφής από",
				"registeredTo": "Ημ. εγγραφής έως"
			},
			"triState": {
				"all": "Όλα",
				"yes": "Ναι",
				"no": "Όχι",
				"guest": "Επισκέπτης",
				"logged": "Συνδεδεμένος"
			},
			"selections": {
				"products": "Προϊόν",
				"categories": "Κατηγορίες",
				"attributes": "Τεχνικά χαρακτηριστικά",
				"statuses": "Καταστάσεις",
				"prices": "Τιμές",
				"dimensions": "Διαστάσεις",
				"seoUrl": "SEO URL",
				"translations": "Μεταφράσεις",
				"variantPages": "Σελίδες παραλλαγών",
				"orders": "Παραγγελίες",
				"orderLines": "Παραγγελίες με προϊόντα (Template 1)",
				"customers": "Πελάτες",
				"addresses": "Διευθύνσεις"
			},
			"customersImportNote": "Κάθε επιλογή εμφανίζεται σε διαφορετικό sheet (Customers, Addresses). Το ίδιο αρχείο μπορεί να γίνει import: οι πελάτες αναγνωρίζονται από το email και οι διευθύνσεις από email + τίτλο. Το import δεν διαγράφει ποτέ πελάτες ή διευθύνσεις."
		}
	},
	"modules": {
		"contests": {
			"title": "Διαγωνισμοί",
			"add": "Νέος Διαγωνισμός",
			"addTitle": "Νέος Διαγωνισμός",
			"editTitle": "Επεξεργασία Διαγωνισμού",
			"formSubtitle": "Στοιχεία διαγωνισμού, κείμενα και λίστες συμμετοχής.",
			"deleteTitle": "Διαγραφή διαγωνισμού",
			"deleteBody": "Διαγραφή του διαγωνισμού «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"tabs": {
				"basic": "Βασικά Στοιχεία",
				"body1": "Κείμενο (1)",
				"body2": "Κείμενο (2)",
				"more": "Περισσότερα"
			},
			"fields": {
				"name": "Όνομα",
				"product": "Προϊόν",
				"startDate": "Ημ. Έναρξης",
				"endDate": "Ημ. Λήξης",
				"fee": "Ποσό συμμετοχής",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"body1": "Κείμενο (1)",
				"body2": "Κείμενο (2)",
				"proponents": "Εισηγητές",
				"blacklist": "Μαύρη λίστα"
			},
			"actions": {
				"draw": "Κλήρωση",
				"participations": "Συμμετοχές",
				"winners": "Νικητές",
				"payments": "Πληρωμές"
			},
			"draw": {
				"title": "Κλήρωση:",
				"subtitle": "Εκτέλεση κλήρωσης και παρακολούθηση προόδου.",
				"state": "Κατάσταση",
				"running": "Σε εξέλιξη",
				"completed": "Ολοκληρώθηκε",
				"notRun": "Δεν έχει εκτελεστεί",
				"winnersCount": "Πλήθος νικητών",
				"start": "Έναρξη κλήρωσης",
				"started": "Η κλήρωση ξεκίνησε",
				"winners": "Νικητές",
				"failures": "Αποτυχίες",
				"progress": "Πρόοδος",
				"inProgress": "Σε εξέλιξη…",
				"participations": "Συμμετοχές",
				"proponents": "Εισηγητές",
				"oldParticipations": "Παλαιές συμμετοχές",
				"oldWinners": "Παλαιοί νικητές"
			},
			"part": {
				"code": "Κωδικός",
				"barcode": "Barcode",
				"purchaseDate": "Ημ. Αγοράς",
				"email": "E-mail",
				"name": "Όνομα",
				"surname": "Επώνυμο"
			},
			"win": {
				"paid": "Πληρώθηκε",
				"synced": "Συγχρονισμένο"
			},
			"pay": {
				"winner": "Νικητής",
				"paymentType": "Τρόπος πληρωμής",
				"success": "Επιτυχία",
				"transactionId": "ID συναλλαγής",
				"transactionStatus": "Κατάσταση συναλλαγής",
				"updateDate": "Ημ. Ενημέρωσης"
			}
		},
		"productTabs": {
			"title": "Product Tabs",
			"add": "Νέο Tab",
			"addTitle": "Νέο Tab Προϊόντων",
			"editTitle": "Επεξεργασία Tab",
			"formSubtitle": "Στοιχεία tab, κείμενο και εικόνες.",
			"deleteTitle": "Διαγραφή tab",
			"deleteBody": "Διαγραφή του tab «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"tabs": {
				"basic": "Βασικά Στοιχεία",
				"body": "Κείμενο"
			},
			"fields": {
				"title": "Τίτλος",
				"code": "Κωδικός",
				"navigateUrl": "URL πλοήγησης",
				"urlTarget": "Target URL",
				"rtl": "Δεξιά προς αριστερά",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"color": "Χρώμα",
				"image1": "Εικόνα 1",
				"image2": "Εικόνα 2"
			},
			"entry": {
				"listTitle": "Στοιχεία Tab",
				"add": "Νέο Στοιχείο",
				"addTitle": "Νέο Στοιχείο",
				"editTitle": "Επεξεργασία Στοιχείου",
				"subtitle": "Στοιχείο tab προϊόντων.",
				"deleteTitle": "Διαγραφή στοιχείου",
				"deleteBody": "Διαγραφή του στοιχείου; Η ενέργεια δεν αναιρείται.",
				"name": "Όνομα",
				"code": "Κωδικός",
				"navigateUrl": "URL πλοήγησης",
				"urlTarget": "Target URL",
				"mode": "Λειτουργία",
				"status": "Κατάσταση",
				"category": "Κατηγορία",
				"visible": "Ορατό",
				"sort": "Σειρά",
				"products": "Προϊόντα",
				"productsSaveFirst": "Αποθηκεύστε πρώτα το στοιχείο για να διαχειριστείτε προϊόντα."
			}
		}
	},
	"bookings": {
		"list": {
			"title": "Κρατήσεις",
			"add": "Νέα κράτηση",
			"export": "Εξαγωγή Excel",
			"exported": "Η εξαγωγή ολοκληρώθηκε",
			"searchPlaceholder": "Αναζήτηση ονόματος, email, τηλεφώνου, κωδικού, τύπου…",
			"loadError": "Δεν ήταν δυνατή η φόρτωση των κρατήσεων.",
			"deleted": "Η κράτηση διαγράφηκε",
			"deleteTitle": "Διαγραφή κράτησης",
			"deleteBody": "Να διαγραφεί η κράτηση {{code}}; Η ενέργεια δεν μπορεί να αναιρεθεί.",
			"deleteOnlyCancelled": "Διαγράφονται μόνο ακυρωμένες κρατήσεις",
			"copyCode": "Κλικ για αντιγραφή",
			"codeCopied": "Ο κωδικός αντιγράφηκε",
			"noCode": "Χωρίς κωδικό",
			"filters": {
				"status": "Κατάσταση",
				"anyStatus": "Όλες οι καταστάσεις",
				"bookingType": "Τύπος κράτησης",
				"anyType": "Όλοι οι τύποι κράτησης",
				"store": "Σημείο παραλαβής",
				"anyStore": "Όλα τα σημεία παραλαβής",
				"anyCustomer": "Όλοι οι πελάτες",
				"fromDate": "Από ημερομηνία",
				"toDate": "Έως ημερομηνία",
				"clear": "Καθαρισμός φίλτρων"
			},
			"columns": {
				"code": "Κωδικός",
				"customer": "Πελάτης",
				"bookingType": "Τύπος κράτησης",
				"store": "Σημείο παραλαβής",
				"status": "Κατάσταση",
				"when": "Ημερομηνία & ώρα",
				"representatives": "Εκπρόσωποι",
				"created": "Δημιουργία"
			},
			"actions": {
				"preview": "Προεπισκόπηση",
				"confirm": "Επιβεβαίωση",
				"cancel": "Ακύρωση κράτησης",
				"complete": "Ολοκλήρωση"
			},
			"confirmAction": {
				"confirm": {
					"title": "Επιβεβαίωση κράτησης",
					"body": "Να επιβεβαιωθεί η κράτηση {{code}}; Ο πελάτης θα ειδοποιηθεί."
				},
				"cancel": {
					"title": "Ακύρωση κράτησης",
					"body": "Να ακυρωθεί η κράτηση {{code}}; Ο πελάτης θα ειδοποιηθεί."
				},
				"complete": {
					"title": "Ολοκλήρωση κράτησης",
					"body": "Να σημειωθεί η κράτηση {{code}} ως ολοκληρωμένη;"
				}
			},
			"statusChanged": {
				"confirm": "Η κράτηση επιβεβαιώθηκε",
				"cancel": "Η κράτηση ακυρώθηκε",
				"complete": "Η κράτηση ολοκληρώθηκε"
			},
			"preview": {
				"title": "Κράτηση {{code}}",
				"subtitle": "Στοιχεία κράτησης",
				"customer": "Πελάτης",
				"name": "Όνομα",
				"email": "Email",
				"phone": "Τηλέφωνο",
				"booking": "Κράτηση",
				"code": "Κωδικός",
				"status": "Κατάσταση",
				"date": "Ημερομηνία",
				"time": "Ώρα",
				"store": "Σημείο παραλαβής",
				"created": "Δημιουργήθηκε",
				"type": "Τύπος κράτησης",
				"typeTitle": "Τίτλος",
				"kind": "Είδος",
				"link": "Σύνδεσμος",
				"open": "Άνοιγμα",
				"representatives": "Εκπρόσωποι",
				"noRepresentatives": "Δεν έχουν οριστεί εκπρόσωποι",
				"saveNotes": "Αποθήκευση σημειώσεων",
				"notesSaved": "Οι σημειώσεις αποθηκεύτηκαν",
				"adminNotes": "Σημειώσεις διαχειριστή"
			}
		},
		"types": {
			"title": "Τύποι Κρατήσεων",
			"add": "Νέος τύπος κράτησης",
			"untitled": "Τύπος κράτησης χωρίς τίτλο",
			"notFound": "Ο τύπος κράτησης δεν βρέθηκε.",
			"saved": "Ο τύπος κράτησης αποθηκεύτηκε",
			"closingBody_one": "{{count}} επερχόμενη κράτηση μένει εκτός της νέας περιόδου κρατήσεων. Η αποθήκευση την ακυρώνει και ενημερώνει τον πελάτη.",
			"closingBody_other": "{{count}} επερχόμενες κρατήσεις μένουν εκτός της νέας περιόδου κρατήσεων. Η αποθήκευση τις ακυρώνει και ενημερώνει τους πελάτες.",
			"deleted": "Ο τύπος κράτησης διαγράφηκε",
			"deleteTitle": "Διαγραφή τύπου κράτησης",
			"deleteBody": "Διαγραφή του τύπου κράτησης «{{name}}»; Ένας τύπος που έχει ακόμη κρατήσεις, διαθεσιμότητες ή εξαιρέσεις δεν μπορεί να διαγραφεί.",
			"statusVisible": "Ορατός",
			"statusHidden": "Κρυφός",
			"statusTitle": "Κατάσταση",
			"scheduleTitle": "Πρόγραμμα",
			"languageTitle": "Γλώσσα",
			"languageBody": "Η ετικέτα, η σύντομη/αναλυτική περιγραφή, το κυρίως κείμενο και το κείμενο email αποθηκεύονται για την τρέχουσα γλώσσα του περιβάλλοντος ({{lang}}). Αλλάξτε τη γλώσσα του περιβάλλοντος για να επεξεργαστείτε άλλη μετάφραση.",
			"frontLabelHelp": "Ετικέτα που βλέπουν οι πελάτες στο κατάστημα (αποθηκεύεται για την τρέχουσα γλώσσα).",
			"bodyHelp": "Πλούσιο περιεχόμενο της σελίδας κράτησης (αποθηκεύεται για την τρέχουσα γλώσσα).",
			"bodyPlaceholder": "Περιεχόμενο σελίδας κράτησης…",
			"emailDescriptionHelp": "Κείμενο που περιλαμβάνεται στα email κρατήσεων (αποθηκεύεται για την τρέχουσα γλώσσα).",
			"emailDescriptionPlaceholder": "Κείμενο email…",
			"constraintsHelp": "Περιορίστε πότε μπορεί να γίνει κράτηση. Αφήστε κενό για καμία δέσμευση.",
			"maxDaysHelp": "Κυλιόμενο διάστημα: πόσες ημέρες μπροστά μπορούν να κάνουν κράτηση οι πελάτες (1–365).",
			"limitsHelp": "Το 0 σημαίνει χωρίς όριο.",
			"storeHint": "Η επιλογή σημείου παραλαβής συμπληρώνει την τοποθεσία του· οι διαθεσιμότητες εμφανίζουν τότε μόνο τους εκπροσώπους του σημείου.",
			"storeLockedHint": "Τα πεδία τοποθεσίας ακολουθούν το επιλεγμένο σημείο παραλαβής. Καταργήστε την επιλογή για χειροκίνητη επεξεργασία.",
			"kinds": {
				"physical": "Φυσική παρουσία",
				"online": "Διαδικτυακή",
				"hybrid": "Υβριδική",
				"delivery": "Παράδοση",
				"rental": "Ενοικίαση",
				"contact": "Επικοινωνία",
				"custom": "Προσαρμοσμένη"
			},
			"tabs": {
				"general": "Γενικά",
				"content": "Περιεχόμενο",
				"constraints": "Ημερομηνίες & ώρες",
				"location": "Τοποθεσία",
				"links": "Διαδικτυακοί σύνδεσμοι",
				"limits": "Όρια κρατήσεων",
				"seo": "SEO",
				"image": "Εικόνα"
			},
			"image": "Εικόνα υπηρεσίας",
			"uploadImage": "Ανέβασμα εικόνας",
			"replaceImage": "Αντικατάσταση εικόνας",
			"imageHelp": "Εμφανίζεται στη σελίδα κράτησης του e-shop και στα ραντεβού του πελάτη.",
			"fields": {
				"title": "Τίτλος",
				"frontLabel": "Ετικέτα",
				"code": "Κωδικός",
				"kind": "Είδος",
				"shortDescription": "Σύντομη περιγραφή",
				"longDescription": "Αναλυτική περιγραφή",
				"body": "Κυρίως κείμενο",
				"emailDescription": "Κείμενο email",
				"validFromDate": "Ισχύει από (ημερομηνία)",
				"validFromTime": "Ισχύει από (ώρα)",
				"validToDate": "Ισχύει έως (ημερομηνία)",
				"validToTime": "Ισχύει έως (ώρα)",
				"maxDays": "Μέγιστες ημέρες μπροστά",
				"store": "Σημείο παραλαβής",
				"locationName": "Όνομα τοποθεσίας",
				"locationUrl": "URL τοποθεσίας",
				"address": "Διεύθυνση",
				"address2": "Διεύθυνση 2",
				"area": "Περιοχή",
				"city": "Πόλη",
				"zip": "Ταχυδρομικός κώδικας",
				"country": "Χώρα",
				"region": "Νομός",
				"latitude": "Γεωγρ. πλάτος",
				"longitude": "Γεωγρ. μήκος",
				"zoom": "Σύνδεσμος Zoom",
				"teams": "Σύνδεσμος Teams",
				"gmeet": "Σύνδεσμος Google Meet",
				"ytube": "Σύνδεσμος YouTube",
				"fb": "Σύνδεσμος Facebook",
				"insta": "Σύνδεσμος Instagram",
				"gurl": "Γενικό URL",
				"headerTitle": "Τίτλος κεφαλίδας",
				"metaTitle": "Meta τίτλος",
				"canonicalUrl": "Canonical URL",
				"visible": "Ορατός",
				"sort": "Σειρά ταξινόμησης"
			},
			"columns": {
				"bookingType": "Τύπος κράτησης",
				"store": "Σημείο παραλαβής",
				"stats": "Κρατήσεις",
				"constraints": "Περιορισμοί",
				"location": "Τοποθεσία",
				"limits": "Όρια κρατήσεων",
				"country": "Χώρα",
				"region": "Νομός",
				"created": "Δημιουργία",
				"updated": "Ενημέρωση",
				"visible": "Ορατός",
				"sort": "Σειρά"
			},
			"constraints": {
				"none": "Χωρίς περιορισμούς",
				"from": "Από {{value}}",
				"until": "Έως {{value}}",
				"daysAhead_one": "{{count}} ημέρα μπροστά",
				"daysAhead_other": "{{count}} ημέρες μπροστά"
			},
			"limits": {
				"maxb": "Μέγιστες κρατήσεις",
				"maxbu": "Μέγιστες κρατήσεις ανά πελάτη",
				"maxbud": "Μέγιστες ανά πελάτη ανά ημέρα",
				"maxbuw": "Μέγιστες ανά πελάτη ανά εβδομάδα",
				"maxbum": "Μέγιστες ανά πελάτη ανά μήνα",
				"maxbuy": "Μέγιστες ανά πελάτη ανά έτος",
				"maxbuShort": "Ανά πελάτη",
				"maxbudShort": "Ανά ημέρα",
				"maxbuwShort": "Ανά εβδομάδα",
				"maxbumShort": "Ανά μήνα",
				"maxbuyShort": "Ανά έτος"
			},
			"actions": {
				"slots": "Διαθεσιμότητες",
				"exceptions": "Εξαιρέσεις",
				"rules": "Κανόνες"
			},
			"rules": {
				"title": "Κανόνες — {{name}}",
				"subtitle": "Βαθμίδες πελατών (override) που αποθηκεύονται στους κανόνες του τύπου κράτησης. Αφήστε κενό για καμία.",
				"tiers": "Βαθμίδες πελατών",
				"tiersPlaceholder": "Επιλέξτε βαθμίδες…",
				"saved": "Οι κανόνες αποθηκεύτηκαν"
			},
			"validation": {
				"date": "Εισαγάγετε έγκυρη ημερομηνία.",
				"time": "Εισαγάγετε έγκυρη ώρα (ΩΩ:ΛΛ).",
				"dateRange": "Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης.",
				"timePair": "Ορίστε και ώρα έναρξης και ώρα λήξης, ή αφήστε και τις δύο κενές.",
				"timeRange": "Χωρίς ημερομηνίες ισχύος, η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης.",
				"maxDays": "Εισαγάγετε αριθμό ημερών από 1 έως 365.",
				"limit": "Εισαγάγετε 0 ή θετικό ακέραιο."
			}
		},
		"representatives": {
			"title": "Εκπρόσωποι",
			"add": "Νέος εκπρόσωπος",
			"addTitle": "Νέος εκπρόσωπος",
			"editTitle": "Επεξεργασία εκπροσώπου",
			"formSubtitle": "Μέλη του προσωπικού που μπορούν να ανατεθούν σε κρατήσεις.",
			"saved": "Ο εκπρόσωπος αποθηκεύτηκε",
			"deleted": "Ο εκπρόσωπος διαγράφηκε",
			"deleteTitle": "Διαγραφή εκπροσώπου",
			"deleteBody": "Διαγραφή του εκπροσώπου «{{name}}»; Η ενέργεια δεν αναιρείται.",
			"storeLockedHint": "Τα στοιχεία τοποθεσίας ακολουθούν το επιλεγμένο σημείο παραλαβής. Καταργήστε την επιλογή του για να τα επεξεργαστείτε χειροκίνητα.",
			"profile": "Προφίλ",
			"viewMap": "Προβολή χάρτη",
			"today_one": "{{count}} σήμερα",
			"today_other": "{{count}} σήμερα",
			"upcoming_one": "{{count}} επερχόμενη",
			"upcoming_other": "{{count}} επερχόμενες",
			"sections": {
				"basic": "Βασικά στοιχεία",
				"contact": "Επικοινωνία",
				"location": "Τοποθεσία",
				"display": "Εμφάνιση"
			},
			"placeholders": {
				"title": "π.χ. Δρ.",
				"position": "π.χ. Δερματολόγος"
			},
			"fields": {
				"title": "Τίτλος",
				"firstName": "Όνομα",
				"lastName": "Επώνυμο",
				"position": "Θέση",
				"gender": "Φύλο",
				"email": "E-mail",
				"phone": "Τηλέφωνο",
				"profileUrl": "URL προφίλ",
				"store": "Σημείο παραλαβής",
				"locationName": "Όνομα τοποθεσίας",
				"locationUrl": "URL τοποθεσίας",
				"address": "Διεύθυνση",
				"address2": "Διεύθυνση (γραμμή 2)",
				"area": "Περιοχή",
				"city": "Πόλη",
				"zip": "Ταχυδρομικός κώδικας",
				"country": "Χώρα",
				"region": "Νομός",
				"latitude": "Γεωγραφικό πλάτος",
				"longitude": "Γεωγραφικό μήκος",
				"visible": "Ορατός",
				"sort": "Σειρά ταξινόμησης"
			},
			"columns": {
				"representative": "Εκπρόσωπος",
				"store": "Σημείο παραλαβής",
				"stats": "Στατιστικά κρατήσεων",
				"schedule": "Πρόγραμμα",
				"position": "Θέση",
				"contact": "Επικοινωνία",
				"location": "Τοποθεσία",
				"country": "Χώρα",
				"region": "Νομός",
				"city": "Πόλη",
				"email": "E-mail",
				"created": "Δημιουργία",
				"updated": "Ενημέρωση",
				"visible": "Ορατός",
				"sort": "Σειρά"
			},
			"stats": {
				"pending": "Κρατήσεις σε αναμονή",
				"confirmed": "Επιβεβαιωμένες κρατήσεις",
				"completed": "Ολοκληρωμένες κρατήσεις",
				"cancelled": "Ακυρωμένες κρατήσεις"
			}
		},
		"reports": {
			"title": "Αναφορές Κρατήσεων",
			"empty": "Δεν υπάρχουν κρατήσεις σε αυτή την περίοδο",
			"error": "Δεν ήταν δυνατή η φόρτωση της αναφοράς",
			"filters": {
				"status": "Κατάσταση",
				"services": "Υπηρεσίες",
				"stores": "Καταστήματα",
				"hint": "Οι κρατήσεις μετρώνται βάσει ημερομηνίας ραντεβού. Το φίλτρο κατάστασης δεν εφαρμόζεται στους δείκτες και στην πληρότητα."
			},
			"kpis": {
				"total": "Σύνολο κρατήσεων",
				"confirmedRate": "Ποσοστό επιβεβαίωσης",
				"completionRate": "Ποσοστό ολοκλήρωσης",
				"cancellationRate": "Ποσοστό ακύρωσης"
			},
			"occupancy": {
				"title": "Πληρότητα",
				"byService": "Πληρότητα ανά υπηρεσία",
				"byStore": "Πληρότητα ανά κατάστημα",
				"booked": "Κρατημένες",
				"capacity": "Χωρητικότητα",
				"summary": "{{booked}} κρατημένες από {{capacity}} διαθέσιμες θέσεις (χωρίς τις ακυρωμένες κρατήσεις)"
			},
			"byService": {
				"title": "Κρατήσεις ανά υπηρεσία",
				"subtitle": "Μερίδιο κρατήσεων ανά υπηρεσία"
			},
			"byStore": {
				"title": "Κρατήσεις ανά κατάστημα",
				"subtitle": "Μερίδιο κρατήσεων ανά κατάστημα"
			},
			"trend": "Κρατήσεις ανά ημέρα",
			"analytics": {
				"title": "Αναλυτικά στοιχεία",
				"bookings": "Κρατήσεις",
				"created": "Δημιουργήθηκαν",
				"avgLeadTime": "Μέσος χρόνος προκράτησης (ημέρες)",
				"newCustomers": "Νέοι πελάτες",
				"returningCustomers": "Επαναλαμβανόμενοι πελάτες",
				"repeatRate": "Ποσοστό επανάληψης",
				"velocity": "Ρυθμός κρατήσεων",
				"velocityHint": "Πότε δημιουργήθηκαν οι κρατήσεις της περιόδου (ανά ημέρα)",
				"leadTime": "Χρόνος προκράτησης",
				"byDayOfWeek": "Κρατήσεις ανά ημέρα εβδομάδας",
				"byHour": "Κρατήσεις ανά ώρα",
				"byRepresentative": "Κρατήσεις ανά εκπρόσωπο",
				"lead": {
					"lead_same_day": "Ίδια ημέρα",
					"lead_1_3": "1–3 ημέρες",
					"lead_4_7": "4–7 ημέρες",
					"lead_8_14": "8–14 ημέρες",
					"lead_15_30": "15–30 ημέρες",
					"lead_30_plus": "30+ ημέρες"
				},
				"dow": {
					"Monday": "Δευ",
					"Tuesday": "Τρι",
					"Wednesday": "Τετ",
					"Thursday": "Πεμ",
					"Friday": "Παρ",
					"Saturday": "Σαβ",
					"Sunday": "Κυρ"
				}
			}
		},
		"noAccess": "Δεν έχετε πρόσβαση στις κρατήσεις.",
		"slots": {
			"title": "Διαθεσιμότητες — {{name}}",
			"subtitle": "Εβδομαδιαίες χρονοθυρίδες ανά ημέρα και εκπρόσωπο. Οι χρονοθυρίδες χωρίς εκπροσώπους είναι γενικές και ανοιχτές σε όλους.",
			"total_one": "{{count}} χρονοθυρίδα",
			"total_other": "{{count}} χρονοθυρίδες",
			"count_one": "{{count}} χρονοθυρίδα",
			"count_other": "{{count}} χρονοθυρίδες",
			"empty": "Δεν υπάρχουν ακόμη διαθεσιμότητες. Προσθέστε με τη χειροκίνητη ή τη μαζική δημιουργία.",
			"managedHint_one": "{{count}} χρονοθυρίδα συγκεκριμένης ημερομηνίας από εξαιρέσεις δεν εμφανίζεται· ακολουθεί την εξαίρεσή της.",
			"managedHint_other": "{{count}} χρονοθυρίδες συγκεκριμένων ημερομηνιών από εξαιρέσεις δεν εμφανίζονται· ακολουθούν τις εξαιρέσεις τους.",
			"selectAll": "Επιλογή όλων των χρονοθυρίδων",
			"select": "Επιλογή χρονοθυρίδας",
			"deleteSelected": "Διαγραφή επιλεγμένων ({{count}})",
			"generic": "Γενική (όλοι)",
			"maxBookings": "Μέγ. κρατήσεις",
			"sort": "Σειρά",
			"visible": "Ορατή",
			"revert": "Αναίρεση",
			"addTitle": "Προσθήκη διαθεσιμοτήτων",
			"manual": "Χειροκίνητα",
			"bulk": "Μαζική δημιουργία",
			"day": "Ημέρα εβδομάδας",
			"weekdays": "Ημέρες εβδομάδας",
			"startTime": "Ώρα έναρξης",
			"endTime": "Ώρα λήξης",
			"duration": "Διάρκεια χρονοθυρίδας (λεπτά)",
			"representatives": "Εκπρόσωποι",
			"optional": "προαιρετικό",
			"genericPlaceholder": "Αφήστε κενό για γενική χρονοθυρίδα",
			"genericHint": "Αν μείνει κενό, δημιουργείται γενική χρονοθυρίδα διαθέσιμη σε όλους.",
			"creatingGeneric": "Δεν επιλέχθηκε εκπρόσωπος — δημιουργείται γενική χρονοθυρίδα.",
			"generatePreview": "Προεπισκόπηση",
			"willCreate_one": "Θα δημιουργηθεί {{count}} χρονοθυρίδα",
			"willCreate_other": "Θα δημιουργηθούν {{count}} χρονοθυρίδες",
			"andMore_one": "…και {{count}} ακόμη χρονοθυρίδα",
			"andMore_other": "…και {{count}} ακόμη χρονοθυρίδες",
			"createAll": "Δημιουργία όλων ({{count}})",
			"created": "Η χρονοθυρίδα δημιουργήθηκε",
			"bulkCreated_one": "Δημιουργήθηκε {{count}} χρονοθυρίδα",
			"bulkCreated_other": "Δημιουργήθηκαν {{count}} χρονοθυρίδες",
			"updated": "Η χρονοθυρίδα ενημερώθηκε",
			"deleted_one": "Διαγράφηκε {{count}} χρονοθυρίδα",
			"deleted_other": "Διαγράφηκαν {{count}} χρονοθυρίδες",
			"confirmBulkTitle": "Δημιουργία διαθεσιμοτήτων",
			"confirmBulkBody_one": "Δημιουργία {{count}} χρονοθυρίδας;",
			"confirmBulkBody_other": "Δημιουργία {{count}} χρονοθυρίδων;",
			"confirmDeleteTitle": "Διαγραφή διαθεσιμοτήτων",
			"confirmDeleteBody_one": "Διαγραφή {{count}} επιλεγμένης χρονοθυρίδας; Η ενέργεια δεν αναιρείται.",
			"confirmDeleteBody_other": "Διαγραφή {{count}} επιλεγμένων χρονοθυρίδων; Η ενέργεια δεν αναιρείται.",
			"validation": {
				"timeOrder": "Η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης.",
				"maxBookings": "Οι μέγιστες κρατήσεις πρέπει να είναι τουλάχιστον 1."
			},
			"dayNames": {
				"monday": "Δευτέρα",
				"tuesday": "Τρίτη",
				"wednesday": "Τετάρτη",
				"thursday": "Πέμπτη",
				"friday": "Παρασκευή",
				"saturday": "Σάββατο",
				"sunday": "Κυριακή"
			},
			"daysShort": {
				"monday": "Δευ",
				"tuesday": "Τρι",
				"wednesday": "Τετ",
				"thursday": "Πεμ",
				"friday": "Παρ",
				"saturday": "Σαβ",
				"sunday": "Κυρ"
			}
		},
		"exceptions": {
			"title": "Εξαιρέσεις — {{name}}",
			"subtitle": "Ημέρες ή ώρες όπου ο τύπος κράτησης, ή κάποιος εκπρόσωπός του, δεν είναι διαθέσιμος ή έχει ειδικό ωράριο.",
			"scopes": {
				"booking": "Εξαιρέσεις τύπου κράτησης",
				"representative": "Εξαιρέσεις εκπροσώπων"
			},
			"total_one": "{{count}} εξαίρεση",
			"total_other": "{{count}} εξαιρέσεις",
			"empty": "Δεν υπάρχουν ακόμη εξαιρέσεις.",
			"selectAll": "Επιλογή όλων των εξαιρέσεων",
			"select": "Επιλογή εξαίρεσης",
			"deleteSelected": "Διαγραφή επιλεγμένων ({{count}})",
			"days_one": "{{count}} ημέρα",
			"days_other": "{{count}} ημέρες",
			"inactive": "Ανενεργή",
			"maxBookingsShort": "Μέγ. {{count}}",
			"addTitle": "Προσθήκη εξαίρεσης",
			"editTitle": "Επεξεργασία εξαίρεσης",
			"new": "Νέα",
			"editing": "Επεξεργασία: {{name}}",
			"editRestricted": "Μπορείτε να αλλάξετε τίτλο, περιγραφή, είδος, μέγιστες κρατήσεις, κατάσταση και (για ωριαίες εξαιρέσεις) τις ώρες. Η ημερομηνία και ο τρόπος δεν αλλάζουν.",
			"editRestrictedRep": "Μπορείτε να αλλάξετε τίτλο, περιγραφή, είδος, μέγιστες κρατήσεις, κατάσταση και (για ωριαίες εξαιρέσεις) τις ώρες. Η ημερομηνία, ο τρόπος και ο εκπρόσωπος δεν αλλάζουν.",
			"selectRepresentative": "Επιλέξτε εκπρόσωπο…",
			"noRepresentatives": "Μπορούν να επιλεγούν μόνο εκπρόσωποι που έχουν διαθεσιμότητες σε αυτόν τον τύπο κράτησης.",
			"endDateHint": "Αφήστε κενή την ημερομηνία λήξης για μία ημέρα· ένα διάστημα δημιουργεί μία εξαίρεση ανά ημέρα.",
			"titlePlaceholder": "Προαιρετικός τίτλος",
			"descriptionPlaceholder": "Προαιρετική περιγραφή",
			"add": "Προσθήκη εξαίρεσης",
			"update": "Ενημέρωση εξαίρεσης",
			"created": "Η εξαίρεση δημιουργήθηκε",
			"updated": "Η εξαίρεση ενημερώθηκε",
			"deleted_one": "Διαγράφηκε {{count}} εξαίρεση",
			"deleted_other": "Διαγράφηκαν {{count}} εξαιρέσεις",
			"confirmDeleteTitle": "Διαγραφή εξαιρέσεων",
			"confirmDeleteBody_one": "Διαγραφή {{count}} επιλεγμένης εξαίρεσης;",
			"confirmDeleteBody_other": "Διαγραφή {{count}} επιλεγμένων εξαιρέσεων;",
			"conflictsTitle": "Επηρεάζονται υπάρχουσες κρατήσεις",
			"conflictsBody_one": "{{count}} επερχόμενη κράτηση εμπίπτει σε αυτή την εξαίρεση. Η αποθήκευση την ακυρώνει και ενημερώνει τον πελάτη.",
			"conflictsBody_other": "{{count}} επερχόμενες κρατήσεις εμπίπτουν σε αυτή την εξαίρεση. Η αποθήκευση τις ακυρώνει και ενημερώνει τους πελάτες.",
			"cancelAndNotify": "Ακύρωση και ενημέρωση",
			"fields": {
				"representative": "Εκπρόσωπος",
				"mode": "Τρόπος εξαίρεσης",
				"startTime": "Ώρα έναρξης",
				"endTime": "Ώρα λήξης",
				"maxBookings": "Μέγιστες κρατήσεις",
				"startDate": "Ημερομηνία έναρξης",
				"endDate": "Ημερομηνία λήξης (προαιρετικά)",
				"title": "Τίτλος",
				"type": "Είδος εξαίρεσης",
				"description": "Περιγραφή",
				"active": "Ενεργή εξαίρεση"
			},
			"modes": {
				"full_day": "Ολόκληρη ημέρα",
				"available_hours": "Μόνο διαθέσιμες ώρες",
				"unavailable_hours": "Μη διαθέσιμες ώρες"
			},
			"modeHints": {
				"booking": {
					"full_day": "Μπλοκάρει ολόκληρη την ημέρα.",
					"available_hours": "Μόνο αυτές οι ώρες είναι διαθέσιμες την ημέρα αυτή.",
					"unavailable_hours": "Αυτές οι ώρες δεν είναι διαθέσιμες την ημέρα αυτή."
				},
				"representative": {
					"full_day": "Ο εκπρόσωπος δεν είναι διαθέσιμος όλη την ημέρα.",
					"available_hours": "Ο εκπρόσωπος είναι διαθέσιμος μόνο αυτές τις ώρες.",
					"unavailable_hours": "Ο εκπρόσωπος δεν είναι διαθέσιμος αυτές τις ώρες."
				}
			},
			"maxBookingsHint": {
				"booking": "Μέγιστες ταυτόχρονες κρατήσεις για αυτό το χρονικό διάστημα.",
				"representative": "Μέγιστες ταυτόχρονες κρατήσεις με αυτόν τον εκπρόσωπο για αυτό το χρονικό διάστημα."
			},
			"types": {
				"National": "Εθνική αργία",
				"Religious": "Θρησκευτική αργία",
				"Company": "Εταιρική αργία",
				"Maintenance": "Συντήρηση",
				"ScheduleChange": "Αλλαγή προγράμματος",
				"Custom": "Προσαρμοσμένη"
			},
			"validation": {
				"representative": "Επιλέξτε εκπρόσωπο.",
				"startDate": "Επιλέξτε ημερομηνία έναρξης.",
				"endDate": "Η ημερομηνία λήξης δεν μπορεί να είναι πριν από την ημερομηνία έναρξης.",
				"times": "Εισαγάγετε ώρα έναρξης και λήξης.",
				"timeOrder": "Η ώρα έναρξης πρέπει να είναι πριν από την ώρα λήξης.",
				"maxBookings": "Οι μέγιστες κρατήσεις πρέπει να είναι τουλάχιστον 1."
			}
		},
		"status": {
			"pending": "Σε αναμονή",
			"confirmed": "Επιβεβαιωμένη",
			"completed": "Ολοκληρωμένη",
			"cancelled": "Ακυρωμένη"
		},
		"create": {
			"title": "Νέα κράτηση",
			"subtitle": "Πελάτης, υπηρεσία, σημείο παραλαβής και διαθέσιμη ώρα.",
			"created": "Η κράτηση {{code}} δημιουργήθηκε",
			"steps": {
				"customer": "Πελάτης",
				"service": "Υπηρεσία",
				"slot": "Ημερομηνία & ώρα",
				"review": "Επισκόπηση"
			},
			"customer": "Πελάτης",
			"service": "Υπηρεσία",
			"selectService": "Επιλέξτε υπηρεσία…",
			"noServices": "Δεν υπάρχουν ενεργοί τύποι κράτησης.",
			"store": "Σημείο παραλαβής",
			"selectStore": "Επιλέξτε σημείο παραλαβής…",
			"noStore": "Χωρίς σημείο παραλαβής",
			"noStoresForService": "Κανένα σημείο παραλαβής δεν προσφέρει αυτή την υπηρεσία.",
			"resolvedType": "Τύπος κράτησης",
			"prevWeek": "Προηγούμενη εβδομάδα",
			"nextWeek": "Επόμενη εβδομάδα",
			"today": "Σήμερα",
			"constraints": {
				"title": "Περίοδος κρατήσεων",
				"from": "Από {{date}}",
				"to": "Έως {{date}}",
				"maxDays": "Μέχρι {{count}} ημέρες από σήμερα"
			},
			"outsideRange": "Εκτός επιτρεπόμενης περιόδου",
			"noSlots": "Χωρίς διαθέσιμες ώρες",
			"available_one": "{{count}} διαθέσιμη",
			"available_other": "{{count}} διαθέσιμες",
			"slotState": {
				"past": "Παρελθόν",
				"unavailable": "Μη διαθέσιμο",
				"blocked": "Δεν επιτρέπεται",
				"full": "Πλήρες"
			},
			"limitTitle": "Περιορισμός κράτησης",
			"userStats": "Κρατήσεις πελάτη — σήμερα: {{today}}, εβδομάδα: {{week}}, μήνας: {{month}}",
			"valid": "Έγκυρο",
			"chooseRepresentative": "Επιλέξτε εκπρόσωπο",
			"representative": "Εκπρόσωπος",
			"noRepresentative": "Χωρίς εκπρόσωπο",
			"date": "Ημερομηνία",
			"time": "Ώρα",
			"checkingConflicts": "Έλεγχος για συγκρούσεις…",
			"conflictTitle": "Ο πελάτης έχει κρατήσεις που συγκρούονται:",
			"noConflicts": "Καμία σύγκρουση με άλλες κρατήσεις του πελάτη",
			"notifyHint": "Η κράτηση δημιουργείται σε αναμονή και ο πελάτης λαμβάνει το email/SMS της κράτησης.",
			"submit": "Δημιουργία κράτησης",
			"limits": {
				"duplicate": "Ο πελάτης έχει ήδη κλείσει αυτή την ώρα",
				"overlap": "Η ώρα επικαλύπτεται με υπάρχουσα κράτηση του πελάτη",
				"daily": "Ο πελάτης έφτασε το ημερήσιο όριο κρατήσεων ({{count}})",
				"weekly": "Ο πελάτης έφτασε το εβδομαδιαίο όριο κρατήσεων ({{count}})",
				"monthly": "Ο πελάτης έφτασε το μηνιαίο όριο κρατήσεων ({{count}})",
				"yearly": "Ο πελάτης έφτασε το ετήσιο όριο κρατήσεων ({{count}})",
				"global": "Έχει συμπληρωθεί το συνολικό όριο κρατήσεων για αυτόν τον τύπο",
				"slot": "Δεν υπάρχουν διαθέσιμες θέσεις για αυτή την ώρα",
				"total": "Ο πελάτης έφτασε το όριο κρατήσεων για αυτή την υπηρεσία ({{count}})",
				"past": "Η ώρα αυτή έχει ήδη περάσει",
				"date_constraint": "Η ημερομηνία είναι εκτός των ημερομηνιών κράτησης της υπηρεσίας",
				"time_constraint": "Η ώρα είναι εκτός του ωραρίου κράτησης της υπηρεσίας",
				"invalid": "Το αίτημα κράτησης δεν είναι έγκυρο",
				"generic": "Η κράτηση δεν είναι δυνατή αυτή τη στιγμή"
			}
		},
		"validation": {
			"coordinate": "Εισαγάγετε έγκυρη συντεταγμένη.",
			"url": "Εισαγάγετε πλήρη σύνδεσμο που ξεκινά με http:// ή https://."
		},
		"lookupDenied": {
			"stores": "Η επιλογή σημείου παραλαβής απαιτεί τον ρόλο Παραγγελίες ή Έγκριση παραγγελιών.",
			"tiers": "Οι βαθμίδες πελατών απαιτούν τον ρόλο Σύστημα.",
			"customers": "Η αναζήτηση πελατών απαιτεί τον ρόλο Πελάτες."
		}
	}
}
